/* eslint-disable */
export const CommuneZimou = [
  {
    id: 1,
    name: "Adrar",
    wilaya_id: 1,
    zip_code: "1001",
    wilaya: {
      id: 1,
      name: "Adrar",
    },
  },
  {
    id: 2,
    name: "Tamest",
    wilaya_id: 1,
    zip_code: "1002",
    wilaya: {
      id: 1,
      name: "Adrar",
    },
  },
  {
    id: 3,
    name: "Charouine",
    wilaya_id: 49,
    zip_code: "1003",
    wilaya: {
      id: 49,
      name: "Timimoun",
    },
  },
  {
    id: 4,
    name: "Reggane",
    wilaya_id: 1,
    zip_code: "1004",
    wilaya: {
      id: 1,
      name: "Adrar",
    },
  },
  {
    id: 5,
    name: "In Zghmir",
    wilaya_id: 1,
    zip_code: "1005",
    wilaya: {
      id: 1,
      name: "Adrar",
    },
  },
  {
    id: 6,
    name: "Tit",
    wilaya_id: 1,
    zip_code: "1006",
    wilaya: {
      id: 1,
      name: "Adrar",
    },
  },
  {
    id: 7,
    name: "Ksar Kaddour",
    wilaya_id: 49,
    zip_code: "1007",
    wilaya: {
      id: 49,
      name: "Timimoun",
    },
  },
  {
    id: 8,
    name: "Tsabit",
    wilaya_id: 1,
    zip_code: "1008",
    wilaya: {
      id: 1,
      name: "Adrar",
    },
  },
  {
    id: 9,
    name: "Timimoun",
    wilaya_id: 49,
    zip_code: "1009",
    wilaya: {
      id: 49,
      name: "Timimoun",
    },
  },
  {
    id: 10,
    name: "Ouled Saïd",
    wilaya_id: 49,
    zip_code: "1010",
    wilaya: {
      id: 49,
      name: "Timimoun",
    },
  },
  {
    id: 11,
    name: "Zaouiet Kounta",
    wilaya_id: 1,
    zip_code: "1011",
    wilaya: {
      id: 1,
      name: "Adrar",
    },
  },
  {
    id: 12,
    name: "Aoulef",
    wilaya_id: 1,
    zip_code: "1012",
    wilaya: {
      id: 1,
      name: "Adrar",
    },
  },
  {
    id: 13,
    name: "Tamekten",
    wilaya_id: 1,
    zip_code: "1013",
    wilaya: {
      id: 1,
      name: "Adrar",
    },
  },
  {
    id: 14,
    name: "Tamantit",
    wilaya_id: 1,
    zip_code: "1014",
    wilaya: {
      id: 1,
      name: "Adrar",
    },
  },
  {
    id: 15,
    name: "Fenoughil",
    wilaya_id: 1,
    zip_code: "1015",
    wilaya: {
      id: 1,
      name: "Adrar",
    },
  },
  {
    id: 16,
    name: "Tinerkouk",
    wilaya_id: 49,
    zip_code: "1016",
    wilaya: {
      id: 49,
      name: "Timimoun",
    },
  },
  {
    id: 17,
    name: "Deldoul",
    wilaya_id: 49,
    zip_code: "1017",
    wilaya: {
      id: 49,
      name: "Timimoun",
    },
  },
  {
    id: 18,
    name: "Sali",
    wilaya_id: 1,
    zip_code: "1018",
    wilaya: {
      id: 1,
      name: "Adrar",
    },
  },
  {
    id: 19,
    name: "Akabli",
    wilaya_id: 1,
    zip_code: "1019",
    wilaya: {
      id: 1,
      name: "Adrar",
    },
  },
  {
    id: 20,
    name: "Metarfa",
    wilaya_id: 49,
    zip_code: "1020",
    wilaya: {
      id: 49,
      name: "Timimoun",
    },
  },
  {
    id: 21,
    name: "Ouled Ahmed Tammi",
    wilaya_id: 1,
    zip_code: "1021",
    wilaya: {
      id: 1,
      name: "Adrar",
    },
  },
  {
    id: 22,
    name: "Bouda",
    wilaya_id: 1,
    zip_code: "1022",
    wilaya: {
      id: 1,
      name: "Adrar",
    },
  },
  {
    id: 23,
    name: "Aougrout",
    wilaya_id: 49,
    zip_code: "1023",
    wilaya: {
      id: 49,
      name: "Timimoun",
    },
  },
  {
    id: 24,
    name: "Talmine",
    wilaya_id: 49,
    zip_code: "1024",
    wilaya: {
      id: 49,
      name: "Timimoun",
    },
  },
  {
    id: 25,
    name: "Bordj Badji Mokhtar",
    wilaya_id: 50,
    zip_code: "1025",
    wilaya: {
      id: 50,
      name: "Bordj Badji Mokhtar",
    },
  },
  {
    id: 26,
    name: "Sebaa",
    wilaya_id: 1,
    zip_code: "1026",
    wilaya: {
      id: 1,
      name: "Adrar",
    },
  },
  {
    id: 27,
    name: "Ouled Aïssa",
    wilaya_id: 49,
    zip_code: "1027",
    wilaya: {
      id: 49,
      name: "Timimoun",
    },
  },
  {
    id: 28,
    name: "Timiaouine",
    wilaya_id: 50,
    zip_code: "1028",
    wilaya: {
      id: 50,
      name: "Bordj Badji Mokhtar",
    },
  },
  {
    id: 29,
    name: "Chlef",
    wilaya_id: 2,
    zip_code: "2001",
    wilaya: {
      id: 2,
      name: "Chlef",
    },
  },
  {
    id: 30,
    name: "Ténès",
    wilaya_id: 2,
    zip_code: "2002",
    wilaya: {
      id: 2,
      name: "Chlef",
    },
  },
  {
    id: 31,
    name: "Bénairia",
    wilaya_id: 2,
    zip_code: "2003",
    wilaya: {
      id: 2,
      name: "Chlef",
    },
  },
  {
    id: 32,
    name: "El Karimia",
    wilaya_id: 2,
    zip_code: "2004",
    wilaya: {
      id: 2,
      name: "Chlef",
    },
  },
  {
    id: 33,
    name: "Tadjena",
    wilaya_id: 2,
    zip_code: "2005",
    wilaya: {
      id: 2,
      name: "Chlef",
    },
  },
  {
    id: 34,
    name: "Taougrite",
    wilaya_id: 2,
    zip_code: "2006",
    wilaya: {
      id: 2,
      name: "Chlef",
    },
  },
  {
    id: 35,
    name: "Beni Haoua",
    wilaya_id: 2,
    zip_code: "2007",
    wilaya: {
      id: 2,
      name: "Chlef",
    },
  },
  {
    id: 36,
    name: "Sobha",
    wilaya_id: 2,
    zip_code: "2008",
    wilaya: {
      id: 2,
      name: "Chlef",
    },
  },
  {
    id: 37,
    name: "Harchoun",
    wilaya_id: 2,
    zip_code: "2009",
    wilaya: {
      id: 2,
      name: "Chlef",
    },
  },
  {
    id: 38,
    name: "Ouled Fares",
    wilaya_id: 2,
    zip_code: "2010",
    wilaya: {
      id: 2,
      name: "Chlef",
    },
  },
  {
    id: 39,
    name: "Sidi Akkacha",
    wilaya_id: 2,
    zip_code: "2011",
    wilaya: {
      id: 2,
      name: "Chlef",
    },
  },
  {
    id: 40,
    name: "Boukadir",
    wilaya_id: 2,
    zip_code: "2012",
    wilaya: {
      id: 2,
      name: "Chlef",
    },
  },
  {
    id: 41,
    name: "Beni Rached",
    wilaya_id: 2,
    zip_code: "2013",
    wilaya: {
      id: 2,
      name: "Chlef",
    },
  },
  {
    id: 42,
    name: "Talassa",
    wilaya_id: 2,
    zip_code: "2014",
    wilaya: {
      id: 2,
      name: "Chlef",
    },
  },
  {
    id: 43,
    name: "Harenfa",
    wilaya_id: 2,
    zip_code: "2015",
    wilaya: {
      id: 2,
      name: "Chlef",
    },
  },
  {
    id: 44,
    name: "Oued Goussine",
    wilaya_id: 2,
    zip_code: "2016",
    wilaya: {
      id: 2,
      name: "Chlef",
    },
  },
  {
    id: 45,
    name: "Dahra",
    wilaya_id: 2,
    zip_code: "2017",
    wilaya: {
      id: 2,
      name: "Chlef",
    },
  },
  {
    id: 46,
    name: "Ouled Abbes",
    wilaya_id: 2,
    zip_code: "2018",
    wilaya: {
      id: 2,
      name: "Chlef",
    },
  },
  {
    id: 47,
    name: "Sendjas",
    wilaya_id: 2,
    zip_code: "2019",
    wilaya: {
      id: 2,
      name: "Chlef",
    },
  },
  {
    id: 48,
    name: "Zeboudja",
    wilaya_id: 2,
    zip_code: "2020",
    wilaya: {
      id: 2,
      name: "Chlef",
    },
  },
  {
    id: 49,
    name: "Oued Sly",
    wilaya_id: 2,
    zip_code: "2021",
    wilaya: {
      id: 2,
      name: "Chlef",
    },
  },
  {
    id: 50,
    name: "Abou El Hassan",
    wilaya_id: 2,
    zip_code: "2022",
    wilaya: {
      id: 2,
      name: "Chlef",
    },
  },
  {
    id: 51,
    name: "El Marsa",
    wilaya_id: 2,
    zip_code: "2023",
    wilaya: {
      id: 2,
      name: "Chlef",
    },
  },
  {
    id: 52,
    name: "Chettia",
    wilaya_id: 2,
    zip_code: "2024",
    wilaya: {
      id: 2,
      name: "Chlef",
    },
  },
  {
    id: 53,
    name: "Sidi Abderahmane",
    wilaya_id: 2,
    zip_code: "2025",
    wilaya: {
      id: 2,
      name: "Chlef",
    },
  },
  {
    id: 54,
    name: "Moussadek",
    wilaya_id: 2,
    zip_code: "2026",
    wilaya: {
      id: 2,
      name: "Chlef",
    },
  },
  {
    id: 55,
    name: "El Hadjadj",
    wilaya_id: 2,
    zip_code: "2027",
    wilaya: {
      id: 2,
      name: "Chlef",
    },
  },
  {
    id: 56,
    name: "Labiod Medjadja",
    wilaya_id: 2,
    zip_code: "2028",
    wilaya: {
      id: 2,
      name: "Chlef",
    },
  },
  {
    id: 57,
    name: "Oued Fodda",
    wilaya_id: 2,
    zip_code: "2029",
    wilaya: {
      id: 2,
      name: "Chlef",
    },
  },
  {
    id: 58,
    name: "Ouled Ben Abdelkader",
    wilaya_id: 2,
    zip_code: "2030",
    wilaya: {
      id: 2,
      name: "Chlef",
    },
  },
  {
    id: 59,
    name: "Bouzeghaia",
    wilaya_id: 2,
    zip_code: "2031",
    wilaya: {
      id: 2,
      name: "Chlef",
    },
  },
  {
    id: 60,
    name: "Aïn Merane",
    wilaya_id: 2,
    zip_code: "2032",
    wilaya: {
      id: 2,
      name: "Chlef",
    },
  },
  {
    id: 61,
    name: "Oum Drou",
    wilaya_id: 2,
    zip_code: "2033",
    wilaya: {
      id: 2,
      name: "Chlef",
    },
  },
  {
    id: 62,
    name: "Breira",
    wilaya_id: 2,
    zip_code: "2034",
    wilaya: {
      id: 2,
      name: "Chlef",
    },
  },
  {
    id: 63,
    name: "Beni Bouateb",
    wilaya_id: 2,
    zip_code: "2035",
    wilaya: {
      id: 2,
      name: "Chlef",
    },
  },
  {
    id: 64,
    name: "Laghouat",
    wilaya_id: 3,
    zip_code: "3001",
    wilaya: {
      id: 3,
      name: "Laghouat",
    },
  },
  {
    id: 65,
    name: "Ksar El Hirane",
    wilaya_id: 3,
    zip_code: "3002",
    wilaya: {
      id: 3,
      name: "Laghouat",
    },
  },
  {
    id: 66,
    name: "Bennasser Benchohra",
    wilaya_id: 3,
    zip_code: "3003",
    wilaya: {
      id: 3,
      name: "Laghouat",
    },
  },
  {
    id: 67,
    name: "Sidi Makhlouf",
    wilaya_id: 3,
    zip_code: "3004",
    wilaya: {
      id: 3,
      name: "Laghouat",
    },
  },
  {
    id: 68,
    name: "Hassi Delaa",
    wilaya_id: 3,
    zip_code: "3005",
    wilaya: {
      id: 3,
      name: "Laghouat",
    },
  },
  {
    id: 69,
    name: "Hassi R'Mel",
    wilaya_id: 3,
    zip_code: "3006",
    wilaya: {
      id: 3,
      name: "Laghouat",
    },
  },
  {
    id: 70,
    name: "Aïn Madhi",
    wilaya_id: 3,
    zip_code: "3007",
    wilaya: {
      id: 3,
      name: "Laghouat",
    },
  },
  {
    id: 71,
    name: "Tadjemout",
    wilaya_id: 3,
    zip_code: "3008",
    wilaya: {
      id: 3,
      name: "Laghouat",
    },
  },
  {
    id: 72,
    name: "Kheneg",
    wilaya_id: 3,
    zip_code: "3009",
    wilaya: {
      id: 3,
      name: "Laghouat",
    },
  },
  {
    id: 73,
    name: "Gueltat Sidi Saad",
    wilaya_id: 3,
    zip_code: "3010",
    wilaya: {
      id: 3,
      name: "Laghouat",
    },
  },
  {
    id: 74,
    name: "Aïn Sidi Ali",
    wilaya_id: 3,
    zip_code: "3011",
    wilaya: {
      id: 3,
      name: "Laghouat",
    },
  },
  {
    id: 75,
    name: "Beidha",
    wilaya_id: 3,
    zip_code: "3012",
    wilaya: {
      id: 3,
      name: "Laghouat",
    },
  },
  {
    id: 76,
    name: "Brida",
    wilaya_id: 3,
    zip_code: "3013",
    wilaya: {
      id: 3,
      name: "Laghouat",
    },
  },
  {
    id: 77,
    name: "El Ghicha",
    wilaya_id: 3,
    zip_code: "3014",
    wilaya: {
      id: 3,
      name: "Laghouat",
    },
  },
  {
    id: 78,
    name: "Hadj Mechri",
    wilaya_id: 3,
    zip_code: "3015",
    wilaya: {
      id: 3,
      name: "Laghouat",
    },
  },
  {
    id: 79,
    name: "Sebgag",
    wilaya_id: 3,
    zip_code: "3016",
    wilaya: {
      id: 3,
      name: "Laghouat",
    },
  },
  {
    id: 80,
    name: "Taouiala",
    wilaya_id: 3,
    zip_code: "3017",
    wilaya: {
      id: 3,
      name: "Laghouat",
    },
  },
  {
    id: 81,
    name: "Tadjrouna",
    wilaya_id: 3,
    zip_code: "3018",
    wilaya: {
      id: 3,
      name: "Laghouat",
    },
  },
  {
    id: 82,
    name: "Aflou",
    wilaya_id: 3,
    zip_code: "3019",
    wilaya: {
      id: 3,
      name: "Laghouat",
    },
  },
  {
    id: 83,
    name: "El Assafia",
    wilaya_id: 3,
    zip_code: "3020",
    wilaya: {
      id: 3,
      name: "Laghouat",
    },
  },
  {
    id: 84,
    name: "Oued Morra",
    wilaya_id: 3,
    zip_code: "3021",
    wilaya: {
      id: 3,
      name: "Laghouat",
    },
  },
  {
    id: 85,
    name: "Oued M'Zi",
    wilaya_id: 3,
    zip_code: "3022",
    wilaya: {
      id: 3,
      name: "Laghouat",
    },
  },
  {
    id: 86,
    name: "El Houaita",
    wilaya_id: 3,
    zip_code: "3023",
    wilaya: {
      id: 3,
      name: "Laghouat",
    },
  },
  {
    id: 87,
    name: "Sidi Bouzid",
    wilaya_id: 3,
    zip_code: "3024",
    wilaya: {
      id: 3,
      name: "Laghouat",
    },
  },
  {
    id: 88,
    name: "Oum El Bouaghi",
    wilaya_id: 4,
    zip_code: "4001",
    wilaya: {
      id: 4,
      name: "Oum El Bouaghi",
    },
  },
  {
    id: 89,
    name: "Aïn Beïda",
    wilaya_id: 4,
    zip_code: "4002",
    wilaya: {
      id: 4,
      name: "Oum El Bouaghi",
    },
  },
  {
    id: 90,
    name: "Aïn M'lila",
    wilaya_id: 4,
    zip_code: "4003",
    wilaya: {
      id: 4,
      name: "Oum El Bouaghi",
    },
  },
  {
    id: 91,
    name: "Behir Chergui",
    wilaya_id: 4,
    zip_code: "4004",
    wilaya: {
      id: 4,
      name: "Oum El Bouaghi",
    },
  },
  {
    id: 92,
    name: "El Amiria",
    wilaya_id: 4,
    zip_code: "4005",
    wilaya: {
      id: 4,
      name: "Oum El Bouaghi",
    },
  },
  {
    id: 93,
    name: "Sigus",
    wilaya_id: 4,
    zip_code: "4006",
    wilaya: {
      id: 4,
      name: "Oum El Bouaghi",
    },
  },
  {
    id: 94,
    name: "El Belala",
    wilaya_id: 4,
    zip_code: "4007",
    wilaya: {
      id: 4,
      name: "Oum El Bouaghi",
    },
  },
  {
    id: 95,
    name: "Aïn Babouche",
    wilaya_id: 4,
    zip_code: "4008",
    wilaya: {
      id: 4,
      name: "Oum El Bouaghi",
    },
  },
  {
    id: 96,
    name: "Berriche",
    wilaya_id: 4,
    zip_code: "4009",
    wilaya: {
      id: 4,
      name: "Oum El Bouaghi",
    },
  },
  {
    id: 97,
    name: "Ouled Hamla",
    wilaya_id: 4,
    zip_code: "4010",
    wilaya: {
      id: 4,
      name: "Oum El Bouaghi",
    },
  },
  {
    id: 98,
    name: "Dhalaa",
    wilaya_id: 4,
    zip_code: "4011",
    wilaya: {
      id: 4,
      name: "Oum El Bouaghi",
    },
  },
  {
    id: 99,
    name: "Aïn Kercha",
    wilaya_id: 4,
    zip_code: "4012",
    wilaya: {
      id: 4,
      name: "Oum El Bouaghi",
    },
  },
  {
    id: 100,
    name: "Hanchir Toumghani",
    wilaya_id: 4,
    zip_code: "4013",
    wilaya: {
      id: 4,
      name: "Oum El Bouaghi",
    },
  },
  {
    id: 101,
    name: "El Djazia",
    wilaya_id: 4,
    zip_code: "4014",
    wilaya: {
      id: 4,
      name: "Oum El Bouaghi",
    },
  },
  {
    id: 102,
    name: "Aïn Diss",
    wilaya_id: 4,
    zip_code: "4015",
    wilaya: {
      id: 4,
      name: "Oum El Bouaghi",
    },
  },
  {
    id: 103,
    name: "Fkirina",
    wilaya_id: 4,
    zip_code: "4016",
    wilaya: {
      id: 4,
      name: "Oum El Bouaghi",
    },
  },
  {
    id: 104,
    name: "Souk Naamane",
    wilaya_id: 4,
    zip_code: "4017",
    wilaya: {
      id: 4,
      name: "Oum El Bouaghi",
    },
  },
  {
    id: 105,
    name: "Zorg",
    wilaya_id: 4,
    zip_code: "4018",
    wilaya: {
      id: 4,
      name: "Oum El Bouaghi",
    },
  },
  {
    id: 106,
    name: "El Fedjoudj Boughrara Saoudi",
    wilaya_id: 4,
    zip_code: "4019",
    wilaya: {
      id: 4,
      name: "Oum El Bouaghi",
    },
  },
  {
    id: 107,
    name: "Ouled Zouaï",
    wilaya_id: 4,
    zip_code: "4020",
    wilaya: {
      id: 4,
      name: "Oum El Bouaghi",
    },
  },
  {
    id: 108,
    name: "Bir Chouhada",
    wilaya_id: 4,
    zip_code: "4021",
    wilaya: {
      id: 4,
      name: "Oum El Bouaghi",
    },
  },
  {
    id: 109,
    name: "Ksar Sbahi",
    wilaya_id: 4,
    zip_code: "4022",
    wilaya: {
      id: 4,
      name: "Oum El Bouaghi",
    },
  },
  {
    id: 110,
    name: "Oued Nini",
    wilaya_id: 4,
    zip_code: "4023",
    wilaya: {
      id: 4,
      name: "Oum El Bouaghi",
    },
  },
  {
    id: 111,
    name: "Meskiana",
    wilaya_id: 4,
    zip_code: "4024",
    wilaya: {
      id: 4,
      name: "Oum El Bouaghi",
    },
  },
  {
    id: 112,
    name: "Aïn Fakroun",
    wilaya_id: 4,
    zip_code: "4025",
    wilaya: {
      id: 4,
      name: "Oum El Bouaghi",
    },
  },
  {
    id: 113,
    name: "Rahia",
    wilaya_id: 4,
    zip_code: "4026",
    wilaya: {
      id: 4,
      name: "Oum El Bouaghi",
    },
  },
  {
    id: 114,
    name: "Aïn Zitoun",
    wilaya_id: 4,
    zip_code: "4027",
    wilaya: {
      id: 4,
      name: "Oum El Bouaghi",
    },
  },
  {
    id: 115,
    name: "Ouled Gacem",
    wilaya_id: 4,
    zip_code: "4028",
    wilaya: {
      id: 4,
      name: "Oum El Bouaghi",
    },
  },
  {
    id: 116,
    name: "El Harmilia",
    wilaya_id: 4,
    zip_code: "4029",
    wilaya: {
      id: 4,
      name: "Oum El Bouaghi",
    },
  },
  {
    id: 117,
    name: "Batna",
    wilaya_id: 5,
    zip_code: "5001",
    wilaya: {
      id: 5,
      name: "Batna",
    },
  },
  {
    id: 118,
    name: "Ghassira",
    wilaya_id: 5,
    zip_code: "5002",
    wilaya: {
      id: 5,
      name: "Batna",
    },
  },
  {
    id: 119,
    name: "M'doukel",
    wilaya_id: 5,
    zip_code: "5003",
    wilaya: {
      id: 5,
      name: "Batna",
    },
  },
  {
    id: 120,
    name: "Menaa",
    wilaya_id: 5,
    zip_code: "5004",
    wilaya: {
      id: 5,
      name: "Batna",
    },
  },
  {
    id: 121,
    name: "Seriana",
    wilaya_id: 5,
    zip_code: "5005",
    wilaya: {
      id: 5,
      name: "Batna",
    },
  },
  {
    id: 122,
    name: "Maafa",
    wilaya_id: 5,
    zip_code: "5006",
    wilaya: {
      id: 5,
      name: "Batna",
    },
  },
  {
    id: 123,
    name: "El Madher",
    wilaya_id: 5,
    zip_code: "5007",
    wilaya: {
      id: 5,
      name: "Batna",
    },
  },
  {
    id: 124,
    name: "Taxlent",
    wilaya_id: 5,
    zip_code: "5008",
    wilaya: {
      id: 5,
      name: "Batna",
    },
  },
  {
    id: 125,
    name: "N'Gaous",
    wilaya_id: 5,
    zip_code: "5009",
    wilaya: {
      id: 5,
      name: "Batna",
    },
  },
  {
    id: 126,
    name: "Guigba",
    wilaya_id: 5,
    zip_code: "5010",
    wilaya: {
      id: 5,
      name: "Batna",
    },
  },
  {
    id: 127,
    name: "Inoughissen",
    wilaya_id: 5,
    zip_code: "5011",
    wilaya: {
      id: 5,
      name: "Batna",
    },
  },
  {
    id: 128,
    name: "Ouyoun El Assafir",
    wilaya_id: 5,
    zip_code: "5012",
    wilaya: {
      id: 5,
      name: "Batna",
    },
  },
  {
    id: 129,
    name: "Djerma",
    wilaya_id: 5,
    zip_code: "5013",
    wilaya: {
      id: 5,
      name: "Batna",
    },
  },
  {
    id: 130,
    name: "Bitam",
    wilaya_id: 5,
    zip_code: "5014",
    wilaya: {
      id: 5,
      name: "Batna",
    },
  },
  {
    id: 131,
    name: "Merouana",
    wilaya_id: 5,
    zip_code: "5015",
    wilaya: {
      id: 5,
      name: "Batna",
    },
  },
  {
    id: 132,
    name: "Arris",
    wilaya_id: 5,
    zip_code: "5016",
    wilaya: {
      id: 5,
      name: "Batna",
    },
  },
  {
    id: 133,
    name: "Kimmel",
    wilaya_id: 5,
    zip_code: "5017",
    wilaya: {
      id: 5,
      name: "Batna",
    },
  },
  {
    id: 134,
    name: "Tigherghar",
    wilaya_id: 5,
    zip_code: "5018",
    wilaya: {
      id: 5,
      name: "Batna",
    },
  },
  {
    id: 135,
    name: "Aïn Djasser",
    wilaya_id: 5,
    zip_code: "5019",
    wilaya: {
      id: 5,
      name: "Batna",
    },
  },
  {
    id: 136,
    name: "Ouled Sellam",
    wilaya_id: 5,
    zip_code: "5020",
    wilaya: {
      id: 5,
      name: "Batna",
    },
  },
  {
    id: 137,
    name: "Tighanimine",
    wilaya_id: 5,
    zip_code: "5021",
    wilaya: {
      id: 5,
      name: "Batna",
    },
  },
  {
    id: 138,
    name: "Aïn Yagout",
    wilaya_id: 5,
    zip_code: "5022",
    wilaya: {
      id: 5,
      name: "Batna",
    },
  },
  {
    id: 139,
    name: "Fesdis",
    wilaya_id: 5,
    zip_code: "5023",
    wilaya: {
      id: 5,
      name: "Batna",
    },
  },
  {
    id: 140,
    name: "Sefiane",
    wilaya_id: 5,
    zip_code: "5024",
    wilaya: {
      id: 5,
      name: "Batna",
    },
  },
  {
    id: 141,
    name: "Rahbat",
    wilaya_id: 5,
    zip_code: "5025",
    wilaya: {
      id: 5,
      name: "Batna",
    },
  },
  {
    id: 142,
    name: "Teniet El Abed",
    wilaya_id: 5,
    zip_code: "5026",
    wilaya: {
      id: 5,
      name: "Batna",
    },
  },
  {
    id: 143,
    name: "Lemsane",
    wilaya_id: 5,
    zip_code: "5027",
    wilaya: {
      id: 5,
      name: "Batna",
    },
  },
  {
    id: 144,
    name: "Ksar Bellezma",
    wilaya_id: 5,
    zip_code: "5028",
    wilaya: {
      id: 5,
      name: "Batna",
    },
  },
  {
    id: 145,
    name: "Seggana",
    wilaya_id: 5,
    zip_code: "5029",
    wilaya: {
      id: 5,
      name: "Batna",
    },
  },
  {
    id: 146,
    name: "Ichmoul",
    wilaya_id: 5,
    zip_code: "5030",
    wilaya: {
      id: 5,
      name: "Batna",
    },
  },
  {
    id: 147,
    name: "Foum Toub",
    wilaya_id: 5,
    zip_code: "5031",
    wilaya: {
      id: 5,
      name: "Batna",
    },
  },
  {
    id: 148,
    name: "Ben Foudhala El Hakania",
    wilaya_id: 5,
    zip_code: "5032",
    wilaya: {
      id: 5,
      name: "Batna",
    },
  },
  {
    id: 149,
    name: "Oued El Ma",
    wilaya_id: 5,
    zip_code: "5033",
    wilaya: {
      id: 5,
      name: "Batna",
    },
  },
  {
    id: 150,
    name: "T'Kout",
    wilaya_id: 5,
    zip_code: "5034",
    wilaya: {
      id: 5,
      name: "Batna",
    },
  },
  {
    id: 151,
    name: "Bouzina",
    wilaya_id: 5,
    zip_code: "5035",
    wilaya: {
      id: 5,
      name: "Batna",
    },
  },
  {
    id: 152,
    name: "Chemora",
    wilaya_id: 5,
    zip_code: "5036",
    wilaya: {
      id: 5,
      name: "Batna",
    },
  },
  {
    id: 153,
    name: "Oued Chaaba",
    wilaya_id: 5,
    zip_code: "5037",
    wilaya: {
      id: 5,
      name: "Batna",
    },
  },
  {
    id: 154,
    name: "Talkhamt",
    wilaya_id: 5,
    zip_code: "5038",
    wilaya: {
      id: 5,
      name: "Batna",
    },
  },
  {
    id: 155,
    name: "Gosbat",
    wilaya_id: 5,
    zip_code: "5039",
    wilaya: {
      id: 5,
      name: "Batna",
    },
  },
  {
    id: 156,
    name: "Ouled Aouf",
    wilaya_id: 5,
    zip_code: "5040",
    wilaya: {
      id: 5,
      name: "Batna",
    },
  },
  {
    id: 157,
    name: "Boumagueur",
    wilaya_id: 5,
    zip_code: "5041",
    wilaya: {
      id: 5,
      name: "Batna",
    },
  },
  {
    id: 158,
    name: "Barika",
    wilaya_id: 5,
    zip_code: "5042",
    wilaya: {
      id: 5,
      name: "Batna",
    },
  },
  {
    id: 159,
    name: "Djezar",
    wilaya_id: 5,
    zip_code: "5043",
    wilaya: {
      id: 5,
      name: "Batna",
    },
  },
  {
    id: 160,
    name: "Timgad",
    wilaya_id: 5,
    zip_code: "5044",
    wilaya: {
      id: 5,
      name: "Batna",
    },
  },
  {
    id: 161,
    name: "Aïn Touta",
    wilaya_id: 5,
    zip_code: "5045",
    wilaya: {
      id: 5,
      name: "Batna",
    },
  },
  {
    id: 162,
    name: "Hidoussa",
    wilaya_id: 5,
    zip_code: "5046",
    wilaya: {
      id: 5,
      name: "Batna",
    },
  },
  {
    id: 163,
    name: "Tazoult",
    wilaya_id: 5,
    zip_code: "5047",
    wilaya: {
      id: 5,
      name: "Batna",
    },
  },
  {
    id: 164,
    name: "Oued Taga",
    wilaya_id: 5,
    zip_code: "5048",
    wilaya: {
      id: 5,
      name: "Batna",
    },
  },
  {
    id: 165,
    name: "Ouled Fadel",
    wilaya_id: 5,
    zip_code: "5049",
    wilaya: {
      id: 5,
      name: "Batna",
    },
  },
  {
    id: 166,
    name: "Tilatou",
    wilaya_id: 5,
    zip_code: "5050",
    wilaya: {
      id: 5,
      name: "Batna",
    },
  },
  {
    id: 167,
    name: "Ras El Aioun",
    wilaya_id: 5,
    zip_code: "5051",
    wilaya: {
      id: 5,
      name: "Batna",
    },
  },
  {
    id: 168,
    name: "Chir",
    wilaya_id: 5,
    zip_code: "5052",
    wilaya: {
      id: 5,
      name: "Batna",
    },
  },
  {
    id: 169,
    name: "Ouled Si Slimane",
    wilaya_id: 5,
    zip_code: "5053",
    wilaya: {
      id: 5,
      name: "Batna",
    },
  },
  {
    id: 170,
    name: "Zanat El Beida",
    wilaya_id: 5,
    zip_code: "5054",
    wilaya: {
      id: 5,
      name: "Batna",
    },
  },
  {
    id: 171,
    name: "Abdelkader Azil",
    wilaya_id: 5,
    zip_code: "5055",
    wilaya: {
      id: 5,
      name: "Batna",
    },
  },
  {
    id: 172,
    name: "Ouled Ammar",
    wilaya_id: 5,
    zip_code: "5056",
    wilaya: {
      id: 5,
      name: "Batna",
    },
  },
  {
    id: 173,
    name: "El Hassi",
    wilaya_id: 5,
    zip_code: "5057",
    wilaya: {
      id: 5,
      name: "Batna",
    },
  },
  {
    id: 174,
    name: "Lazrou",
    wilaya_id: 5,
    zip_code: "5058",
    wilaya: {
      id: 5,
      name: "Batna",
    },
  },
  {
    id: 175,
    name: "Boumia (Batna)",
    wilaya_id: 5,
    zip_code: "5059",
    wilaya: {
      id: 5,
      name: "Batna",
    },
  },
  {
    id: 176,
    name: "Boulhilat",
    wilaya_id: 5,
    zip_code: "5060",
    wilaya: {
      id: 5,
      name: "Batna",
    },
  },
  {
    id: 177,
    name: "Larbaâ",
    wilaya_id: 5,
    zip_code: "5061",
    wilaya: {
      id: 5,
      name: "Batna",
    },
  },
  {
    id: 178,
    name: "Bejaia",
    wilaya_id: 6,
    zip_code: "6001",
    wilaya: {
      id: 6,
      name: "Bejaia",
    },
  },
  {
    id: 179,
    name: "Amizour",
    wilaya_id: 6,
    zip_code: "6002",
    wilaya: {
      id: 6,
      name: "Bejaia",
    },
  },
  {
    id: 180,
    name: "Ferraoun",
    wilaya_id: 6,
    zip_code: "6003",
    wilaya: {
      id: 6,
      name: "Bejaia",
    },
  },
  {
    id: 181,
    name: "Taourirt Ighil",
    wilaya_id: 6,
    zip_code: "6004",
    wilaya: {
      id: 6,
      name: "Bejaia",
    },
  },
  {
    id: 182,
    name: "Chellata",
    wilaya_id: 6,
    zip_code: "6005",
    wilaya: {
      id: 6,
      name: "Bejaia",
    },
  },
  {
    id: 183,
    name: "Tamokra",
    wilaya_id: 6,
    zip_code: "6006",
    wilaya: {
      id: 6,
      name: "Bejaia",
    },
  },
  {
    id: 184,
    name: "Timezrit",
    wilaya_id: 6,
    zip_code: "6007",
    wilaya: {
      id: 6,
      name: "Bejaia",
    },
  },
  {
    id: 185,
    name: "Souk El Ténine",
    wilaya_id: 6,
    zip_code: "6008",
    wilaya: {
      id: 6,
      name: "Bejaia",
    },
  },
  {
    id: 186,
    name: "M'cisna",
    wilaya_id: 6,
    zip_code: "6009",
    wilaya: {
      id: 6,
      name: "Bejaia",
    },
  },
  {
    id: 187,
    name: "Tinabdher",
    wilaya_id: 6,
    zip_code: "6010",
    wilaya: {
      id: 6,
      name: "Bejaia",
    },
  },
  {
    id: 188,
    name: "Tichy",
    wilaya_id: 6,
    zip_code: "6011",
    wilaya: {
      id: 6,
      name: "Bejaia",
    },
  },
  {
    id: 189,
    name: "Semaoun",
    wilaya_id: 6,
    zip_code: "6012",
    wilaya: {
      id: 6,
      name: "Bejaia",
    },
  },
  {
    id: 190,
    name: "Kendira",
    wilaya_id: 6,
    zip_code: "6013",
    wilaya: {
      id: 6,
      name: "Bejaia",
    },
  },
  {
    id: 191,
    name: "Tifra",
    wilaya_id: 6,
    zip_code: "6014",
    wilaya: {
      id: 6,
      name: "Bejaia",
    },
  },
  {
    id: 192,
    name: "Ighram",
    wilaya_id: 6,
    zip_code: "6015",
    wilaya: {
      id: 6,
      name: "Bejaia",
    },
  },
  {
    id: 193,
    name: "Amalou",
    wilaya_id: 6,
    zip_code: "6016",
    wilaya: {
      id: 6,
      name: "Bejaia",
    },
  },
  {
    id: 194,
    name: "Ighil Ali",
    wilaya_id: 6,
    zip_code: "6017",
    wilaya: {
      id: 6,
      name: "Bejaia",
    },
  },
  {
    id: 195,
    name: "Fenaïa Ilmaten",
    wilaya_id: 6,
    zip_code: "6018",
    wilaya: {
      id: 6,
      name: "Bejaia",
    },
  },
  {
    id: 196,
    name: "Toudja",
    wilaya_id: 6,
    zip_code: "6019",
    wilaya: {
      id: 6,
      name: "Bejaia",
    },
  },
  {
    id: 197,
    name: "Darguina",
    wilaya_id: 6,
    zip_code: "6020",
    wilaya: {
      id: 6,
      name: "Bejaia",
    },
  },
  {
    id: 198,
    name: "Sidi Ayad",
    wilaya_id: 6,
    zip_code: "6021",
    wilaya: {
      id: 6,
      name: "Bejaia",
    },
  },
  {
    id: 199,
    name: "Aokas",
    wilaya_id: 6,
    zip_code: "6022",
    wilaya: {
      id: 6,
      name: "Bejaia",
    },
  },
  {
    id: 200,
    name: "Ait Djellil",
    wilaya_id: 6,
    zip_code: "6023",
    wilaya: {
      id: 6,
      name: "Bejaia",
    },
  },
  {
    id: 201,
    name: "Adekar",
    wilaya_id: 6,
    zip_code: "6024",
    wilaya: {
      id: 6,
      name: "Bejaia",
    },
  },
  {
    id: 202,
    name: "Akbou",
    wilaya_id: 6,
    zip_code: "6025",
    wilaya: {
      id: 6,
      name: "Bejaia",
    },
  },
  {
    id: 203,
    name: "Seddouk",
    wilaya_id: 6,
    zip_code: "6026",
    wilaya: {
      id: 6,
      name: "Bejaia",
    },
  },
  {
    id: 204,
    name: "Tazmalt",
    wilaya_id: 6,
    zip_code: "6027",
    wilaya: {
      id: 6,
      name: "Bejaia",
    },
  },
  {
    id: 205,
    name: "Aït R'zine",
    wilaya_id: 6,
    zip_code: "6028",
    wilaya: {
      id: 6,
      name: "Bejaia",
    },
  },
  {
    id: 206,
    name: "Chemini",
    wilaya_id: 6,
    zip_code: "6029",
    wilaya: {
      id: 6,
      name: "Bejaia",
    },
  },
  {
    id: 207,
    name: "Souk Oufella",
    wilaya_id: 6,
    zip_code: "6030",
    wilaya: {
      id: 6,
      name: "Bejaia",
    },
  },
  {
    id: 208,
    name: "Taskriout",
    wilaya_id: 6,
    zip_code: "6031",
    wilaya: {
      id: 6,
      name: "Bejaia",
    },
  },
  {
    id: 209,
    name: "Tibane",
    wilaya_id: 6,
    zip_code: "6032",
    wilaya: {
      id: 6,
      name: "Bejaia",
    },
  },
  {
    id: 210,
    name: "Tala Hamza",
    wilaya_id: 6,
    zip_code: "6033",
    wilaya: {
      id: 6,
      name: "Bejaia",
    },
  },
  {
    id: 211,
    name: "Barbacha",
    wilaya_id: 6,
    zip_code: "6034",
    wilaya: {
      id: 6,
      name: "Bejaia",
    },
  },
  {
    id: 212,
    name: "Aït Ksila",
    wilaya_id: 6,
    zip_code: "6035",
    wilaya: {
      id: 6,
      name: "Bejaia",
    },
  },
  {
    id: 213,
    name: "Ouzellaguen",
    wilaya_id: 6,
    zip_code: "6036",
    wilaya: {
      id: 6,
      name: "Bejaia",
    },
  },
  {
    id: 214,
    name: "Bouhamza",
    wilaya_id: 6,
    zip_code: "6037",
    wilaya: {
      id: 6,
      name: "Bejaia",
    },
  },
  {
    id: 215,
    name: "Aït Mellikeche",
    wilaya_id: 6,
    zip_code: "6038",
    wilaya: {
      id: 6,
      name: "Bejaia",
    },
  },
  {
    id: 216,
    name: "Sidi Aïch",
    wilaya_id: 6,
    zip_code: "6039",
    wilaya: {
      id: 6,
      name: "Bejaia",
    },
  },
  {
    id: 217,
    name: "El Kseur",
    wilaya_id: 6,
    zip_code: "6040",
    wilaya: {
      id: 6,
      name: "Bejaia",
    },
  },
  {
    id: 218,
    name: "Melbou",
    wilaya_id: 6,
    zip_code: "6041",
    wilaya: {
      id: 6,
      name: "Bejaia",
    },
  },
  {
    id: 219,
    name: "Akfadou",
    wilaya_id: 6,
    zip_code: "6042",
    wilaya: {
      id: 6,
      name: "Bejaia",
    },
  },
  {
    id: 220,
    name: "Leflaye",
    wilaya_id: 6,
    zip_code: "6043",
    wilaya: {
      id: 6,
      name: "Bejaia",
    },
  },
  {
    id: 221,
    name: "Kherrata",
    wilaya_id: 6,
    zip_code: "6044",
    wilaya: {
      id: 6,
      name: "Bejaia",
    },
  },
  {
    id: 222,
    name: "Draâ El Kaïd",
    wilaya_id: 6,
    zip_code: "6045",
    wilaya: {
      id: 6,
      name: "Bejaia",
    },
  },
  {
    id: 223,
    name: "Tamridjet",
    wilaya_id: 6,
    zip_code: "6046",
    wilaya: {
      id: 6,
      name: "Bejaia",
    },
  },
  {
    id: 224,
    name: "Aït Smail",
    wilaya_id: 6,
    zip_code: "6047",
    wilaya: {
      id: 6,
      name: "Bejaia",
    },
  },
  {
    id: 225,
    name: "Boukhelifa",
    wilaya_id: 6,
    zip_code: "6048",
    wilaya: {
      id: 6,
      name: "Bejaia",
    },
  },
  {
    id: 226,
    name: "Tizi N'Berber",
    wilaya_id: 6,
    zip_code: "6049",
    wilaya: {
      id: 6,
      name: "Bejaia",
    },
  },
  {
    id: 227,
    name: "Aït Maouche",
    wilaya_id: 6,
    zip_code: "6050",
    wilaya: {
      id: 6,
      name: "Bejaia",
    },
  },
  {
    id: 228,
    name: "Oued Ghir",
    wilaya_id: 6,
    zip_code: "6051",
    wilaya: {
      id: 6,
      name: "Bejaia",
    },
  },
  {
    id: 229,
    name: "Boudjellil",
    wilaya_id: 6,
    zip_code: "6052",
    wilaya: {
      id: 6,
      name: "Bejaia",
    },
  },
  {
    id: 230,
    name: "Biskra",
    wilaya_id: 7,
    zip_code: "7001",
    wilaya: {
      id: 7,
      name: "Biskra",
    },
  },
  {
    id: 231,
    name: "Oumache",
    wilaya_id: 7,
    zip_code: "7002",
    wilaya: {
      id: 7,
      name: "Biskra",
    },
  },
  {
    id: 232,
    name: "Branis",
    wilaya_id: 7,
    zip_code: "7003",
    wilaya: {
      id: 7,
      name: "Biskra",
    },
  },
  {
    id: 233,
    name: "Chetma",
    wilaya_id: 7,
    zip_code: "7004",
    wilaya: {
      id: 7,
      name: "Biskra",
    },
  },
  {
    id: 234,
    name: "Ouled Djellal",
    wilaya_id: 51,
    zip_code: "7005",
    wilaya: {
      id: 51,
      name: "Ouled Djellal",
    },
  },
  {
    id: 235,
    name: "Ras El Miaad",
    wilaya_id: 51,
    zip_code: "7006",
    wilaya: {
      id: 51,
      name: "Ouled Djellal",
    },
  },
  {
    id: 236,
    name: "Besbes",
    wilaya_id: 51,
    zip_code: "7007",
    wilaya: {
      id: 51,
      name: "Ouled Djellal",
    },
  },
  {
    id: 237,
    name: "Sidi Khaled",
    wilaya_id: 51,
    zip_code: "7008",
    wilaya: {
      id: 51,
      name: "Ouled Djellal",
    },
  },
  {
    id: 238,
    name: "Doucen",
    wilaya_id: 51,
    zip_code: "7009",
    wilaya: {
      id: 51,
      name: "Ouled Djellal",
    },
  },
  {
    id: 239,
    name: "Ech Chaïba",
    wilaya_id: 51,
    zip_code: "7010",
    wilaya: {
      id: 51,
      name: "Ouled Djellal",
    },
  },
  {
    id: 240,
    name: "Sidi Okba",
    wilaya_id: 7,
    zip_code: "7011",
    wilaya: {
      id: 7,
      name: "Biskra",
    },
  },
  {
    id: 241,
    name: "M'Chouneche",
    wilaya_id: 7,
    zip_code: "7012",
    wilaya: {
      id: 7,
      name: "Biskra",
    },
  },
  {
    id: 242,
    name: "El Haouch",
    wilaya_id: 7,
    zip_code: "7013",
    wilaya: {
      id: 7,
      name: "Biskra",
    },
  },
  {
    id: 243,
    name: "Aïn Naga",
    wilaya_id: 7,
    zip_code: "7014",
    wilaya: {
      id: 7,
      name: "Biskra",
    },
  },
  {
    id: 244,
    name: "Zeribet El Oued",
    wilaya_id: 7,
    zip_code: "7015",
    wilaya: {
      id: 7,
      name: "Biskra",
    },
  },
  {
    id: 245,
    name: "El Feidh",
    wilaya_id: 7,
    zip_code: "7016",
    wilaya: {
      id: 7,
      name: "Biskra",
    },
  },
  {
    id: 246,
    name: "El Kantara",
    wilaya_id: 7,
    zip_code: "7017",
    wilaya: {
      id: 7,
      name: "Biskra",
    },
  },
  {
    id: 247,
    name: "Aïn Zaatout",
    wilaya_id: 7,
    zip_code: "7018",
    wilaya: {
      id: 7,
      name: "Biskra",
    },
  },
  {
    id: 248,
    name: "El Outaya",
    wilaya_id: 7,
    zip_code: "7019",
    wilaya: {
      id: 7,
      name: "Biskra",
    },
  },
  {
    id: 249,
    name: "Djemorah",
    wilaya_id: 7,
    zip_code: "7020",
    wilaya: {
      id: 7,
      name: "Biskra",
    },
  },
  {
    id: 250,
    name: "Tolga",
    wilaya_id: 7,
    zip_code: "7021",
    wilaya: {
      id: 7,
      name: "Biskra",
    },
  },
  {
    id: 251,
    name: "Lioua",
    wilaya_id: 7,
    zip_code: "7022",
    wilaya: {
      id: 7,
      name: "Biskra",
    },
  },
  {
    id: 252,
    name: "Lichana",
    wilaya_id: 7,
    zip_code: "7023",
    wilaya: {
      id: 7,
      name: "Biskra",
    },
  },
  {
    id: 253,
    name: "Ourlal",
    wilaya_id: 7,
    zip_code: "7024",
    wilaya: {
      id: 7,
      name: "Biskra",
    },
  },
  {
    id: 254,
    name: "M'Lili",
    wilaya_id: 7,
    zip_code: "7025",
    wilaya: {
      id: 7,
      name: "Biskra",
    },
  },
  {
    id: 255,
    name: "Foughala",
    wilaya_id: 7,
    zip_code: "7026",
    wilaya: {
      id: 7,
      name: "Biskra",
    },
  },
  {
    id: 256,
    name: "Bordj Ben Azzouz",
    wilaya_id: 7,
    zip_code: "7027",
    wilaya: {
      id: 7,
      name: "Biskra",
    },
  },
  {
    id: 257,
    name: "El Mizaraa",
    wilaya_id: 7,
    zip_code: "7028",
    wilaya: {
      id: 7,
      name: "Biskra",
    },
  },
  {
    id: 258,
    name: "Bouchagroune",
    wilaya_id: 7,
    zip_code: "7029",
    wilaya: {
      id: 7,
      name: "Biskra",
    },
  },
  {
    id: 259,
    name: "Mekhadma",
    wilaya_id: 7,
    zip_code: "7030",
    wilaya: {
      id: 7,
      name: "Biskra",
    },
  },
  {
    id: 260,
    name: "El Ghrous",
    wilaya_id: 7,
    zip_code: "7031",
    wilaya: {
      id: 7,
      name: "Biskra",
    },
  },
  {
    id: 261,
    name: "El Hadjeb",
    wilaya_id: 7,
    zip_code: "7032",
    wilaya: {
      id: 7,
      name: "Biskra",
    },
  },
  {
    id: 262,
    name: "Khenguet Sidi Nadji",
    wilaya_id: 7,
    zip_code: "7033",
    wilaya: {
      id: 7,
      name: "Biskra",
    },
  },
  {
    id: 263,
    name: "Béchar",
    wilaya_id: 8,
    zip_code: "8001",
    wilaya: {
      id: 8,
      name: "Béchar",
    },
  },
  {
    id: 264,
    name: "Erg Ferradj",
    wilaya_id: 8,
    zip_code: "8002",
    wilaya: {
      id: 8,
      name: "Béchar",
    },
  },
  {
    id: 265,
    name: "Ouled Khoudir",
    wilaya_id: 52,
    zip_code: "8003",
    wilaya: {
      id: 52,
      name: "Béni Abbès",
    },
  },
  {
    id: 266,
    name: "Meridja",
    wilaya_id: 8,
    zip_code: "8004",
    wilaya: {
      id: 8,
      name: "Béchar",
    },
  },
  {
    id: 267,
    name: "Timoudi",
    wilaya_id: 52,
    zip_code: "8005",
    wilaya: {
      id: 52,
      name: "Béni Abbès",
    },
  },
  {
    id: 268,
    name: "Lahmar",
    wilaya_id: 8,
    zip_code: "8006",
    wilaya: {
      id: 8,
      name: "Béchar",
    },
  },
  {
    id: 269,
    name: "Béni Abbès",
    wilaya_id: 52,
    zip_code: "8007",
    wilaya: {
      id: 52,
      name: "Béni Abbès",
    },
  },
  {
    id: 270,
    name: "Beni Ikhlef",
    wilaya_id: 52,
    zip_code: "8008",
    wilaya: {
      id: 52,
      name: "Béni Abbès",
    },
  },
  {
    id: 271,
    name: "Mechraa Houari Boumedienne",
    wilaya_id: 8,
    zip_code: "8009",
    wilaya: {
      id: 8,
      name: "Béchar",
    },
  },
  {
    id: 272,
    name: "Kenadsa",
    wilaya_id: 8,
    zip_code: "8010",
    wilaya: {
      id: 8,
      name: "Béchar",
    },
  },
  {
    id: 273,
    name: "Igli",
    wilaya_id: 52,
    zip_code: "8011",
    wilaya: {
      id: 52,
      name: "Béni Abbès",
    },
  },
  {
    id: 274,
    name: "Tabelbala",
    wilaya_id: 52,
    zip_code: "8012",
    wilaya: {
      id: 52,
      name: "Béni Abbès",
    },
  },
  {
    id: 275,
    name: "Taghit",
    wilaya_id: 8,
    zip_code: "8013",
    wilaya: {
      id: 8,
      name: "Béchar",
    },
  },
  {
    id: 276,
    name: "El Ouata",
    wilaya_id: 52,
    zip_code: "8014",
    wilaya: {
      id: 52,
      name: "Béni Abbès",
    },
  },
  {
    id: 277,
    name: "Boukais",
    wilaya_id: 8,
    zip_code: "8015",
    wilaya: {
      id: 8,
      name: "Béchar",
    },
  },
  {
    id: 278,
    name: "Mougheul",
    wilaya_id: 8,
    zip_code: "8016",
    wilaya: {
      id: 8,
      name: "Béchar",
    },
  },
  {
    id: 279,
    name: "Abadla",
    wilaya_id: 8,
    zip_code: "8017",
    wilaya: {
      id: 8,
      name: "Béchar",
    },
  },
  {
    id: 280,
    name: "Kerzaz",
    wilaya_id: 52,
    zip_code: "8018",
    wilaya: {
      id: 52,
      name: "Béni Abbès",
    },
  },
  {
    id: 281,
    name: "Ksabi",
    wilaya_id: 52,
    zip_code: "8019",
    wilaya: {
      id: 52,
      name: "Béni Abbès",
    },
  },
  {
    id: 282,
    name: "Tamtert",
    wilaya_id: 52,
    zip_code: "8020",
    wilaya: {
      id: 52,
      name: "Béni Abbès",
    },
  },
  {
    id: 283,
    name: "Beni Ounif",
    wilaya_id: 8,
    zip_code: "8021",
    wilaya: {
      id: 8,
      name: "Béchar",
    },
  },
  {
    id: 284,
    name: "Blida",
    wilaya_id: 9,
    zip_code: "9001",
    wilaya: {
      id: 9,
      name: "Blida",
    },
  },
  {
    id: 285,
    name: "Chebli",
    wilaya_id: 9,
    zip_code: "9002",
    wilaya: {
      id: 9,
      name: "Blida",
    },
  },
  {
    id: 286,
    name: "Bouinan",
    wilaya_id: 9,
    zip_code: "9003",
    wilaya: {
      id: 9,
      name: "Blida",
    },
  },
  {
    id: 287,
    name: "Oued Alleug",
    wilaya_id: 9,
    zip_code: "9004",
    wilaya: {
      id: 9,
      name: "Blida",
    },
  },
  {
    id: 288,
    name: "Ouled Yaïch",
    wilaya_id: 9,
    zip_code: "9007",
    wilaya: {
      id: 9,
      name: "Blida",
    },
  },
  {
    id: 289,
    name: "Chréa",
    wilaya_id: 9,
    zip_code: "9008",
    wilaya: {
      id: 9,
      name: "Blida",
    },
  },
  {
    id: 290,
    name: "El Affroun",
    wilaya_id: 9,
    zip_code: "9010",
    wilaya: {
      id: 9,
      name: "Blida",
    },
  },
  {
    id: 291,
    name: "Chiffa",
    wilaya_id: 9,
    zip_code: "9011",
    wilaya: {
      id: 9,
      name: "Blida",
    },
  },
  {
    id: 292,
    name: "Hammam Melouane",
    wilaya_id: 9,
    zip_code: "9012",
    wilaya: {
      id: 9,
      name: "Blida",
    },
  },
  {
    id: 293,
    name: "Benkhelil",
    wilaya_id: 9,
    zip_code: "9013",
    wilaya: {
      id: 9,
      name: "Blida",
    },
  },
  {
    id: 294,
    name: "Soumaa",
    wilaya_id: 9,
    zip_code: "9014",
    wilaya: {
      id: 9,
      name: "Blida",
    },
  },
  {
    id: 295,
    name: "Mouzaia",
    wilaya_id: 9,
    zip_code: "9016",
    wilaya: {
      id: 9,
      name: "Blida",
    },
  },
  {
    id: 296,
    name: "Souhane",
    wilaya_id: 9,
    zip_code: "9017",
    wilaya: {
      id: 9,
      name: "Blida",
    },
  },
  {
    id: 297,
    name: "Meftah",
    wilaya_id: 9,
    zip_code: "9018",
    wilaya: {
      id: 9,
      name: "Blida",
    },
  },
  {
    id: 298,
    name: "Ouled Slama",
    wilaya_id: 9,
    zip_code: "9019",
    wilaya: {
      id: 9,
      name: "Blida",
    },
  },
  {
    id: 299,
    name: "Boufarik",
    wilaya_id: 9,
    zip_code: "9020",
    wilaya: {
      id: 9,
      name: "Blida",
    },
  },
  {
    id: 300,
    name: "Larbaa",
    wilaya_id: 9,
    zip_code: "9021",
    wilaya: {
      id: 9,
      name: "Blida",
    },
  },
  {
    id: 301,
    name: "Oued Djer",
    wilaya_id: 9,
    zip_code: "9022",
    wilaya: {
      id: 9,
      name: "Blida",
    },
  },
  {
    id: 302,
    name: "Beni Tamou",
    wilaya_id: 9,
    zip_code: "9023",
    wilaya: {
      id: 9,
      name: "Blida",
    },
  },
  {
    id: 303,
    name: "Bouarfa",
    wilaya_id: 9,
    zip_code: "9024",
    wilaya: {
      id: 9,
      name: "Blida",
    },
  },
  {
    id: 304,
    name: "Beni Mered",
    wilaya_id: 9,
    zip_code: "9025",
    wilaya: {
      id: 9,
      name: "Blida",
    },
  },
  {
    id: 305,
    name: "Bougara",
    wilaya_id: 9,
    zip_code: "9026",
    wilaya: {
      id: 9,
      name: "Blida",
    },
  },
  {
    id: 306,
    name: "Guerouaou",
    wilaya_id: 9,
    zip_code: "9027",
    wilaya: {
      id: 9,
      name: "Blida",
    },
  },
  {
    id: 307,
    name: "Aïn Romana",
    wilaya_id: 9,
    zip_code: "9028",
    wilaya: {
      id: 9,
      name: "Blida",
    },
  },
  {
    id: 308,
    name: "Djebabra",
    wilaya_id: 9,
    zip_code: "9029",
    wilaya: {
      id: 9,
      name: "Blida",
    },
  },
  {
    id: 309,
    name: "Bouira",
    wilaya_id: 10,
    zip_code: "10001",
    wilaya: {
      id: 10,
      name: "Bouira",
    },
  },
  {
    id: 310,
    name: "El Asnam",
    wilaya_id: 10,
    zip_code: "10002",
    wilaya: {
      id: 10,
      name: "Bouira",
    },
  },
  {
    id: 311,
    name: "Guerrouma",
    wilaya_id: 10,
    zip_code: "10003",
    wilaya: {
      id: 10,
      name: "Bouira",
    },
  },
  {
    id: 312,
    name: "Beni Khellad",
    wilaya_id: 10,
    zip_code: "10004",
    wilaya: {
      id: 10,
      name: "Bouira",
    },
  },
  {
    id: 313,
    name: "Kadiria",
    wilaya_id: 10,
    zip_code: "10005",
    wilaya: {
      id: 10,
      name: "Bouira",
    },
  },
  {
    id: 314,
    name: "Hanif",
    wilaya_id: 10,
    zip_code: "10006",
    wilaya: {
      id: 10,
      name: "Bouira",
    },
  },
  {
    id: 315,
    name: "Dirrah",
    wilaya_id: 10,
    zip_code: "10007",
    wilaya: {
      id: 10,
      name: "Bouira",
    },
  },
  {
    id: 316,
    name: "Aït Laziz",
    wilaya_id: 10,
    zip_code: "10008",
    wilaya: {
      id: 10,
      name: "Bouira",
    },
  },
  {
    id: 317,
    name: "Taghzout",
    wilaya_id: 10,
    zip_code: "10009",
    wilaya: {
      id: 10,
      name: "Bouira",
    },
  },
  {
    id: 318,
    name: "Raouraoua",
    wilaya_id: 10,
    zip_code: "10010",
    wilaya: {
      id: 10,
      name: "Bouira",
    },
  },
  {
    id: 319,
    name: "Mezdour",
    wilaya_id: 10,
    zip_code: "10011",
    wilaya: {
      id: 10,
      name: "Bouira",
    },
  },
  {
    id: 320,
    name: "Haizer",
    wilaya_id: 10,
    zip_code: "10012",
    wilaya: {
      id: 10,
      name: "Bouira",
    },
  },
  {
    id: 321,
    name: "Lakhdaria",
    wilaya_id: 10,
    zip_code: "10013",
    wilaya: {
      id: 10,
      name: "Bouira",
    },
  },
  {
    id: 322,
    name: "M'Chedallah",
    wilaya_id: 10,
    zip_code: "10014",
    wilaya: {
      id: 10,
      name: "Bouira",
    },
  },
  {
    id: 323,
    name: "El Hachimia",
    wilaya_id: 10,
    zip_code: "10015",
    wilaya: {
      id: 10,
      name: "Bouira",
    },
  },
  {
    id: 324,
    name: "Aomar",
    wilaya_id: 10,
    zip_code: "10016",
    wilaya: {
      id: 10,
      name: "Bouira",
    },
  },
  {
    id: 325,
    name: "Chorfa",
    wilaya_id: 10,
    zip_code: "10017",
    wilaya: {
      id: 10,
      name: "Bouira",
    },
  },
  {
    id: 326,
    name: "Bordj Okhriss",
    wilaya_id: 10,
    zip_code: "10018",
    wilaya: {
      id: 10,
      name: "Bouira",
    },
  },
  {
    id: 327,
    name: "El Adjiba",
    wilaya_id: 10,
    zip_code: "10019",
    wilaya: {
      id: 10,
      name: "Bouira",
    },
  },
  {
    id: 328,
    name: "El Hakimia",
    wilaya_id: 10,
    zip_code: "10020",
    wilaya: {
      id: 10,
      name: "Bouira",
    },
  },
  {
    id: 329,
    name: "El Khabouzia",
    wilaya_id: 10,
    zip_code: "10021",
    wilaya: {
      id: 10,
      name: "Bouira",
    },
  },
  {
    id: 330,
    name: "Ahl El Ksar",
    wilaya_id: 10,
    zip_code: "10022",
    wilaya: {
      id: 10,
      name: "Bouira",
    },
  },
  {
    id: 331,
    name: "Bouderbala",
    wilaya_id: 10,
    zip_code: "10023",
    wilaya: {
      id: 10,
      name: "Bouira",
    },
  },
  {
    id: 332,
    name: "Zbarbar",
    wilaya_id: 10,
    zip_code: "10024",
    wilaya: {
      id: 10,
      name: "Bouira",
    },
  },
  {
    id: 333,
    name: "Aïn El Hadjar",
    wilaya_id: 10,
    zip_code: "10025",
    wilaya: {
      id: 10,
      name: "Bouira",
    },
  },
  {
    id: 334,
    name: "Djebahia",
    wilaya_id: 10,
    zip_code: "10026",
    wilaya: {
      id: 10,
      name: "Bouira",
    },
  },
  {
    id: 335,
    name: "Aghbalou",
    wilaya_id: 10,
    zip_code: "10027",
    wilaya: {
      id: 10,
      name: "Bouira",
    },
  },
  {
    id: 336,
    name: "Taguedit",
    wilaya_id: 10,
    zip_code: "10028",
    wilaya: {
      id: 10,
      name: "Bouira",
    },
  },
  {
    id: 337,
    name: "Aïn El Turk",
    wilaya_id: 10,
    zip_code: "10029",
    wilaya: {
      id: 10,
      name: "Bouira",
    },
  },
  {
    id: 338,
    name: "Saharidj",
    wilaya_id: 10,
    zip_code: "10030",
    wilaya: {
      id: 10,
      name: "Bouira",
    },
  },
  {
    id: 339,
    name: "Dechmia",
    wilaya_id: 10,
    zip_code: "10031",
    wilaya: {
      id: 10,
      name: "Bouira",
    },
  },
  {
    id: 340,
    name: "Ridane",
    wilaya_id: 10,
    zip_code: "10032",
    wilaya: {
      id: 10,
      name: "Bouira",
    },
  },
  {
    id: 341,
    name: "Bechloul",
    wilaya_id: 10,
    zip_code: "10033",
    wilaya: {
      id: 10,
      name: "Bouira",
    },
  },
  {
    id: 342,
    name: "Boukram",
    wilaya_id: 10,
    zip_code: "10034",
    wilaya: {
      id: 10,
      name: "Bouira",
    },
  },
  {
    id: 343,
    name: "Aïn Bessem",
    wilaya_id: 10,
    zip_code: "10035",
    wilaya: {
      id: 10,
      name: "Bouira",
    },
  },
  {
    id: 344,
    name: "Bir Ghbalou",
    wilaya_id: 10,
    zip_code: "10036",
    wilaya: {
      id: 10,
      name: "Bouira",
    },
  },
  {
    id: 345,
    name: "Maamora",
    wilaya_id: 10,
    zip_code: "10037",
    wilaya: {
      id: 10,
      name: "Bouira",
    },
  },
  {
    id: 346,
    name: "Sour El Ghouzlane",
    wilaya_id: 10,
    zip_code: "10038",
    wilaya: {
      id: 10,
      name: "Bouira",
    },
  },
  {
    id: 347,
    name: "Maala",
    wilaya_id: 10,
    zip_code: "10039",
    wilaya: {
      id: 10,
      name: "Bouira",
    },
  },
  {
    id: 348,
    name: "Ouled Rached",
    wilaya_id: 10,
    zip_code: "10040",
    wilaya: {
      id: 10,
      name: "Bouira",
    },
  },
  {
    id: 349,
    name: "Aïn Laloui",
    wilaya_id: 10,
    zip_code: "10041",
    wilaya: {
      id: 10,
      name: "Bouira",
    },
  },
  {
    id: 350,
    name: "Hadjera Zerga",
    wilaya_id: 10,
    zip_code: "10042",
    wilaya: {
      id: 10,
      name: "Bouira",
    },
  },
  {
    id: 351,
    name: "Ath Mansour",
    wilaya_id: 10,
    zip_code: "10043",
    wilaya: {
      id: 10,
      name: "Bouira",
    },
  },
  {
    id: 352,
    name: "El Mokrani",
    wilaya_id: 10,
    zip_code: "10044",
    wilaya: {
      id: 10,
      name: "Bouira",
    },
  },
  {
    id: 353,
    name: "Oued El Berdi",
    wilaya_id: 10,
    zip_code: "10045",
    wilaya: {
      id: 10,
      name: "Bouira",
    },
  },
  {
    id: 354,
    name: "Tamanrasset",
    wilaya_id: 11,
    zip_code: "11001",
    wilaya: {
      id: 11,
      name: "Tamanrasset",
    },
  },
  {
    id: 355,
    name: "Abalessa",
    wilaya_id: 11,
    zip_code: "11002",
    wilaya: {
      id: 11,
      name: "Tamanrasset",
    },
  },
  {
    id: 356,
    name: "In Ghar",
    wilaya_id: 53,
    zip_code: "11003",
    wilaya: {
      id: 53,
      name: "In Salah",
    },
  },
  {
    id: 357,
    name: "In Guezzam",
    wilaya_id: 54,
    zip_code: "11004",
    wilaya: {
      id: 54,
      name: "In Guezzam",
    },
  },
  {
    id: 358,
    name: "Idles",
    wilaya_id: 11,
    zip_code: "11005",
    wilaya: {
      id: 11,
      name: "Tamanrasset",
    },
  },
  {
    id: 359,
    name: "Tazrouk",
    wilaya_id: 11,
    zip_code: "11006",
    wilaya: {
      id: 11,
      name: "Tamanrasset",
    },
  },
  {
    id: 360,
    name: "Tin Zaouatine",
    wilaya_id: 54,
    zip_code: "11007",
    wilaya: {
      id: 54,
      name: "In Guezzam",
    },
  },
  {
    id: 361,
    name: "In Salah",
    wilaya_id: 53,
    zip_code: "11008",
    wilaya: {
      id: 53,
      name: "In Salah",
    },
  },
  {
    id: 362,
    name: "In Amguel",
    wilaya_id: 11,
    zip_code: "11009",
    wilaya: {
      id: 11,
      name: "Tamanrasset",
    },
  },
  {
    id: 363,
    name: "Foggaret Ezzaouia",
    wilaya_id: 53,
    zip_code: "11010",
    wilaya: {
      id: 53,
      name: "In Salah",
    },
  },
  {
    id: 364,
    name: "Tébessa",
    wilaya_id: 12,
    zip_code: "12001",
    wilaya: {
      id: 12,
      name: "Tébessa",
    },
  },
  {
    id: 365,
    name: "Bir El Ater",
    wilaya_id: 12,
    zip_code: "12002",
    wilaya: {
      id: 12,
      name: "Tébessa",
    },
  },
  {
    id: 366,
    name: "Cheria",
    wilaya_id: 12,
    zip_code: "12003",
    wilaya: {
      id: 12,
      name: "Tébessa",
    },
  },
  {
    id: 367,
    name: "Stah Guentis",
    wilaya_id: 12,
    zip_code: "12004",
    wilaya: {
      id: 12,
      name: "Tébessa",
    },
  },
  {
    id: 368,
    name: "El Aouinet",
    wilaya_id: 12,
    zip_code: "12005",
    wilaya: {
      id: 12,
      name: "Tébessa",
    },
  },
  {
    id: 369,
    name: "El Houidjbet",
    wilaya_id: 12,
    zip_code: "12006",
    wilaya: {
      id: 12,
      name: "Tébessa",
    },
  },
  {
    id: 370,
    name: "Safsaf El Ouesra",
    wilaya_id: 12,
    zip_code: "12007",
    wilaya: {
      id: 12,
      name: "Tébessa",
    },
  },
  {
    id: 371,
    name: "Hammamet",
    wilaya_id: 12,
    zip_code: "12008",
    wilaya: {
      id: 12,
      name: "Tébessa",
    },
  },
  {
    id: 372,
    name: "Negrine",
    wilaya_id: 12,
    zip_code: "12009",
    wilaya: {
      id: 12,
      name: "Tébessa",
    },
  },
  {
    id: 373,
    name: "Bir Mokkadem",
    wilaya_id: 12,
    zip_code: "12010",
    wilaya: {
      id: 12,
      name: "Tébessa",
    },
  },
  {
    id: 374,
    name: "El Kouif",
    wilaya_id: 12,
    zip_code: "12011",
    wilaya: {
      id: 12,
      name: "Tébessa",
    },
  },
  {
    id: 375,
    name: "Morsott",
    wilaya_id: 12,
    zip_code: "12012",
    wilaya: {
      id: 12,
      name: "Tébessa",
    },
  },
  {
    id: 376,
    name: "El Ogla",
    wilaya_id: 12,
    zip_code: "12013",
    wilaya: {
      id: 12,
      name: "Tébessa",
    },
  },
  {
    id: 377,
    name: "Bir Dheb",
    wilaya_id: 12,
    zip_code: "12014",
    wilaya: {
      id: 12,
      name: "Tébessa",
    },
  },
  {
    id: 378,
    name: "Ogla Melha",
    wilaya_id: 12,
    zip_code: "12015",
    wilaya: {
      id: 12,
      name: "Tébessa",
    },
  },
  {
    id: 379,
    name: "Guorriguer",
    wilaya_id: 12,
    zip_code: "12016",
    wilaya: {
      id: 12,
      name: "Tébessa",
    },
  },
  {
    id: 380,
    name: "Bekkaria",
    wilaya_id: 12,
    zip_code: "12017",
    wilaya: {
      id: 12,
      name: "Tébessa",
    },
  },
  {
    id: 381,
    name: "Boukhadra",
    wilaya_id: 12,
    zip_code: "12018",
    wilaya: {
      id: 12,
      name: "Tébessa",
    },
  },
  {
    id: 382,
    name: "Ouenza",
    wilaya_id: 12,
    zip_code: "12019",
    wilaya: {
      id: 12,
      name: "Tébessa",
    },
  },
  {
    id: 383,
    name: "El Ma Labiodh",
    wilaya_id: 12,
    zip_code: "12020",
    wilaya: {
      id: 12,
      name: "Tébessa",
    },
  },
  {
    id: 384,
    name: "Oum Ali",
    wilaya_id: 12,
    zip_code: "12021",
    wilaya: {
      id: 12,
      name: "Tébessa",
    },
  },
  {
    id: 385,
    name: "Tlidjene",
    wilaya_id: 12,
    zip_code: "12022",
    wilaya: {
      id: 12,
      name: "Tébessa",
    },
  },
  {
    id: 386,
    name: "Aïn Zerga",
    wilaya_id: 12,
    zip_code: "12023",
    wilaya: {
      id: 12,
      name: "Tébessa",
    },
  },
  {
    id: 387,
    name: "El Meridj",
    wilaya_id: 12,
    zip_code: "12024",
    wilaya: {
      id: 12,
      name: "Tébessa",
    },
  },
  {
    id: 388,
    name: "Boulhaf Dir",
    wilaya_id: 12,
    zip_code: "12025",
    wilaya: {
      id: 12,
      name: "Tébessa",
    },
  },
  {
    id: 389,
    name: "Bedjene",
    wilaya_id: 12,
    zip_code: "12026",
    wilaya: {
      id: 12,
      name: "Tébessa",
    },
  },
  {
    id: 390,
    name: "El Mezeraa",
    wilaya_id: 12,
    zip_code: "12027",
    wilaya: {
      id: 12,
      name: "Tébessa",
    },
  },
  {
    id: 391,
    name: "Ferkane",
    wilaya_id: 12,
    zip_code: "12028",
    wilaya: {
      id: 12,
      name: "Tébessa",
    },
  },
  {
    id: 392,
    name: "Tlemcen",
    wilaya_id: 13,
    zip_code: "13001",
    wilaya: {
      id: 13,
      name: "Tlemcen",
    },
  },
  {
    id: 393,
    name: "Beni Mester",
    wilaya_id: 13,
    zip_code: "13002",
    wilaya: {
      id: 13,
      name: "Tlemcen",
    },
  },
  {
    id: 394,
    name: "Aïn Tallout",
    wilaya_id: 13,
    zip_code: "13003",
    wilaya: {
      id: 13,
      name: "Tlemcen",
    },
  },
  {
    id: 395,
    name: "Remchi",
    wilaya_id: 13,
    zip_code: "13004",
    wilaya: {
      id: 13,
      name: "Tlemcen",
    },
  },
  {
    id: 396,
    name: "El Fehoul",
    wilaya_id: 13,
    zip_code: "13005",
    wilaya: {
      id: 13,
      name: "Tlemcen",
    },
  },
  {
    id: 397,
    name: "Sabra",
    wilaya_id: 13,
    zip_code: "13006",
    wilaya: {
      id: 13,
      name: "Tlemcen",
    },
  },
  {
    id: 398,
    name: "Ghazaouet",
    wilaya_id: 13,
    zip_code: "13007",
    wilaya: {
      id: 13,
      name: "Tlemcen",
    },
  },
  {
    id: 399,
    name: "Souani",
    wilaya_id: 13,
    zip_code: "13008",
    wilaya: {
      id: 13,
      name: "Tlemcen",
    },
  },
  {
    id: 400,
    name: "Djebala",
    wilaya_id: 13,
    zip_code: "13009",
    wilaya: {
      id: 13,
      name: "Tlemcen",
    },
  },
  {
    id: 401,
    name: "El Gor",
    wilaya_id: 13,
    zip_code: "13010",
    wilaya: {
      id: 13,
      name: "Tlemcen",
    },
  },
  {
    id: 402,
    name: "Oued Lakhdar",
    wilaya_id: 13,
    zip_code: "13011",
    wilaya: {
      id: 13,
      name: "Tlemcen",
    },
  },
  {
    id: 403,
    name: "Aïn Fezza",
    wilaya_id: 13,
    zip_code: "13012",
    wilaya: {
      id: 13,
      name: "Tlemcen",
    },
  },
  {
    id: 404,
    name: "Ouled Mimoun",
    wilaya_id: 13,
    zip_code: "13013",
    wilaya: {
      id: 13,
      name: "Tlemcen",
    },
  },
  {
    id: 405,
    name: "Amieur",
    wilaya_id: 13,
    zip_code: "13014",
    wilaya: {
      id: 13,
      name: "Tlemcen",
    },
  },
  {
    id: 406,
    name: "Aïn Youcef",
    wilaya_id: 13,
    zip_code: "13015",
    wilaya: {
      id: 13,
      name: "Tlemcen",
    },
  },
  {
    id: 407,
    name: "Zenata",
    wilaya_id: 13,
    zip_code: "13016",
    wilaya: {
      id: 13,
      name: "Tlemcen",
    },
  },
  {
    id: 408,
    name: "Beni Snous",
    wilaya_id: 13,
    zip_code: "13017",
    wilaya: {
      id: 13,
      name: "Tlemcen",
    },
  },
  {
    id: 409,
    name: "Bab El Assa",
    wilaya_id: 13,
    zip_code: "13018",
    wilaya: {
      id: 13,
      name: "Tlemcen",
    },
  },
  {
    id: 410,
    name: "Dar Yaghmouracene",
    wilaya_id: 13,
    zip_code: "13019",
    wilaya: {
      id: 13,
      name: "Tlemcen",
    },
  },
  {
    id: 411,
    name: "Fellaoucene",
    wilaya_id: 13,
    zip_code: "13020",
    wilaya: {
      id: 13,
      name: "Tlemcen",
    },
  },
  {
    id: 412,
    name: "Azails",
    wilaya_id: 13,
    zip_code: "13021",
    wilaya: {
      id: 13,
      name: "Tlemcen",
    },
  },
  {
    id: 413,
    name: "Sebaa Chioukh",
    wilaya_id: 13,
    zip_code: "13022",
    wilaya: {
      id: 13,
      name: "Tlemcen",
    },
  },
  {
    id: 414,
    name: "Terny Beni Hdiel",
    wilaya_id: 13,
    zip_code: "13023",
    wilaya: {
      id: 13,
      name: "Tlemcen",
    },
  },
  {
    id: 415,
    name: "Bensekrane",
    wilaya_id: 13,
    zip_code: "13024",
    wilaya: {
      id: 13,
      name: "Tlemcen",
    },
  },
  {
    id: 416,
    name: "Aïn Nehala",
    wilaya_id: 13,
    zip_code: "13025",
    wilaya: {
      id: 13,
      name: "Tlemcen",
    },
  },
  {
    id: 417,
    name: "Hennaya",
    wilaya_id: 13,
    zip_code: "13026",
    wilaya: {
      id: 13,
      name: "Tlemcen",
    },
  },
  {
    id: 418,
    name: "Maghnia",
    wilaya_id: 13,
    zip_code: "13027",
    wilaya: {
      id: 13,
      name: "Tlemcen",
    },
  },
  {
    id: 419,
    name: "Hammam Boughrara",
    wilaya_id: 13,
    zip_code: "13028",
    wilaya: {
      id: 13,
      name: "Tlemcen",
    },
  },
  {
    id: 420,
    name: "Souahlia",
    wilaya_id: 13,
    zip_code: "13029",
    wilaya: {
      id: 13,
      name: "Tlemcen",
    },
  },
  {
    id: 421,
    name: "Msirda Fouaga",
    wilaya_id: 13,
    zip_code: "13030",
    wilaya: {
      id: 13,
      name: "Tlemcen",
    },
  },
  {
    id: 422,
    name: "Aïn Fetah",
    wilaya_id: 13,
    zip_code: "13031",
    wilaya: {
      id: 13,
      name: "Tlemcen",
    },
  },
  {
    id: 423,
    name: "El Aricha",
    wilaya_id: 13,
    zip_code: "13032",
    wilaya: {
      id: 13,
      name: "Tlemcen",
    },
  },
  {
    id: 424,
    name: "Souk Tlata",
    wilaya_id: 13,
    zip_code: "13033",
    wilaya: {
      id: 13,
      name: "Tlemcen",
    },
  },
  {
    id: 425,
    name: "Sidi Abdelli",
    wilaya_id: 13,
    zip_code: "13034",
    wilaya: {
      id: 13,
      name: "Tlemcen",
    },
  },
  {
    id: 426,
    name: "Sebdou",
    wilaya_id: 13,
    zip_code: "13035",
    wilaya: {
      id: 13,
      name: "Tlemcen",
    },
  },
  {
    id: 427,
    name: "Beni Ouarsous",
    wilaya_id: 13,
    zip_code: "13036",
    wilaya: {
      id: 13,
      name: "Tlemcen",
    },
  },
  {
    id: 428,
    name: "Sidi Medjahed",
    wilaya_id: 13,
    zip_code: "13037",
    wilaya: {
      id: 13,
      name: "Tlemcen",
    },
  },
  {
    id: 429,
    name: "Beni Boussaid",
    wilaya_id: 13,
    zip_code: "13038",
    wilaya: {
      id: 13,
      name: "Tlemcen",
    },
  },
  {
    id: 430,
    name: "Marsa Ben M'Hidi",
    wilaya_id: 13,
    zip_code: "13039",
    wilaya: {
      id: 13,
      name: "Tlemcen",
    },
  },
  {
    id: 431,
    name: "Nedroma",
    wilaya_id: 13,
    zip_code: "13040",
    wilaya: {
      id: 13,
      name: "Tlemcen",
    },
  },
  {
    id: 432,
    name: "Sidi Djillali",
    wilaya_id: 13,
    zip_code: "13041",
    wilaya: {
      id: 13,
      name: "Tlemcen",
    },
  },
  {
    id: 433,
    name: "Beni Bahdel",
    wilaya_id: 13,
    zip_code: "13042",
    wilaya: {
      id: 13,
      name: "Tlemcen",
    },
  },
  {
    id: 434,
    name: "El Bouihi",
    wilaya_id: 13,
    zip_code: "13043",
    wilaya: {
      id: 13,
      name: "Tlemcen",
    },
  },
  {
    id: 435,
    name: "Honaïne",
    wilaya_id: 13,
    zip_code: "13044",
    wilaya: {
      id: 13,
      name: "Tlemcen",
    },
  },
  {
    id: 436,
    name: "Tienet",
    wilaya_id: 13,
    zip_code: "13045",
    wilaya: {
      id: 13,
      name: "Tlemcen",
    },
  },
  {
    id: 437,
    name: "Ouled Riyah",
    wilaya_id: 13,
    zip_code: "13046",
    wilaya: {
      id: 13,
      name: "Tlemcen",
    },
  },
  {
    id: 438,
    name: "Bouhlou",
    wilaya_id: 13,
    zip_code: "13047",
    wilaya: {
      id: 13,
      name: "Tlemcen",
    },
  },
  {
    id: 439,
    name: "Souk El Khemis",
    wilaya_id: 13,
    zip_code: "13048",
    wilaya: {
      id: 13,
      name: "Tlemcen",
    },
  },
  {
    id: 440,
    name: "Aïn Ghoraba",
    wilaya_id: 13,
    zip_code: "13049",
    wilaya: {
      id: 13,
      name: "Tlemcen",
    },
  },
  {
    id: 441,
    name: "Chetouane",
    wilaya_id: 13,
    zip_code: "13050",
    wilaya: {
      id: 13,
      name: "Tlemcen",
    },
  },
  {
    id: 442,
    name: "Mansourah",
    wilaya_id: 13,
    zip_code: "13051",
    wilaya: {
      id: 13,
      name: "Tlemcen",
    },
  },
  {
    id: 443,
    name: "Beni Semiel",
    wilaya_id: 13,
    zip_code: "13052",
    wilaya: {
      id: 13,
      name: "Tlemcen",
    },
  },
  {
    id: 444,
    name: "Aïn Kebira",
    wilaya_id: 13,
    zip_code: "13053",
    wilaya: {
      id: 13,
      name: "Tlemcen",
    },
  },
  {
    id: 445,
    name: "Tiaret",
    wilaya_id: 14,
    zip_code: "14001",
    wilaya: {
      id: 14,
      name: "Tiaret",
    },
  },
  {
    id: 446,
    name: "Medroussa",
    wilaya_id: 14,
    zip_code: "14002",
    wilaya: {
      id: 14,
      name: "Tiaret",
    },
  },
  {
    id: 447,
    name: "Aïn Bouchekif",
    wilaya_id: 14,
    zip_code: "14003",
    wilaya: {
      id: 14,
      name: "Tiaret",
    },
  },
  {
    id: 448,
    name: "Sidi Ali Mellal",
    wilaya_id: 14,
    zip_code: "14004",
    wilaya: {
      id: 14,
      name: "Tiaret",
    },
  },
  {
    id: 449,
    name: "Aïn Kermes",
    wilaya_id: 14,
    zip_code: "14005",
    wilaya: {
      id: 14,
      name: "Tiaret",
    },
  },
  {
    id: 450,
    name: "Aïn Deheb",
    wilaya_id: 14,
    zip_code: "14006",
    wilaya: {
      id: 14,
      name: "Tiaret",
    },
  },
  {
    id: 451,
    name: "Sidi Bakhti",
    wilaya_id: 14,
    zip_code: "14007",
    wilaya: {
      id: 14,
      name: "Tiaret",
    },
  },
  {
    id: 452,
    name: "Medrissa",
    wilaya_id: 14,
    zip_code: "14008",
    wilaya: {
      id: 14,
      name: "Tiaret",
    },
  },
  {
    id: 453,
    name: "Zmalet El Emir Abdelkader",
    wilaya_id: 14,
    zip_code: "14009",
    wilaya: {
      id: 14,
      name: "Tiaret",
    },
  },
  {
    id: 454,
    name: "Madna",
    wilaya_id: 14,
    zip_code: "14010",
    wilaya: {
      id: 14,
      name: "Tiaret",
    },
  },
  {
    id: 455,
    name: "Sebt",
    wilaya_id: 14,
    zip_code: "14011",
    wilaya: {
      id: 14,
      name: "Tiaret",
    },
  },
  {
    id: 456,
    name: "Mellakou",
    wilaya_id: 14,
    zip_code: "14012",
    wilaya: {
      id: 14,
      name: "Tiaret",
    },
  },
  {
    id: 457,
    name: "Dahmouni",
    wilaya_id: 14,
    zip_code: "14013",
    wilaya: {
      id: 14,
      name: "Tiaret",
    },
  },
  {
    id: 458,
    name: "Rahouia",
    wilaya_id: 14,
    zip_code: "14014",
    wilaya: {
      id: 14,
      name: "Tiaret",
    },
  },
  {
    id: 459,
    name: "Mahdia",
    wilaya_id: 14,
    zip_code: "14015",
    wilaya: {
      id: 14,
      name: "Tiaret",
    },
  },
  {
    id: 460,
    name: "Sougueur",
    wilaya_id: 14,
    zip_code: "14016",
    wilaya: {
      id: 14,
      name: "Tiaret",
    },
  },
  {
    id: 461,
    name: "Si Abdelghani",
    wilaya_id: 14,
    zip_code: "14017",
    wilaya: {
      id: 14,
      name: "Tiaret",
    },
  },
  {
    id: 462,
    name: "Aïn Dzarit",
    wilaya_id: 14,
    zip_code: "14018",
    wilaya: {
      id: 14,
      name: "Tiaret",
    },
  },
  {
    id: 463,
    name: "Djillali Ben Amar",
    wilaya_id: 14,
    zip_code: "14019",
    wilaya: {
      id: 14,
      name: "Tiaret",
    },
  },
  {
    id: 464,
    name: "Naima",
    wilaya_id: 14,
    zip_code: "14020",
    wilaya: {
      id: 14,
      name: "Tiaret",
    },
  },
  {
    id: 465,
    name: "Meghila",
    wilaya_id: 14,
    zip_code: "14021",
    wilaya: {
      id: 14,
      name: "Tiaret",
    },
  },
  {
    id: 466,
    name: "Guertoufa",
    wilaya_id: 14,
    zip_code: "14022",
    wilaya: {
      id: 14,
      name: "Tiaret",
    },
  },
  {
    id: 467,
    name: "Sidi Hosni",
    wilaya_id: 14,
    zip_code: "14023",
    wilaya: {
      id: 14,
      name: "Tiaret",
    },
  },
  {
    id: 468,
    name: "Djebilet Rosfa",
    wilaya_id: 14,
    zip_code: "14024",
    wilaya: {
      id: 14,
      name: "Tiaret",
    },
  },
  {
    id: 469,
    name: "Sebaine",
    wilaya_id: 14,
    zip_code: "14025",
    wilaya: {
      id: 14,
      name: "Tiaret",
    },
  },
  {
    id: 470,
    name: "Tousnina",
    wilaya_id: 14,
    zip_code: "14026",
    wilaya: {
      id: 14,
      name: "Tiaret",
    },
  },
  {
    id: 471,
    name: "Frenda",
    wilaya_id: 14,
    zip_code: "14027",
    wilaya: {
      id: 14,
      name: "Tiaret",
    },
  },
  {
    id: 472,
    name: "Aïn El Hadid",
    wilaya_id: 14,
    zip_code: "14028",
    wilaya: {
      id: 14,
      name: "Tiaret",
    },
  },
  {
    id: 473,
    name: "Ksar Chellala",
    wilaya_id: 14,
    zip_code: "14029",
    wilaya: {
      id: 14,
      name: "Tiaret",
    },
  },
  {
    id: 474,
    name: "Rechaiga",
    wilaya_id: 14,
    zip_code: "14030",
    wilaya: {
      id: 14,
      name: "Tiaret",
    },
  },
  {
    id: 475,
    name: "Nadorah",
    wilaya_id: 14,
    zip_code: "14031",
    wilaya: {
      id: 14,
      name: "Tiaret",
    },
  },
  {
    id: 476,
    name: "Tagdemt",
    wilaya_id: 14,
    zip_code: "14032",
    wilaya: {
      id: 14,
      name: "Tiaret",
    },
  },
  {
    id: 477,
    name: "Oued Lilli",
    wilaya_id: 14,
    zip_code: "14033",
    wilaya: {
      id: 14,
      name: "Tiaret",
    },
  },
  {
    id: 478,
    name: "Mechraa Safa",
    wilaya_id: 14,
    zip_code: "14034",
    wilaya: {
      id: 14,
      name: "Tiaret",
    },
  },
  {
    id: 479,
    name: "Hamadia",
    wilaya_id: 14,
    zip_code: "14035",
    wilaya: {
      id: 14,
      name: "Tiaret",
    },
  },
  {
    id: 480,
    name: "Chehaima",
    wilaya_id: 14,
    zip_code: "14036",
    wilaya: {
      id: 14,
      name: "Tiaret",
    },
  },
  {
    id: 481,
    name: "Takhemaret",
    wilaya_id: 14,
    zip_code: "14037",
    wilaya: {
      id: 14,
      name: "Tiaret",
    },
  },
  {
    id: 482,
    name: "Sidi Abderrahmane",
    wilaya_id: 14,
    zip_code: "14038",
    wilaya: {
      id: 14,
      name: "Tiaret",
    },
  },
  {
    id: 483,
    name: "Serghine",
    wilaya_id: 14,
    zip_code: "14039",
    wilaya: {
      id: 14,
      name: "Tiaret",
    },
  },
  {
    id: 484,
    name: "Bougara",
    wilaya_id: 14,
    zip_code: "14040",
    wilaya: {
      id: 14,
      name: "Tiaret",
    },
  },
  {
    id: 485,
    name: "Faidja",
    wilaya_id: 14,
    zip_code: "14041",
    wilaya: {
      id: 14,
      name: "Tiaret",
    },
  },
  {
    id: 486,
    name: "Tidda",
    wilaya_id: 14,
    zip_code: "14042",
    wilaya: {
      id: 14,
      name: "Tiaret",
    },
  },
  {
    id: 487,
    name: "Tizi Ouzou",
    wilaya_id: 15,
    zip_code: "15001",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 488,
    name: "Ain El Hammam",
    wilaya_id: 15,
    zip_code: "15002",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 489,
    name: "Akbil",
    wilaya_id: 15,
    zip_code: "15003",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 490,
    name: "Freha",
    wilaya_id: 15,
    zip_code: "15004",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 491,
    name: "Souamaâ",
    wilaya_id: 15,
    zip_code: "15005",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 492,
    name: "Mechtras",
    wilaya_id: 15,
    zip_code: "15006",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 493,
    name: "Irdjen",
    wilaya_id: 15,
    zip_code: "15007",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 494,
    name: "Timizart",
    wilaya_id: 15,
    zip_code: "15008",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 495,
    name: "Makouda",
    wilaya_id: 15,
    zip_code: "15009",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 496,
    name: "Draâ El Mizan",
    wilaya_id: 15,
    zip_code: "15010",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 497,
    name: "Tizi Gheniff",
    wilaya_id: 15,
    zip_code: "15011",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 498,
    name: "Bounouh",
    wilaya_id: 15,
    zip_code: "15012",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 499,
    name: "Aït Chafâa",
    wilaya_id: 15,
    zip_code: "15013",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 500,
    name: "Frikat",
    wilaya_id: 15,
    zip_code: "15014",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 501,
    name: "Beni Aïssi",
    wilaya_id: 15,
    zip_code: "15015",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 502,
    name: "Beni Zmenzer",
    wilaya_id: 15,
    zip_code: "15016",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 503,
    name: "Iferhounène",
    wilaya_id: 15,
    zip_code: "15017",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 504,
    name: "Azazga",
    wilaya_id: 15,
    zip_code: "15018",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 505,
    name: "Illoula Oumalou",
    wilaya_id: 15,
    zip_code: "15019",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 506,
    name: "Yakouren",
    wilaya_id: 15,
    zip_code: "15020",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 507,
    name: "Larbaâ Nath Irathen",
    wilaya_id: 15,
    zip_code: "15021",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 508,
    name: "Tizi Rached",
    wilaya_id: 15,
    zip_code: "15022",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 509,
    name: "Zekri",
    wilaya_id: 15,
    zip_code: "15023",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 510,
    name: "Ouaguenoun",
    wilaya_id: 15,
    zip_code: "15024",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 511,
    name: "Aïn Zaouia",
    wilaya_id: 15,
    zip_code: "15025",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 512,
    name: "M'Kira",
    wilaya_id: 15,
    zip_code: "15026",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 513,
    name: "Aït Yahia",
    wilaya_id: 15,
    zip_code: "15027",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 514,
    name: "Aït Mahmoud",
    wilaya_id: 15,
    zip_code: "15028",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 515,
    name: "Mâatkas",
    wilaya_id: 15,
    zip_code: "15029",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 516,
    name: "Aït Boumahdi",
    wilaya_id: 15,
    zip_code: "15030",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 517,
    name: "Abi Youcef",
    wilaya_id: 15,
    zip_code: "15031",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 518,
    name: "Beni Douala",
    wilaya_id: 15,
    zip_code: "15032",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 519,
    name: "Illilten",
    wilaya_id: 15,
    zip_code: "15033",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 520,
    name: "Bouzguen",
    wilaya_id: 15,
    zip_code: "15034",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 521,
    name: "Aït Aggouacha",
    wilaya_id: 15,
    zip_code: "15035",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 522,
    name: "Ouadhia",
    wilaya_id: 15,
    zip_code: "15036",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 523,
    name: "Azeffoun",
    wilaya_id: 15,
    zip_code: "15037",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 524,
    name: "Tigzirt",
    wilaya_id: 15,
    zip_code: "15038",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 525,
    name: "Aït Aïssa Mimoun",
    wilaya_id: 15,
    zip_code: "15039",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 526,
    name: "Boghni",
    wilaya_id: 15,
    zip_code: "15040",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 527,
    name: "Ifigha",
    wilaya_id: 15,
    zip_code: "15041",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 528,
    name: "Aït Oumalou",
    wilaya_id: 15,
    zip_code: "15042",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 529,
    name: "Tirmitine",
    wilaya_id: 15,
    zip_code: "15043",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 530,
    name: "Akerrou",
    wilaya_id: 15,
    zip_code: "15044",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 531,
    name: "Yatafen",
    wilaya_id: 15,
    zip_code: "15045",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 532,
    name: "Ath Zikki",
    wilaya_id: 15,
    zip_code: "15046",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 533,
    name: "Draâ Ben Khedda",
    wilaya_id: 15,
    zip_code: "15047",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 534,
    name: "Ouacif",
    wilaya_id: 15,
    zip_code: "15048",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 535,
    name: "Idjeur",
    wilaya_id: 15,
    zip_code: "15049",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 536,
    name: "Mekla",
    wilaya_id: 15,
    zip_code: "15050",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 537,
    name: "Tizi N'Tleta",
    wilaya_id: 15,
    zip_code: "15051",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 538,
    name: "Aït Yenni",
    wilaya_id: 15,
    zip_code: "15052",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 539,
    name: "Aghribs",
    wilaya_id: 15,
    zip_code: "15053",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 540,
    name: "Iflissen",
    wilaya_id: 15,
    zip_code: "15054",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 541,
    name: "Boudjima",
    wilaya_id: 15,
    zip_code: "15055",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 542,
    name: "Aït Yahia Moussa",
    wilaya_id: 15,
    zip_code: "15056",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 543,
    name: "Souk El Thenine",
    wilaya_id: 15,
    zip_code: "15057",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 544,
    name: "Aït Khellili",
    wilaya_id: 15,
    zip_code: "15058",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 545,
    name: "Sidi Namane",
    wilaya_id: 15,
    zip_code: "15059",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 546,
    name: "Iboudraren",
    wilaya_id: 15,
    zip_code: "15060",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 547,
    name: "Agouni Gueghrane",
    wilaya_id: 15,
    zip_code: "15061",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 548,
    name: "Mizrana",
    wilaya_id: 15,
    zip_code: "15062",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 549,
    name: "Imsouhel",
    wilaya_id: 15,
    zip_code: "15063",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 550,
    name: "Tadmaït",
    wilaya_id: 15,
    zip_code: "15064",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 551,
    name: "Aït Bouadou",
    wilaya_id: 15,
    zip_code: "15065",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 552,
    name: "Assi Youcef",
    wilaya_id: 15,
    zip_code: "15066",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 553,
    name: "Aït Toudert",
    wilaya_id: 15,
    zip_code: "15067",
    wilaya: {
      id: 15,
      name: "Tizi Ouzou",
    },
  },
  {
    id: 554,
    name: "Alger Centre",
    wilaya_id: 16,
    zip_code: "16001",
    wilaya: {
      id: 16,
      name: "Alger",
    },
  },
  {
    id: 555,
    name: "Sidi M'Hamed",
    wilaya_id: 16,
    zip_code: "16002",
    wilaya: {
      id: 16,
      name: "Alger",
    },
  },
  {
    id: 556,
    name: "El Madania",
    wilaya_id: 16,
    zip_code: "16003",
    wilaya: {
      id: 16,
      name: "Alger",
    },
  },
  {
    id: 557,
    name: "Belouizdad",
    wilaya_id: 16,
    zip_code: "16004",
    wilaya: {
      id: 16,
      name: "Alger",
    },
  },
  {
    id: 558,
    name: "Bab El Oued",
    wilaya_id: 16,
    zip_code: "16005",
    wilaya: {
      id: 16,
      name: "Alger",
    },
  },
  {
    id: 559,
    name: "Bologhine",
    wilaya_id: 16,
    zip_code: "16006",
    wilaya: {
      id: 16,
      name: "Alger",
    },
  },
  {
    id: 560,
    name: "Casbah",
    wilaya_id: 16,
    zip_code: "16007",
    wilaya: {
      id: 16,
      name: "Alger",
    },
  },
  {
    id: 561,
    name: "Oued Koriche",
    wilaya_id: 16,
    zip_code: "16008",
    wilaya: {
      id: 16,
      name: "Alger",
    },
  },
  {
    id: 562,
    name: "Bir Mourad Raïs",
    wilaya_id: 16,
    zip_code: "16009",
    wilaya: {
      id: 16,
      name: "Alger",
    },
  },
  {
    id: 563,
    name: "El Biar",
    wilaya_id: 16,
    zip_code: "16010",
    wilaya: {
      id: 16,
      name: "Alger",
    },
  },
  {
    id: 564,
    name: "Bouzareah",
    wilaya_id: 16,
    zip_code: "16011",
    wilaya: {
      id: 16,
      name: "Alger",
    },
  },
  {
    id: 565,
    name: "Birkhadem",
    wilaya_id: 16,
    zip_code: "16012",
    wilaya: {
      id: 16,
      name: "Alger",
    },
  },
  {
    id: 566,
    name: "El Harrach",
    wilaya_id: 16,
    zip_code: "16013",
    wilaya: {
      id: 16,
      name: "Alger",
    },
  },
  {
    id: 567,
    name: "Baraki",
    wilaya_id: 16,
    zip_code: "16014",
    wilaya: {
      id: 16,
      name: "Alger",
    },
  },
  {
    id: 568,
    name: "Oued Smar",
    wilaya_id: 16,
    zip_code: "16015",
    wilaya: {
      id: 16,
      name: "Alger",
    },
  },
  {
    id: 569,
    name: "Bourouba",
    wilaya_id: 16,
    zip_code: "16016",
    wilaya: {
      id: 16,
      name: "Alger",
    },
  },
  {
    id: 570,
    name: "Hussein Dey",
    wilaya_id: 16,
    zip_code: "16017",
    wilaya: {
      id: 16,
      name: "Alger",
    },
  },
  {
    id: 571,
    name: "Kouba",
    wilaya_id: 16,
    zip_code: "16018",
    wilaya: {
      id: 16,
      name: "Alger",
    },
  },
  {
    id: 572,
    name: "Bachdjerrah",
    wilaya_id: 16,
    zip_code: "16019",
    wilaya: {
      id: 16,
      name: "Alger",
    },
  },
  {
    id: 573,
    name: "Dar El Beïda",
    wilaya_id: 16,
    zip_code: "16020",
    wilaya: {
      id: 16,
      name: "Alger",
    },
  },
  {
    id: 574,
    name: "Bab Ezzouar",
    wilaya_id: 16,
    zip_code: "16021",
    wilaya: {
      id: 16,
      name: "Alger",
    },
  },
  {
    id: 575,
    name: "Ben Aknoun",
    wilaya_id: 16,
    zip_code: "16022",
    wilaya: {
      id: 16,
      name: "Alger",
    },
  },
  {
    id: 576,
    name: "Dely Ibrahim",
    wilaya_id: 16,
    zip_code: "16023",
    wilaya: {
      id: 16,
      name: "Alger",
    },
  },
  {
    id: 577,
    name: "El Hammamet",
    wilaya_id: 16,
    zip_code: "16024",
    wilaya: {
      id: 16,
      name: "Alger",
    },
  },
  {
    id: 578,
    name: "Raïs Hamidou",
    wilaya_id: 16,
    zip_code: "16025",
    wilaya: {
      id: 16,
      name: "Alger",
    },
  },
  {
    id: 579,
    name: "Djasr Kasentina",
    wilaya_id: 16,
    zip_code: "16026",
    wilaya: {
      id: 16,
      name: "Alger",
    },
  },
  {
    id: 580,
    name: "El Mouradia",
    wilaya_id: 16,
    zip_code: "16027",
    wilaya: {
      id: 16,
      name: "Alger",
    },
  },
  {
    id: 581,
    name: "Hydra",
    wilaya_id: 16,
    zip_code: "16028",
    wilaya: {
      id: 16,
      name: "Alger",
    },
  },
  {
    id: 582,
    name: "Mohammadia",
    wilaya_id: 16,
    zip_code: "16029",
    wilaya: {
      id: 16,
      name: "Alger",
    },
  },
  {
    id: 583,
    name: "Bordj El Kiffan",
    wilaya_id: 16,
    zip_code: "16030",
    wilaya: {
      id: 16,
      name: "Alger",
    },
  },
  {
    id: 584,
    name: "El Magharia",
    wilaya_id: 16,
    zip_code: "16031",
    wilaya: {
      id: 16,
      name: "Alger",
    },
  },
  {
    id: 585,
    name: "Beni Messous",
    wilaya_id: 16,
    zip_code: "16032",
    wilaya: {
      id: 16,
      name: "Alger",
    },
  },
  {
    id: 586,
    name: "Les Eucalyptus",
    wilaya_id: 16,
    zip_code: "16033",
    wilaya: {
      id: 16,
      name: "Alger",
    },
  },
  {
    id: 587,
    name: "Birtouta",
    wilaya_id: 16,
    zip_code: "16034",
    wilaya: {
      id: 16,
      name: "Alger",
    },
  },
  {
    id: 588,
    name: "Tessala El Merdja",
    wilaya_id: 16,
    zip_code: "16035",
    wilaya: {
      id: 16,
      name: "Alger",
    },
  },
  {
    id: 589,
    name: "Ouled Chebel",
    wilaya_id: 16,
    zip_code: "16036",
    wilaya: {
      id: 16,
      name: "Alger",
    },
  },
  {
    id: 590,
    name: "Sidi Moussa",
    wilaya_id: 16,
    zip_code: "16037",
    wilaya: {
      id: 16,
      name: "Alger",
    },
  },
  {
    id: 591,
    name: "Aïn Taya",
    wilaya_id: 16,
    zip_code: "16038",
    wilaya: {
      id: 16,
      name: "Alger",
    },
  },
  {
    id: 592,
    name: "Bordj El Bahri",
    wilaya_id: 16,
    zip_code: "16039",
    wilaya: {
      id: 16,
      name: "Alger",
    },
  },
  {
    id: 593,
    name: "El Marsa",
    wilaya_id: 16,
    zip_code: "16040",
    wilaya: {
      id: 16,
      name: "Alger",
    },
  },
  {
    id: 594,
    name: "H'raoua",
    wilaya_id: 16,
    zip_code: "16041",
    wilaya: {
      id: 16,
      name: "Alger",
    },
  },
  {
    id: 595,
    name: "Rouïba",
    wilaya_id: 16,
    zip_code: "16042",
    wilaya: {
      id: 16,
      name: "Alger",
    },
  },
  {
    id: 596,
    name: "Reghaïa",
    wilaya_id: 16,
    zip_code: "16043",
    wilaya: {
      id: 16,
      name: "Alger",
    },
  },
  {
    id: 597,
    name: "Aïn Benian",
    wilaya_id: 16,
    zip_code: "16044",
    wilaya: {
      id: 16,
      name: "Alger",
    },
  },
  {
    id: 598,
    name: "Staoueli",
    wilaya_id: 16,
    zip_code: "16045",
    wilaya: {
      id: 16,
      name: "Alger",
    },
  },
  {
    id: 599,
    name: "Zeralda",
    wilaya_id: 16,
    zip_code: "16046",
    wilaya: {
      id: 16,
      name: "Alger",
    },
  },
  {
    id: 600,
    name: "Mahelma",
    wilaya_id: 16,
    zip_code: "16047",
    wilaya: {
      id: 16,
      name: "Alger",
    },
  },
  {
    id: 601,
    name: "Rahmania",
    wilaya_id: 16,
    zip_code: "16048",
    wilaya: {
      id: 16,
      name: "Alger",
    },
  },
  {
    id: 602,
    name: "Souidania",
    wilaya_id: 16,
    zip_code: "16049",
    wilaya: {
      id: 16,
      name: "Alger",
    },
  },
  {
    id: 603,
    name: "Cheraga",
    wilaya_id: 16,
    zip_code: "16050",
    wilaya: {
      id: 16,
      name: "Alger",
    },
  },
  {
    id: 604,
    name: "Ouled Fayet",
    wilaya_id: 16,
    zip_code: "16051",
    wilaya: {
      id: 16,
      name: "Alger",
    },
  },
  {
    id: 605,
    name: "El Achour",
    wilaya_id: 16,
    zip_code: "16052",
    wilaya: {
      id: 16,
      name: "Alger",
    },
  },
  {
    id: 606,
    name: "Draria",
    wilaya_id: 16,
    zip_code: "16053",
    wilaya: {
      id: 16,
      name: "Alger",
    },
  },
  {
    id: 607,
    name: "Douera",
    wilaya_id: 16,
    zip_code: "16054",
    wilaya: {
      id: 16,
      name: "Alger",
    },
  },
  {
    id: 608,
    name: "Baba Hassen",
    wilaya_id: 16,
    zip_code: "16055",
    wilaya: {
      id: 16,
      name: "Alger",
    },
  },
  {
    id: 609,
    name: "Khraicia",
    wilaya_id: 16,
    zip_code: "16056",
    wilaya: {
      id: 16,
      name: "Alger",
    },
  },
  {
    id: 610,
    name: "Saoula",
    wilaya_id: 16,
    zip_code: "16057",
    wilaya: {
      id: 16,
      name: "Alger",
    },
  },
  {
    id: 611,
    name: "Djelfa",
    wilaya_id: 17,
    zip_code: "17001",
    wilaya: {
      id: 17,
      name: "Djelfa",
    },
  },
  {
    id: 612,
    name: "Moudjebara",
    wilaya_id: 17,
    zip_code: "17002",
    wilaya: {
      id: 17,
      name: "Djelfa",
    },
  },
  {
    id: 613,
    name: "El Guedid",
    wilaya_id: 17,
    zip_code: "17003",
    wilaya: {
      id: 17,
      name: "Djelfa",
    },
  },
  {
    id: 614,
    name: "Hassi Bahbah",
    wilaya_id: 17,
    zip_code: "17004",
    wilaya: {
      id: 17,
      name: "Djelfa",
    },
  },
  {
    id: 615,
    name: "Aïn Maabed",
    wilaya_id: 17,
    zip_code: "17005",
    wilaya: {
      id: 17,
      name: "Djelfa",
    },
  },
  {
    id: 616,
    name: "Sed Rahal",
    wilaya_id: 17,
    zip_code: "17006",
    wilaya: {
      id: 17,
      name: "Djelfa",
    },
  },
  {
    id: 617,
    name: "Faidh El Botma",
    wilaya_id: 17,
    zip_code: "17007",
    wilaya: {
      id: 17,
      name: "Djelfa",
    },
  },
  {
    id: 618,
    name: "Birine",
    wilaya_id: 17,
    zip_code: "17008",
    wilaya: {
      id: 17,
      name: "Djelfa",
    },
  },
  {
    id: 619,
    name: "Bouira Lahdab",
    wilaya_id: 17,
    zip_code: "17009",
    wilaya: {
      id: 17,
      name: "Djelfa",
    },
  },
  {
    id: 620,
    name: "Zaccar",
    wilaya_id: 17,
    zip_code: "17010",
    wilaya: {
      id: 17,
      name: "Djelfa",
    },
  },
  {
    id: 621,
    name: "El Khemis",
    wilaya_id: 17,
    zip_code: "17011",
    wilaya: {
      id: 17,
      name: "Djelfa",
    },
  },
  {
    id: 622,
    name: "Sidi Baizid",
    wilaya_id: 17,
    zip_code: "17012",
    wilaya: {
      id: 17,
      name: "Djelfa",
    },
  },
  {
    id: 623,
    name: "M'Liliha",
    wilaya_id: 17,
    zip_code: "17013",
    wilaya: {
      id: 17,
      name: "Djelfa",
    },
  },
  {
    id: 624,
    name: "El Idrissia",
    wilaya_id: 17,
    zip_code: "17014",
    wilaya: {
      id: 17,
      name: "Djelfa",
    },
  },
  {
    id: 625,
    name: "Douis",
    wilaya_id: 17,
    zip_code: "17015",
    wilaya: {
      id: 17,
      name: "Djelfa",
    },
  },
  {
    id: 626,
    name: "Hassi El Euch",
    wilaya_id: 17,
    zip_code: "17016",
    wilaya: {
      id: 17,
      name: "Djelfa",
    },
  },
  {
    id: 627,
    name: "Messaad",
    wilaya_id: 17,
    zip_code: "17017",
    wilaya: {
      id: 17,
      name: "Djelfa",
    },
  },
  {
    id: 628,
    name: "Guettara",
    wilaya_id: 17,
    zip_code: "17018",
    wilaya: {
      id: 17,
      name: "Djelfa",
    },
  },
  {
    id: 629,
    name: "Sidi Ladjel",
    wilaya_id: 17,
    zip_code: "17019",
    wilaya: {
      id: 17,
      name: "Djelfa",
    },
  },
  {
    id: 630,
    name: "Had Sahary",
    wilaya_id: 17,
    zip_code: "17020",
    wilaya: {
      id: 17,
      name: "Djelfa",
    },
  },
  {
    id: 631,
    name: "Guernini",
    wilaya_id: 17,
    zip_code: "17021",
    wilaya: {
      id: 17,
      name: "Djelfa",
    },
  },
  {
    id: 632,
    name: "Selmana",
    wilaya_id: 17,
    zip_code: "17022",
    wilaya: {
      id: 17,
      name: "Djelfa",
    },
  },
  {
    id: 633,
    name: "Aïn Chouhada",
    wilaya_id: 17,
    zip_code: "17023",
    wilaya: {
      id: 17,
      name: "Djelfa",
    },
  },
  {
    id: 634,
    name: "Oum Laadham",
    wilaya_id: 17,
    zip_code: "17024",
    wilaya: {
      id: 17,
      name: "Djelfa",
    },
  },
  {
    id: 635,
    name: "Dar Chioukh",
    wilaya_id: 17,
    zip_code: "17025",
    wilaya: {
      id: 17,
      name: "Djelfa",
    },
  },
  {
    id: 636,
    name: "Charef",
    wilaya_id: 17,
    zip_code: "17026",
    wilaya: {
      id: 17,
      name: "Djelfa",
    },
  },
  {
    id: 637,
    name: "Beni Yagoub",
    wilaya_id: 17,
    zip_code: "17027",
    wilaya: {
      id: 17,
      name: "Djelfa",
    },
  },
  {
    id: 638,
    name: "Zaafrane",
    wilaya_id: 17,
    zip_code: "17028",
    wilaya: {
      id: 17,
      name: "Djelfa",
    },
  },
  {
    id: 639,
    name: "Deldoul",
    wilaya_id: 17,
    zip_code: "17029",
    wilaya: {
      id: 17,
      name: "Djelfa",
    },
  },
  {
    id: 640,
    name: "Aïn El Ibel",
    wilaya_id: 17,
    zip_code: "17030",
    wilaya: {
      id: 17,
      name: "Djelfa",
    },
  },
  {
    id: 641,
    name: "Aïn Oussara",
    wilaya_id: 17,
    zip_code: "17031",
    wilaya: {
      id: 17,
      name: "Djelfa",
    },
  },
  {
    id: 642,
    name: "Benhar",
    wilaya_id: 17,
    zip_code: "17032",
    wilaya: {
      id: 17,
      name: "Djelfa",
    },
  },
  {
    id: 643,
    name: "Hassi Fedoul",
    wilaya_id: 17,
    zip_code: "17033",
    wilaya: {
      id: 17,
      name: "Djelfa",
    },
  },
  {
    id: 644,
    name: "Amourah",
    wilaya_id: 17,
    zip_code: "17034",
    wilaya: {
      id: 17,
      name: "Djelfa",
    },
  },
  {
    id: 645,
    name: "Aïn Feka",
    wilaya_id: 17,
    zip_code: "17035",
    wilaya: {
      id: 17,
      name: "Djelfa",
    },
  },
  {
    id: 646,
    name: "Tadmit",
    wilaya_id: 17,
    zip_code: "17036",
    wilaya: {
      id: 17,
      name: "Djelfa",
    },
  },
  {
    id: 647,
    name: "Jijel",
    wilaya_id: 18,
    zip_code: "18001",
    wilaya: {
      id: 18,
      name: "Jijel",
    },
  },
  {
    id: 648,
    name: "Eraguene",
    wilaya_id: 18,
    zip_code: "18002",
    wilaya: {
      id: 18,
      name: "Jijel",
    },
  },
  {
    id: 649,
    name: "El Aouana",
    wilaya_id: 18,
    zip_code: "18003",
    wilaya: {
      id: 18,
      name: "Jijel",
    },
  },
  {
    id: 650,
    name: "Ziama Mansouriah",
    wilaya_id: 18,
    zip_code: "18004",
    wilaya: {
      id: 18,
      name: "Jijel",
    },
  },
  {
    id: 651,
    name: "Taher",
    wilaya_id: 18,
    zip_code: "18005",
    wilaya: {
      id: 18,
      name: "Jijel",
    },
  },
  {
    id: 652,
    name: "Emir Abdelkader",
    wilaya_id: 18,
    zip_code: "18006",
    wilaya: {
      id: 18,
      name: "Jijel",
    },
  },
  {
    id: 653,
    name: "Chekfa",
    wilaya_id: 18,
    zip_code: "18007",
    wilaya: {
      id: 18,
      name: "Jijel",
    },
  },
  {
    id: 654,
    name: "Chahna",
    wilaya_id: 18,
    zip_code: "18008",
    wilaya: {
      id: 18,
      name: "Jijel",
    },
  },
  {
    id: 655,
    name: "El Milia",
    wilaya_id: 18,
    zip_code: "18009",
    wilaya: {
      id: 18,
      name: "Jijel",
    },
  },
  {
    id: 656,
    name: "Sidi Maarouf",
    wilaya_id: 18,
    zip_code: "18010",
    wilaya: {
      id: 18,
      name: "Jijel",
    },
  },
  {
    id: 657,
    name: "Settara",
    wilaya_id: 18,
    zip_code: "18011",
    wilaya: {
      id: 18,
      name: "Jijel",
    },
  },
  {
    id: 658,
    name: "El Ancer",
    wilaya_id: 18,
    zip_code: "18012",
    wilaya: {
      id: 18,
      name: "Jijel",
    },
  },
  {
    id: 659,
    name: "Sidi Abdelaziz",
    wilaya_id: 18,
    zip_code: "18013",
    wilaya: {
      id: 18,
      name: "Jijel",
    },
  },
  {
    id: 660,
    name: "Kaous",
    wilaya_id: 18,
    zip_code: "18014",
    wilaya: {
      id: 18,
      name: "Jijel",
    },
  },
  {
    id: 661,
    name: "Ghebala",
    wilaya_id: 18,
    zip_code: "18015",
    wilaya: {
      id: 18,
      name: "Jijel",
    },
  },
  {
    id: 662,
    name: "Bouraoui Belhadef",
    wilaya_id: 18,
    zip_code: "18016",
    wilaya: {
      id: 18,
      name: "Jijel",
    },
  },
  {
    id: 663,
    name: "Djimla",
    wilaya_id: 18,
    zip_code: "18017",
    wilaya: {
      id: 18,
      name: "Jijel",
    },
  },
  {
    id: 664,
    name: "Selma Benziada",
    wilaya_id: 18,
    zip_code: "18018",
    wilaya: {
      id: 18,
      name: "Jijel",
    },
  },
  {
    id: 665,
    name: "Boucif Ouled Askeur",
    wilaya_id: 18,
    zip_code: "18019",
    wilaya: {
      id: 18,
      name: "Jijel",
    },
  },
  {
    id: 666,
    name: "El Kennar Nouchfi",
    wilaya_id: 18,
    zip_code: "18020",
    wilaya: {
      id: 18,
      name: "Jijel",
    },
  },
  {
    id: 667,
    name: "Ouled Yahia Khedrouche",
    wilaya_id: 18,
    zip_code: "18021",
    wilaya: {
      id: 18,
      name: "Jijel",
    },
  },
  {
    id: 668,
    name: "Boudriaa Ben Yadjis",
    wilaya_id: 18,
    zip_code: "18022",
    wilaya: {
      id: 18,
      name: "Jijel",
    },
  },
  {
    id: 669,
    name: "Kheïri Oued Adjoul",
    wilaya_id: 18,
    zip_code: "18023",
    wilaya: {
      id: 18,
      name: "Jijel",
    },
  },
  {
    id: 670,
    name: "Texenna",
    wilaya_id: 18,
    zip_code: "18024",
    wilaya: {
      id: 18,
      name: "Jijel",
    },
  },
  {
    id: 671,
    name: "Djemaa Beni Habibi",
    wilaya_id: 18,
    zip_code: "18025",
    wilaya: {
      id: 18,
      name: "Jijel",
    },
  },
  {
    id: 672,
    name: "Bordj Tahar",
    wilaya_id: 18,
    zip_code: "18026",
    wilaya: {
      id: 18,
      name: "Jijel",
    },
  },
  {
    id: 673,
    name: "Ouled Rabah",
    wilaya_id: 18,
    zip_code: "18027",
    wilaya: {
      id: 18,
      name: "Jijel",
    },
  },
  {
    id: 674,
    name: "Ouadjana",
    wilaya_id: 18,
    zip_code: "18028",
    wilaya: {
      id: 18,
      name: "Jijel",
    },
  },
  {
    id: 675,
    name: "Sétif",
    wilaya_id: 19,
    zip_code: "19001",
    wilaya: {
      id: 19,
      name: "Sétif",
    },
  },
  {
    id: 676,
    name: "Aïn El Kebira",
    wilaya_id: 19,
    zip_code: "19002",
    wilaya: {
      id: 19,
      name: "Sétif",
    },
  },
  {
    id: 677,
    name: "Beni Aziz",
    wilaya_id: 19,
    zip_code: "19003",
    wilaya: {
      id: 19,
      name: "Sétif",
    },
  },
  {
    id: 678,
    name: "Ouled Si Ahmed",
    wilaya_id: 19,
    zip_code: "19004",
    wilaya: {
      id: 19,
      name: "Sétif",
    },
  },
  {
    id: 679,
    name: "Boutaleb",
    wilaya_id: 19,
    zip_code: "19005",
    wilaya: {
      id: 19,
      name: "Sétif",
    },
  },
  {
    id: 680,
    name: "Aïn Roua",
    wilaya_id: 19,
    zip_code: "19006",
    wilaya: {
      id: 19,
      name: "Sétif",
    },
  },
  {
    id: 681,
    name: "Draa Kebila",
    wilaya_id: 19,
    zip_code: "19007",
    wilaya: {
      id: 19,
      name: "Sétif",
    },
  },
  {
    id: 682,
    name: "Bir El Arch",
    wilaya_id: 19,
    zip_code: "19008",
    wilaya: {
      id: 19,
      name: "Sétif",
    },
  },
  {
    id: 683,
    name: "Beni Chebana",
    wilaya_id: 19,
    zip_code: "19009",
    wilaya: {
      id: 19,
      name: "Sétif",
    },
  },
  {
    id: 684,
    name: "Ouled Tebben",
    wilaya_id: 19,
    zip_code: "19010",
    wilaya: {
      id: 19,
      name: "Sétif",
    },
  },
  {
    id: 685,
    name: "Hamma",
    wilaya_id: 19,
    zip_code: "19011",
    wilaya: {
      id: 19,
      name: "Sétif",
    },
  },
  {
    id: 686,
    name: "Maaouia",
    wilaya_id: 19,
    zip_code: "19012",
    wilaya: {
      id: 19,
      name: "Sétif",
    },
  },
  {
    id: 687,
    name: "Aïn Legradj",
    wilaya_id: 19,
    zip_code: "19013",
    wilaya: {
      id: 19,
      name: "Sétif",
    },
  },
  {
    id: 688,
    name: "Aïn Abessa",
    wilaya_id: 19,
    zip_code: "19014",
    wilaya: {
      id: 19,
      name: "Sétif",
    },
  },
  {
    id: 689,
    name: "Dehamcha",
    wilaya_id: 19,
    zip_code: "19015",
    wilaya: {
      id: 19,
      name: "Sétif",
    },
  },
  {
    id: 690,
    name: "Babor",
    wilaya_id: 19,
    zip_code: "19016",
    wilaya: {
      id: 19,
      name: "Sétif",
    },
  },
  {
    id: 691,
    name: "Guidjel",
    wilaya_id: 19,
    zip_code: "19017",
    wilaya: {
      id: 19,
      name: "Sétif",
    },
  },
  {
    id: 692,
    name: "Aïn Lahdjar",
    wilaya_id: 19,
    zip_code: "19018",
    wilaya: {
      id: 19,
      name: "Sétif",
    },
  },
  {
    id: 693,
    name: "Bousselam",
    wilaya_id: 19,
    zip_code: "19019",
    wilaya: {
      id: 19,
      name: "Sétif",
    },
  },
  {
    id: 694,
    name: "El Eulma",
    wilaya_id: 19,
    zip_code: "19020",
    wilaya: {
      id: 19,
      name: "Sétif",
    },
  },
  {
    id: 695,
    name: "Djemila",
    wilaya_id: 19,
    zip_code: "19021",
    wilaya: {
      id: 19,
      name: "Sétif",
    },
  },
  {
    id: 696,
    name: "Aït Wertilan",
    wilaya_id: 19,
    zip_code: "19022",
    wilaya: {
      id: 19,
      name: "Sétif",
    },
  },
  {
    id: 697,
    name: "Rasfa",
    wilaya_id: 19,
    zip_code: "19023",
    wilaya: {
      id: 19,
      name: "Sétif",
    },
  },
  {
    id: 698,
    name: "Ouled Addouane",
    wilaya_id: 19,
    zip_code: "19024",
    wilaya: {
      id: 19,
      name: "Sétif",
    },
  },
  {
    id: 699,
    name: "Belaa",
    wilaya_id: 19,
    zip_code: "19025",
    wilaya: {
      id: 19,
      name: "Sétif",
    },
  },
  {
    id: 700,
    name: "Aïn Arnat",
    wilaya_id: 19,
    zip_code: "19026",
    wilaya: {
      id: 19,
      name: "Sétif",
    },
  },
  {
    id: 701,
    name: "Amoucha",
    wilaya_id: 19,
    zip_code: "19027",
    wilaya: {
      id: 19,
      name: "Sétif",
    },
  },
  {
    id: 702,
    name: "Aïn Oulmene",
    wilaya_id: 19,
    zip_code: "19028",
    wilaya: {
      id: 19,
      name: "Sétif",
    },
  },
  {
    id: 703,
    name: "Beidha Bordj",
    wilaya_id: 19,
    zip_code: "19029",
    wilaya: {
      id: 19,
      name: "Sétif",
    },
  },
  {
    id: 704,
    name: "Bouandas",
    wilaya_id: 19,
    zip_code: "19030",
    wilaya: {
      id: 19,
      name: "Sétif",
    },
  },
  {
    id: 705,
    name: "Bazer Sakhra",
    wilaya_id: 19,
    zip_code: "19031",
    wilaya: {
      id: 19,
      name: "Sétif",
    },
  },
  {
    id: 706,
    name: "Hammam Guergour",
    wilaya_id: 19,
    zip_code: "19032",
    wilaya: {
      id: 19,
      name: "Sétif",
    },
  },
  {
    id: 707,
    name: "Mezloug",
    wilaya_id: 19,
    zip_code: "19033",
    wilaya: {
      id: 19,
      name: "Sétif",
    },
  },
  {
    id: 708,
    name: "Bir Haddada",
    wilaya_id: 19,
    zip_code: "19034",
    wilaya: {
      id: 19,
      name: "Sétif",
    },
  },
  {
    id: 709,
    name: "Serdj El Ghoul",
    wilaya_id: 19,
    zip_code: "19035",
    wilaya: {
      id: 19,
      name: "Sétif",
    },
  },
  {
    id: 710,
    name: "Harbil",
    wilaya_id: 19,
    zip_code: "19036",
    wilaya: {
      id: 19,
      name: "Sétif",
    },
  },
  {
    id: 711,
    name: "El Ouricia",
    wilaya_id: 19,
    zip_code: "19037",
    wilaya: {
      id: 19,
      name: "Sétif",
    },
  },
  {
    id: 712,
    name: "Tizi N'Bechar",
    wilaya_id: 19,
    zip_code: "19038",
    wilaya: {
      id: 19,
      name: "Sétif",
    },
  },
  {
    id: 713,
    name: "Salah Bey",
    wilaya_id: 19,
    zip_code: "19039",
    wilaya: {
      id: 19,
      name: "Sétif",
    },
  },
  {
    id: 714,
    name: "Aïn Azel",
    wilaya_id: 19,
    zip_code: "19040",
    wilaya: {
      id: 19,
      name: "Sétif",
    },
  },
  {
    id: 715,
    name: "Guenzet",
    wilaya_id: 19,
    zip_code: "19041",
    wilaya: {
      id: 19,
      name: "Sétif",
    },
  },
  {
    id: 716,
    name: "Talaifacene",
    wilaya_id: 19,
    zip_code: "19042",
    wilaya: {
      id: 19,
      name: "Sétif",
    },
  },
  {
    id: 717,
    name: "Bougaa",
    wilaya_id: 19,
    zip_code: "19043",
    wilaya: {
      id: 19,
      name: "Sétif",
    },
  },
  {
    id: 718,
    name: "Beni Fouda",
    wilaya_id: 19,
    zip_code: "19044",
    wilaya: {
      id: 19,
      name: "Sétif",
    },
  },
  {
    id: 719,
    name: "Tachouda",
    wilaya_id: 19,
    zip_code: "19045",
    wilaya: {
      id: 19,
      name: "Sétif",
    },
  },
  {
    id: 720,
    name: "Beni Mouhli",
    wilaya_id: 19,
    zip_code: "19046",
    wilaya: {
      id: 19,
      name: "Sétif",
    },
  },
  {
    id: 721,
    name: "Ouled Sabor",
    wilaya_id: 19,
    zip_code: "19047",
    wilaya: {
      id: 19,
      name: "Sétif",
    },
  },
  {
    id: 722,
    name: "Guellal",
    wilaya_id: 19,
    zip_code: "19048",
    wilaya: {
      id: 19,
      name: "Sétif",
    },
  },
  {
    id: 723,
    name: "Aïn Sebt",
    wilaya_id: 19,
    zip_code: "19049",
    wilaya: {
      id: 19,
      name: "Sétif",
    },
  },
  {
    id: 724,
    name: "Hammam Soukhna",
    wilaya_id: 19,
    zip_code: "19050",
    wilaya: {
      id: 19,
      name: "Sétif",
    },
  },
  {
    id: 725,
    name: "Aït Naoual Mezada",
    wilaya_id: 19,
    zip_code: "19051",
    wilaya: {
      id: 19,
      name: "Sétif",
    },
  },
  {
    id: 726,
    name: "Ksar El Abtal",
    wilaya_id: 19,
    zip_code: "19052",
    wilaya: {
      id: 19,
      name: "Sétif",
    },
  },
  {
    id: 727,
    name: "Beni Hocine",
    wilaya_id: 19,
    zip_code: "19053",
    wilaya: {
      id: 19,
      name: "Sétif",
    },
  },
  {
    id: 728,
    name: "Aït Tizi",
    wilaya_id: 19,
    zip_code: "19054",
    wilaya: {
      id: 19,
      name: "Sétif",
    },
  },
  {
    id: 729,
    name: "Maoklane",
    wilaya_id: 19,
    zip_code: "19055",
    wilaya: {
      id: 19,
      name: "Sétif",
    },
  },
  {
    id: 730,
    name: "Guelta Zerka",
    wilaya_id: 19,
    zip_code: "19056",
    wilaya: {
      id: 19,
      name: "Sétif",
    },
  },
  {
    id: 731,
    name: "Oued El Barad",
    wilaya_id: 19,
    zip_code: "19057",
    wilaya: {
      id: 19,
      name: "Sétif",
    },
  },
  {
    id: 732,
    name: "Taya",
    wilaya_id: 19,
    zip_code: "19058",
    wilaya: {
      id: 19,
      name: "Sétif",
    },
  },
  {
    id: 733,
    name: "El Ouldja",
    wilaya_id: 19,
    zip_code: "19059",
    wilaya: {
      id: 19,
      name: "Sétif",
    },
  },
  {
    id: 734,
    name: "Tella",
    wilaya_id: 19,
    zip_code: "19060",
    wilaya: {
      id: 19,
      name: "Sétif",
    },
  },
  {
    id: 735,
    name: "Saïda",
    wilaya_id: 20,
    zip_code: "20001",
    wilaya: {
      id: 20,
      name: "Saïda",
    },
  },
  {
    id: 736,
    name: "Doui Thabet",
    wilaya_id: 20,
    zip_code: "20002",
    wilaya: {
      id: 20,
      name: "Saïda",
    },
  },
  {
    id: 737,
    name: "Ain El Hadjar",
    wilaya_id: 20,
    zip_code: "20003",
    wilaya: {
      id: 20,
      name: "Saïda",
    },
  },
  {
    id: 738,
    name: "Ouled Khaled",
    wilaya_id: 20,
    zip_code: "20004",
    wilaya: {
      id: 20,
      name: "Saïda",
    },
  },
  {
    id: 739,
    name: "Moulay Larbi",
    wilaya_id: 20,
    zip_code: "20005",
    wilaya: {
      id: 20,
      name: "Saïda",
    },
  },
  {
    id: 740,
    name: "Youb",
    wilaya_id: 20,
    zip_code: "20006",
    wilaya: {
      id: 20,
      name: "Saïda",
    },
  },
  {
    id: 741,
    name: "Hounet",
    wilaya_id: 20,
    zip_code: "20007",
    wilaya: {
      id: 20,
      name: "Saïda",
    },
  },
  {
    id: 742,
    name: "Sidi Amar",
    wilaya_id: 20,
    zip_code: "20008",
    wilaya: {
      id: 20,
      name: "Saïda",
    },
  },
  {
    id: 743,
    name: "Sidi Boubekeur",
    wilaya_id: 20,
    zip_code: "20009",
    wilaya: {
      id: 20,
      name: "Saïda",
    },
  },
  {
    id: 744,
    name: "El Hassasna",
    wilaya_id: 20,
    zip_code: "20010",
    wilaya: {
      id: 20,
      name: "Saïda",
    },
  },
  {
    id: 745,
    name: "Maamora",
    wilaya_id: 20,
    zip_code: "20011",
    wilaya: {
      id: 20,
      name: "Saïda",
    },
  },
  {
    id: 746,
    name: "Sidi Ahmed",
    wilaya_id: 20,
    zip_code: "20012",
    wilaya: {
      id: 20,
      name: "Saïda",
    },
  },
  {
    id: 747,
    name: "Aïn Sekhouna",
    wilaya_id: 20,
    zip_code: "20013",
    wilaya: {
      id: 20,
      name: "Saïda",
    },
  },
  {
    id: 748,
    name: "Ouled Brahim",
    wilaya_id: 20,
    zip_code: "20014",
    wilaya: {
      id: 20,
      name: "Saïda",
    },
  },
  {
    id: 749,
    name: "Tircine",
    wilaya_id: 20,
    zip_code: "20015",
    wilaya: {
      id: 20,
      name: "Saïda",
    },
  },
  {
    id: 750,
    name: "Aïn Soltane",
    wilaya_id: 20,
    zip_code: "20016",
    wilaya: {
      id: 20,
      name: "Saïda",
    },
  },
  {
    id: 751,
    name: "Skikda",
    wilaya_id: 21,
    zip_code: "21001",
    wilaya: {
      id: 21,
      name: "Skikda",
    },
  },
  {
    id: 752,
    name: "Aïn Zouit",
    wilaya_id: 21,
    zip_code: "21002",
    wilaya: {
      id: 21,
      name: "Skikda",
    },
  },
  {
    id: 753,
    name: "El Hadaiek",
    wilaya_id: 21,
    zip_code: "21003",
    wilaya: {
      id: 21,
      name: "Skikda",
    },
  },
  {
    id: 754,
    name: "Azzaba",
    wilaya_id: 21,
    zip_code: "21004",
    wilaya: {
      id: 21,
      name: "Skikda",
    },
  },
  {
    id: 755,
    name: "Djendel Saadi Mohamed",
    wilaya_id: 21,
    zip_code: "21005",
    wilaya: {
      id: 21,
      name: "Skikda",
    },
  },
  {
    id: 756,
    name: "Aïn Charchar",
    wilaya_id: 21,
    zip_code: "21006",
    wilaya: {
      id: 21,
      name: "Skikda",
    },
  },
  {
    id: 757,
    name: "Bekkouche Lakhdar",
    wilaya_id: 21,
    zip_code: "21007",
    wilaya: {
      id: 21,
      name: "Skikda",
    },
  },
  {
    id: 758,
    name: "Ben Azzouz",
    wilaya_id: 21,
    zip_code: "21008",
    wilaya: {
      id: 21,
      name: "Skikda",
    },
  },
  {
    id: 759,
    name: "Es Sebt",
    wilaya_id: 21,
    zip_code: "21009",
    wilaya: {
      id: 21,
      name: "Skikda",
    },
  },
  {
    id: 760,
    name: "Collo",
    wilaya_id: 21,
    zip_code: "21010",
    wilaya: {
      id: 21,
      name: "Skikda",
    },
  },
  {
    id: 761,
    name: "Beni Zid",
    wilaya_id: 21,
    zip_code: "21011",
    wilaya: {
      id: 21,
      name: "Skikda",
    },
  },
  {
    id: 762,
    name: "Kerkera",
    wilaya_id: 21,
    zip_code: "21012",
    wilaya: {
      id: 21,
      name: "Skikda",
    },
  },
  {
    id: 763,
    name: "Ouled Attia",
    wilaya_id: 21,
    zip_code: "21013",
    wilaya: {
      id: 21,
      name: "Skikda",
    },
  },
  {
    id: 764,
    name: "Oued Zehour",
    wilaya_id: 21,
    zip_code: "21014",
    wilaya: {
      id: 21,
      name: "Skikda",
    },
  },
  {
    id: 765,
    name: "Zitouna",
    wilaya_id: 21,
    zip_code: "21015",
    wilaya: {
      id: 21,
      name: "Skikda",
    },
  },
  {
    id: 766,
    name: "El Harrouch",
    wilaya_id: 21,
    zip_code: "21016",
    wilaya: {
      id: 21,
      name: "Skikda",
    },
  },
  {
    id: 767,
    name: "Zerdaza",
    wilaya_id: 21,
    zip_code: "21017",
    wilaya: {
      id: 21,
      name: "Skikda",
    },
  },
  {
    id: 768,
    name: "Ouled Hbaba",
    wilaya_id: 21,
    zip_code: "21018",
    wilaya: {
      id: 21,
      name: "Skikda",
    },
  },
  {
    id: 769,
    name: "Sidi Mezghiche",
    wilaya_id: 21,
    zip_code: "21019",
    wilaya: {
      id: 21,
      name: "Skikda",
    },
  },
  {
    id: 770,
    name: "Emdjez Edchich",
    wilaya_id: 21,
    zip_code: "21020",
    wilaya: {
      id: 21,
      name: "Skikda",
    },
  },
  {
    id: 771,
    name: "Beni Oulbane",
    wilaya_id: 21,
    zip_code: "21021",
    wilaya: {
      id: 21,
      name: "Skikda",
    },
  },
  {
    id: 772,
    name: "Aïn Bouziane",
    wilaya_id: 21,
    zip_code: "21022",
    wilaya: {
      id: 21,
      name: "Skikda",
    },
  },
  {
    id: 773,
    name: "Ramdane Djamel",
    wilaya_id: 21,
    zip_code: "21023",
    wilaya: {
      id: 21,
      name: "Skikda",
    },
  },
  {
    id: 774,
    name: "Beni Bechir",
    wilaya_id: 21,
    zip_code: "21024",
    wilaya: {
      id: 21,
      name: "Skikda",
    },
  },
  {
    id: 775,
    name: "Salah Bouchaour",
    wilaya_id: 21,
    zip_code: "21025",
    wilaya: {
      id: 21,
      name: "Skikda",
    },
  },
  {
    id: 776,
    name: "Tamalous",
    wilaya_id: 21,
    zip_code: "21026",
    wilaya: {
      id: 21,
      name: "Skikda",
    },
  },
  {
    id: 777,
    name: "Aïn Kechra",
    wilaya_id: 21,
    zip_code: "21027",
    wilaya: {
      id: 21,
      name: "Skikda",
    },
  },
  {
    id: 778,
    name: "Oum Toub",
    wilaya_id: 21,
    zip_code: "21028",
    wilaya: {
      id: 21,
      name: "Skikda",
    },
  },
  {
    id: 779,
    name: "Bin El Ouiden",
    wilaya_id: 21,
    zip_code: "21029",
    wilaya: {
      id: 21,
      name: "Skikda",
    },
  },
  {
    id: 780,
    name: "Filfila",
    wilaya_id: 21,
    zip_code: "21030",
    wilaya: {
      id: 21,
      name: "Skikda",
    },
  },
  {
    id: 781,
    name: "Cheraia",
    wilaya_id: 21,
    zip_code: "21031",
    wilaya: {
      id: 21,
      name: "Skikda",
    },
  },
  {
    id: 782,
    name: "Kanoua",
    wilaya_id: 21,
    zip_code: "21032",
    wilaya: {
      id: 21,
      name: "Skikda",
    },
  },
  {
    id: 783,
    name: "El Ghedir",
    wilaya_id: 21,
    zip_code: "21033",
    wilaya: {
      id: 21,
      name: "Skikda",
    },
  },
  {
    id: 784,
    name: "Bouchtata",
    wilaya_id: 21,
    zip_code: "21034",
    wilaya: {
      id: 21,
      name: "Skikda",
    },
  },
  {
    id: 785,
    name: "Ouldja Boulballout",
    wilaya_id: 21,
    zip_code: "21035",
    wilaya: {
      id: 21,
      name: "Skikda",
    },
  },
  {
    id: 786,
    name: "Kheneg Mayoum",
    wilaya_id: 21,
    zip_code: "21036",
    wilaya: {
      id: 21,
      name: "Skikda",
    },
  },
  {
    id: 787,
    name: "Hamadi Krouma",
    wilaya_id: 21,
    zip_code: "21037",
    wilaya: {
      id: 21,
      name: "Skikda",
    },
  },
  {
    id: 788,
    name: "El Marsa",
    wilaya_id: 21,
    zip_code: "21038",
    wilaya: {
      id: 21,
      name: "Skikda",
    },
  },
  {
    id: 789,
    name: "Sidi Bel Abbes",
    wilaya_id: 22,
    zip_code: "22001",
    wilaya: {
      id: 22,
      name: "Sidi Bel Abbès",
    },
  },
  {
    id: 790,
    name: "Tessala",
    wilaya_id: 22,
    zip_code: "22002",
    wilaya: {
      id: 22,
      name: "Sidi Bel Abbès",
    },
  },
  {
    id: 791,
    name: "Sidi Brahim",
    wilaya_id: 22,
    zip_code: "22003",
    wilaya: {
      id: 22,
      name: "Sidi Bel Abbès",
    },
  },
  {
    id: 792,
    name: "Mostefa Ben Brahim",
    wilaya_id: 22,
    zip_code: "22004",
    wilaya: {
      id: 22,
      name: "Sidi Bel Abbès",
    },
  },
  {
    id: 793,
    name: "Telagh",
    wilaya_id: 22,
    zip_code: "22005",
    wilaya: {
      id: 22,
      name: "Sidi Bel Abbès",
    },
  },
  {
    id: 794,
    name: "Mezaourou",
    wilaya_id: 22,
    zip_code: "22006",
    wilaya: {
      id: 22,
      name: "Sidi Bel Abbès",
    },
  },
  {
    id: 795,
    name: "Boukhanafis",
    wilaya_id: 22,
    zip_code: "22007",
    wilaya: {
      id: 22,
      name: "Sidi Bel Abbès",
    },
  },
  {
    id: 796,
    name: "Sidi Ali Boussidi",
    wilaya_id: 22,
    zip_code: "22008",
    wilaya: {
      id: 22,
      name: "Sidi Bel Abbès",
    },
  },
  {
    id: 797,
    name: "Badredine El Mokrani",
    wilaya_id: 22,
    zip_code: "22009",
    wilaya: {
      id: 22,
      name: "Sidi Bel Abbès",
    },
  },
  {
    id: 798,
    name: "Marhoum",
    wilaya_id: 22,
    zip_code: "22010",
    wilaya: {
      id: 22,
      name: "Sidi Bel Abbès",
    },
  },
  {
    id: 799,
    name: "Tafissour",
    wilaya_id: 22,
    zip_code: "22011",
    wilaya: {
      id: 22,
      name: "Sidi Bel Abbès",
    },
  },
  {
    id: 800,
    name: "Amarnas",
    wilaya_id: 22,
    zip_code: "22012",
    wilaya: {
      id: 22,
      name: "Sidi Bel Abbès",
    },
  },
  {
    id: 801,
    name: "Tilmouni",
    wilaya_id: 22,
    zip_code: "22013",
    wilaya: {
      id: 22,
      name: "Sidi Bel Abbès",
    },
  },
  {
    id: 802,
    name: "Sidi Lahcene",
    wilaya_id: 22,
    zip_code: "22014",
    wilaya: {
      id: 22,
      name: "Sidi Bel Abbès",
    },
  },
  {
    id: 803,
    name: "Aïn Thrid",
    wilaya_id: 22,
    zip_code: "22015",
    wilaya: {
      id: 22,
      name: "Sidi Bel Abbès",
    },
  },
  {
    id: 804,
    name: "Makedra",
    wilaya_id: 22,
    zip_code: "22016",
    wilaya: {
      id: 22,
      name: "Sidi Bel Abbès",
    },
  },
  {
    id: 805,
    name: "Tenira",
    wilaya_id: 22,
    zip_code: "22017",
    wilaya: {
      id: 22,
      name: "Sidi Bel Abbès",
    },
  },
  {
    id: 806,
    name: "Moulay Slissen",
    wilaya_id: 22,
    zip_code: "22018",
    wilaya: {
      id: 22,
      name: "Sidi Bel Abbès",
    },
  },
  {
    id: 807,
    name: "El Haçaiba",
    wilaya_id: 22,
    zip_code: "22019",
    wilaya: {
      id: 22,
      name: "Sidi Bel Abbès",
    },
  },
  {
    id: 808,
    name: "Hassi Zehana",
    wilaya_id: 22,
    zip_code: "22020",
    wilaya: {
      id: 22,
      name: "Sidi Bel Abbès",
    },
  },
  {
    id: 809,
    name: "Tabia",
    wilaya_id: 22,
    zip_code: "22021",
    wilaya: {
      id: 22,
      name: "Sidi Bel Abbès",
    },
  },
  {
    id: 810,
    name: "Merine",
    wilaya_id: 22,
    zip_code: "22022",
    wilaya: {
      id: 22,
      name: "Sidi Bel Abbès",
    },
  },
  {
    id: 811,
    name: "Ras El Ma",
    wilaya_id: 22,
    zip_code: "22023",
    wilaya: {
      id: 22,
      name: "Sidi Bel Abbès",
    },
  },
  {
    id: 812,
    name: "Aïn Tindamine",
    wilaya_id: 22,
    zip_code: "22024",
    wilaya: {
      id: 22,
      name: "Sidi Bel Abbès",
    },
  },
  {
    id: 813,
    name: "Aïn Kada",
    wilaya_id: 22,
    zip_code: "22025",
    wilaya: {
      id: 22,
      name: "Sidi Bel Abbès",
    },
  },
  {
    id: 814,
    name: "M'Cid",
    wilaya_id: 22,
    zip_code: "22026",
    wilaya: {
      id: 22,
      name: "Sidi Bel Abbès",
    },
  },
  {
    id: 815,
    name: "Sidi Khaled",
    wilaya_id: 22,
    zip_code: "22027",
    wilaya: {
      id: 22,
      name: "Sidi Bel Abbès",
    },
  },
  {
    id: 816,
    name: "Aïn El Berd",
    wilaya_id: 22,
    zip_code: "22028",
    wilaya: {
      id: 22,
      name: "Sidi Bel Abbès",
    },
  },
  {
    id: 817,
    name: "Sfisef",
    wilaya_id: 22,
    zip_code: "22029",
    wilaya: {
      id: 22,
      name: "Sidi Bel Abbès",
    },
  },
  {
    id: 818,
    name: "Aïn Adden",
    wilaya_id: 22,
    zip_code: "22030",
    wilaya: {
      id: 22,
      name: "Sidi Bel Abbès",
    },
  },
  {
    id: 819,
    name: "Oued Taourira",
    wilaya_id: 22,
    zip_code: "22031",
    wilaya: {
      id: 22,
      name: "Sidi Bel Abbès",
    },
  },
  {
    id: 820,
    name: "Dhaya",
    wilaya_id: 22,
    zip_code: "22032",
    wilaya: {
      id: 22,
      name: "Sidi Bel Abbès",
    },
  },
  {
    id: 821,
    name: "Zerouala",
    wilaya_id: 22,
    zip_code: "22033",
    wilaya: {
      id: 22,
      name: "Sidi Bel Abbès",
    },
  },
  {
    id: 822,
    name: "Lamtar",
    wilaya_id: 22,
    zip_code: "22034",
    wilaya: {
      id: 22,
      name: "Sidi Bel Abbès",
    },
  },
  {
    id: 823,
    name: "Sidi Chaib",
    wilaya_id: 22,
    zip_code: "22035",
    wilaya: {
      id: 22,
      name: "Sidi Bel Abbès",
    },
  },
  {
    id: 824,
    name: "Sidi Daho des Zairs",
    wilaya_id: 22,
    zip_code: "22036",
    wilaya: {
      id: 22,
      name: "Sidi Bel Abbès",
    },
  },
  {
    id: 825,
    name: "Oued Sebaa",
    wilaya_id: 22,
    zip_code: "22037",
    wilaya: {
      id: 22,
      name: "Sidi Bel Abbès",
    },
  },
  {
    id: 826,
    name: "Boudjebaa El Bordj",
    wilaya_id: 22,
    zip_code: "22038",
    wilaya: {
      id: 22,
      name: "Sidi Bel Abbès",
    },
  },
  {
    id: 827,
    name: "Sehala Thaoura",
    wilaya_id: 22,
    zip_code: "22039",
    wilaya: {
      id: 22,
      name: "Sidi Bel Abbès",
    },
  },
  {
    id: 828,
    name: "Sidi Yacoub",
    wilaya_id: 22,
    zip_code: "22040",
    wilaya: {
      id: 22,
      name: "Sidi Bel Abbès",
    },
  },
  {
    id: 829,
    name: "Sidi Hamadouche",
    wilaya_id: 22,
    zip_code: "22041",
    wilaya: {
      id: 22,
      name: "Sidi Bel Abbès",
    },
  },
  {
    id: 830,
    name: "Belarbi",
    wilaya_id: 22,
    zip_code: "22042",
    wilaya: {
      id: 22,
      name: "Sidi Bel Abbès",
    },
  },
  {
    id: 831,
    name: "Oued Sefioun",
    wilaya_id: 22,
    zip_code: "22043",
    wilaya: {
      id: 22,
      name: "Sidi Bel Abbès",
    },
  },
  {
    id: 832,
    name: "Teghalimet",
    wilaya_id: 22,
    zip_code: "22044",
    wilaya: {
      id: 22,
      name: "Sidi Bel Abbès",
    },
  },
  {
    id: 833,
    name: "Ben Badis",
    wilaya_id: 22,
    zip_code: "22045",
    wilaya: {
      id: 22,
      name: "Sidi Bel Abbès",
    },
  },
  {
    id: 834,
    name: "Sidi Ali Benyoub",
    wilaya_id: 22,
    zip_code: "22046",
    wilaya: {
      id: 22,
      name: "Sidi Bel Abbès",
    },
  },
  {
    id: 835,
    name: "Chettouane Belaila",
    wilaya_id: 22,
    zip_code: "22047",
    wilaya: {
      id: 22,
      name: "Sidi Bel Abbès",
    },
  },
  {
    id: 836,
    name: "Bir El Hammam",
    wilaya_id: 22,
    zip_code: "22048",
    wilaya: {
      id: 22,
      name: "Sidi Bel Abbès",
    },
  },
  {
    id: 837,
    name: "Taoudmout",
    wilaya_id: 22,
    zip_code: "22049",
    wilaya: {
      id: 22,
      name: "Sidi Bel Abbès",
    },
  },
  {
    id: 838,
    name: "Redjem Demouche",
    wilaya_id: 22,
    zip_code: "22050",
    wilaya: {
      id: 22,
      name: "Sidi Bel Abbès",
    },
  },
  {
    id: 839,
    name: "Benachiba Chelia",
    wilaya_id: 22,
    zip_code: "22051",
    wilaya: {
      id: 22,
      name: "Sidi Bel Abbès",
    },
  },
  {
    id: 840,
    name: "Hassi Dahou",
    wilaya_id: 22,
    zip_code: "22052",
    wilaya: {
      id: 22,
      name: "Sidi Bel Abbès",
    },
  },
  {
    id: 841,
    name: "Annaba",
    wilaya_id: 23,
    zip_code: "23001",
    wilaya: {
      id: 23,
      name: "Annaba",
    },
  },
  {
    id: 842,
    name: "Berrahal",
    wilaya_id: 23,
    zip_code: "23002",
    wilaya: {
      id: 23,
      name: "Annaba",
    },
  },
  {
    id: 843,
    name: "El Hadjar",
    wilaya_id: 23,
    zip_code: "23003",
    wilaya: {
      id: 23,
      name: "Annaba",
    },
  },
  {
    id: 844,
    name: "Eulma",
    wilaya_id: 23,
    zip_code: "23004",
    wilaya: {
      id: 23,
      name: "Annaba",
    },
  },
  {
    id: 845,
    name: "El Bouni",
    wilaya_id: 23,
    zip_code: "23005",
    wilaya: {
      id: 23,
      name: "Annaba",
    },
  },
  {
    id: 846,
    name: "Oued El Aneb",
    wilaya_id: 23,
    zip_code: "23006",
    wilaya: {
      id: 23,
      name: "Annaba",
    },
  },
  {
    id: 847,
    name: "Cheurfa",
    wilaya_id: 23,
    zip_code: "23007",
    wilaya: {
      id: 23,
      name: "Annaba",
    },
  },
  {
    id: 848,
    name: "Seraïdi",
    wilaya_id: 23,
    zip_code: "23008",
    wilaya: {
      id: 23,
      name: "Annaba",
    },
  },
  {
    id: 849,
    name: "Aïn Berda",
    wilaya_id: 23,
    zip_code: "23009",
    wilaya: {
      id: 23,
      name: "Annaba",
    },
  },
  {
    id: 850,
    name: "Chetaïbi",
    wilaya_id: 23,
    zip_code: "23010",
    wilaya: {
      id: 23,
      name: "Annaba",
    },
  },
  {
    id: 851,
    name: "Sidi Amar",
    wilaya_id: 23,
    zip_code: "23011",
    wilaya: {
      id: 23,
      name: "Annaba",
    },
  },
  {
    id: 852,
    name: "Treat",
    wilaya_id: 23,
    zip_code: "23012",
    wilaya: {
      id: 23,
      name: "Annaba",
    },
  },
  {
    id: 853,
    name: "Guelma",
    wilaya_id: 24,
    zip_code: "24001",
    wilaya: {
      id: 24,
      name: "Guelma",
    },
  },
  {
    id: 854,
    name: "Nechmaya",
    wilaya_id: 24,
    zip_code: "24002",
    wilaya: {
      id: 24,
      name: "Guelma",
    },
  },
  {
    id: 855,
    name: "Bouati Mahmoud",
    wilaya_id: 24,
    zip_code: "24003",
    wilaya: {
      id: 24,
      name: "Guelma",
    },
  },
  {
    id: 856,
    name: "Oued Zenati",
    wilaya_id: 24,
    zip_code: "24004",
    wilaya: {
      id: 24,
      name: "Guelma",
    },
  },
  {
    id: 857,
    name: "Tamlouka",
    wilaya_id: 24,
    zip_code: "24005",
    wilaya: {
      id: 24,
      name: "Guelma",
    },
  },
  {
    id: 858,
    name: "Oued Fragha",
    wilaya_id: 24,
    zip_code: "24006",
    wilaya: {
      id: 24,
      name: "Guelma",
    },
  },
  {
    id: 859,
    name: "Aïn Sandel",
    wilaya_id: 24,
    zip_code: "24007",
    wilaya: {
      id: 24,
      name: "Guelma",
    },
  },
  {
    id: 860,
    name: "Ras El Agba",
    wilaya_id: 24,
    zip_code: "24008",
    wilaya: {
      id: 24,
      name: "Guelma",
    },
  },
  {
    id: 861,
    name: "Dahouara",
    wilaya_id: 24,
    zip_code: "24009",
    wilaya: {
      id: 24,
      name: "Guelma",
    },
  },
  {
    id: 862,
    name: "Belkheir",
    wilaya_id: 24,
    zip_code: "24010",
    wilaya: {
      id: 24,
      name: "Guelma",
    },
  },
  {
    id: 863,
    name: "Ben Djerrah",
    wilaya_id: 24,
    zip_code: "24011",
    wilaya: {
      id: 24,
      name: "Guelma",
    },
  },
  {
    id: 864,
    name: "Bouhamdane",
    wilaya_id: 24,
    zip_code: "24012",
    wilaya: {
      id: 24,
      name: "Guelma",
    },
  },
  {
    id: 865,
    name: "Aïn Makhlouf",
    wilaya_id: 24,
    zip_code: "24013",
    wilaya: {
      id: 24,
      name: "Guelma",
    },
  },
  {
    id: 866,
    name: "Aïn Ben Beida",
    wilaya_id: 24,
    zip_code: "24014",
    wilaya: {
      id: 24,
      name: "Guelma",
    },
  },
  {
    id: 867,
    name: "Khezarra",
    wilaya_id: 24,
    zip_code: "24015",
    wilaya: {
      id: 24,
      name: "Guelma",
    },
  },
  {
    id: 868,
    name: "Beni Mezline",
    wilaya_id: 24,
    zip_code: "24016",
    wilaya: {
      id: 24,
      name: "Guelma",
    },
  },
  {
    id: 869,
    name: "Bouhachana",
    wilaya_id: 24,
    zip_code: "24017",
    wilaya: {
      id: 24,
      name: "Guelma",
    },
  },
  {
    id: 870,
    name: "Guellat Bou Sbaa",
    wilaya_id: 24,
    zip_code: "24018",
    wilaya: {
      id: 24,
      name: "Guelma",
    },
  },
  {
    id: 871,
    name: "Hammam Debagh",
    wilaya_id: 24,
    zip_code: "24019",
    wilaya: {
      id: 24,
      name: "Guelma",
    },
  },
  {
    id: 872,
    name: "El Fedjoudj",
    wilaya_id: 24,
    zip_code: "24020",
    wilaya: {
      id: 24,
      name: "Guelma",
    },
  },
  {
    id: 873,
    name: "Bordj Sabath",
    wilaya_id: 24,
    zip_code: "24021",
    wilaya: {
      id: 24,
      name: "Guelma",
    },
  },
  {
    id: 874,
    name: "Hammam N'Bail",
    wilaya_id: 24,
    zip_code: "24022",
    wilaya: {
      id: 24,
      name: "Guelma",
    },
  },
  {
    id: 875,
    name: "Aïn Larbi",
    wilaya_id: 24,
    zip_code: "24023",
    wilaya: {
      id: 24,
      name: "Guelma",
    },
  },
  {
    id: 876,
    name: "Medjez Amar",
    wilaya_id: 24,
    zip_code: "24024",
    wilaya: {
      id: 24,
      name: "Guelma",
    },
  },
  {
    id: 877,
    name: "Bouchegouf",
    wilaya_id: 24,
    zip_code: "24025",
    wilaya: {
      id: 24,
      name: "Guelma",
    },
  },
  {
    id: 878,
    name: "Héliopolis",
    wilaya_id: 24,
    zip_code: "24026",
    wilaya: {
      id: 24,
      name: "Guelma",
    },
  },
  {
    id: 879,
    name: "Houari Boumédiène",
    wilaya_id: 24,
    zip_code: "24027",
    wilaya: {
      id: 24,
      name: "Guelma",
    },
  },
  {
    id: 880,
    name: "Roknia",
    wilaya_id: 24,
    zip_code: "24028",
    wilaya: {
      id: 24,
      name: "Guelma",
    },
  },
  {
    id: 881,
    name: "Sellaoua Announa",
    wilaya_id: 24,
    zip_code: "24029",
    wilaya: {
      id: 24,
      name: "Guelma",
    },
  },
  {
    id: 882,
    name: "Medjez Sfa",
    wilaya_id: 24,
    zip_code: "24030",
    wilaya: {
      id: 24,
      name: "Guelma",
    },
  },
  {
    id: 883,
    name: "Boumahra Ahmed",
    wilaya_id: 24,
    zip_code: "24031",
    wilaya: {
      id: 24,
      name: "Guelma",
    },
  },
  {
    id: 884,
    name: "Aïn Reggada",
    wilaya_id: 24,
    zip_code: "24032",
    wilaya: {
      id: 24,
      name: "Guelma",
    },
  },
  {
    id: 885,
    name: "Oued Cheham",
    wilaya_id: 24,
    zip_code: "24033",
    wilaya: {
      id: 24,
      name: "Guelma",
    },
  },
  {
    id: 886,
    name: "Djeballah Khemissi",
    wilaya_id: 24,
    zip_code: "24034",
    wilaya: {
      id: 24,
      name: "Guelma",
    },
  },
  {
    id: 887,
    name: "Constantine",
    wilaya_id: 25,
    zip_code: "25001",
    wilaya: {
      id: 25,
      name: "Constantine",
    },
  },
  {
    id: 888,
    name: "Hamma Bouziane",
    wilaya_id: 25,
    zip_code: "25002",
    wilaya: {
      id: 25,
      name: "Constantine",
    },
  },
  {
    id: 889,
    name: "Ibn Badis",
    wilaya_id: 25,
    zip_code: "25003",
    wilaya: {
      id: 25,
      name: "Constantine",
    },
  },
  {
    id: 890,
    name: "Zighoud Youcef",
    wilaya_id: 25,
    zip_code: "25004",
    wilaya: {
      id: 25,
      name: "Constantine",
    },
  },
  {
    id: 891,
    name: "Didouche Mourad",
    wilaya_id: 25,
    zip_code: "25005",
    wilaya: {
      id: 25,
      name: "Constantine",
    },
  },
  {
    id: 892,
    name: "El Khroub",
    wilaya_id: 25,
    zip_code: "25006",
    wilaya: {
      id: 25,
      name: "Constantine",
    },
  },
  {
    id: 893,
    name: "Aïn Abid",
    wilaya_id: 25,
    zip_code: "25007",
    wilaya: {
      id: 25,
      name: "Constantine",
    },
  },
  {
    id: 894,
    name: "Beni Hamiden",
    wilaya_id: 25,
    zip_code: "25008",
    wilaya: {
      id: 25,
      name: "Constantine",
    },
  },
  {
    id: 895,
    name: "Ouled Rahmoune",
    wilaya_id: 25,
    zip_code: "25009",
    wilaya: {
      id: 25,
      name: "Constantine",
    },
  },
  {
    id: 896,
    name: "Aïn Smara",
    wilaya_id: 25,
    zip_code: "25010",
    wilaya: {
      id: 25,
      name: "Constantine",
    },
  },
  {
    id: 897,
    name: "Messaoud Boudjriou",
    wilaya_id: 25,
    zip_code: "25011",
    wilaya: {
      id: 25,
      name: "Constantine",
    },
  },
  {
    id: 898,
    name: "Ibn Ziad",
    wilaya_id: 25,
    zip_code: "25012",
    wilaya: {
      id: 25,
      name: "Constantine",
    },
  },
  {
    id: 899,
    name: "Médéa",
    wilaya_id: 26,
    zip_code: "26001",
    wilaya: {
      id: 26,
      name: "Médéa",
    },
  },
  {
    id: 900,
    name: "Ouzera",
    wilaya_id: 26,
    zip_code: "26002",
    wilaya: {
      id: 26,
      name: "Médéa",
    },
  },
  {
    id: 901,
    name: "Ouled Maaref",
    wilaya_id: 26,
    zip_code: "26003",
    wilaya: {
      id: 26,
      name: "Médéa",
    },
  },
  {
    id: 902,
    name: "Aïn Boucif",
    wilaya_id: 26,
    zip_code: "26004",
    wilaya: {
      id: 26,
      name: "Médéa",
    },
  },
  {
    id: 903,
    name: "Aissaouia",
    wilaya_id: 26,
    zip_code: "26005",
    wilaya: {
      id: 26,
      name: "Médéa",
    },
  },
  {
    id: 904,
    name: "Ouled Deide",
    wilaya_id: 26,
    zip_code: "26006",
    wilaya: {
      id: 26,
      name: "Médéa",
    },
  },
  {
    id: 905,
    name: "El Omaria",
    wilaya_id: 26,
    zip_code: "26007",
    wilaya: {
      id: 26,
      name: "Médéa",
    },
  },
  {
    id: 906,
    name: "Derrag",
    wilaya_id: 26,
    zip_code: "26008",
    wilaya: {
      id: 26,
      name: "Médéa",
    },
  },
  {
    id: 907,
    name: "El Guelb El Kebir",
    wilaya_id: 26,
    zip_code: "26009",
    wilaya: {
      id: 26,
      name: "Médéa",
    },
  },
  {
    id: 908,
    name: "Bou Aiche",
    wilaya_id: 26,
    zip_code: "26010",
    wilaya: {
      id: 26,
      name: "Médéa",
    },
  },
  {
    id: 909,
    name: "Mezerana",
    wilaya_id: 26,
    zip_code: "26011",
    wilaya: {
      id: 26,
      name: "Médéa",
    },
  },
  {
    id: 910,
    name: "Ouled Brahim",
    wilaya_id: 26,
    zip_code: "26012",
    wilaya: {
      id: 26,
      name: "Médéa",
    },
  },
  {
    id: 911,
    name: "Moudjbar",
    wilaya_id: 26,
    zip_code: "26013",
    wilaya: {
      id: 26,
      name: "Médéa",
    },
  },
  {
    id: 912,
    name: "Sidi Ziane",
    wilaya_id: 26,
    zip_code: "26014",
    wilaya: {
      id: 26,
      name: "Médéa",
    },
  },
  {
    id: 913,
    name: "Tamesguida",
    wilaya_id: 26,
    zip_code: "26015",
    wilaya: {
      id: 26,
      name: "Médéa",
    },
  },
  {
    id: 914,
    name: "El Hamdania",
    wilaya_id: 26,
    zip_code: "26016",
    wilaya: {
      id: 26,
      name: "Médéa",
    },
  },
  {
    id: 915,
    name: "Kef Lakhdar",
    wilaya_id: 26,
    zip_code: "26017",
    wilaya: {
      id: 26,
      name: "Médéa",
    },
  },
  {
    id: 916,
    name: "Chellalet El Adhaoura",
    wilaya_id: 26,
    zip_code: "26018",
    wilaya: {
      id: 26,
      name: "Médéa",
    },
  },
  {
    id: 917,
    name: "Bouskene",
    wilaya_id: 26,
    zip_code: "26019",
    wilaya: {
      id: 26,
      name: "Médéa",
    },
  },
  {
    id: 918,
    name: "Rebaia",
    wilaya_id: 26,
    zip_code: "26020",
    wilaya: {
      id: 26,
      name: "Médéa",
    },
  },
  {
    id: 919,
    name: "Bouchrahil",
    wilaya_id: 26,
    zip_code: "26021",
    wilaya: {
      id: 26,
      name: "Médéa",
    },
  },
  {
    id: 920,
    name: "Ouled Hellal",
    wilaya_id: 26,
    zip_code: "26022",
    wilaya: {
      id: 26,
      name: "Médéa",
    },
  },
  {
    id: 921,
    name: "Tafraout",
    wilaya_id: 26,
    zip_code: "26023",
    wilaya: {
      id: 26,
      name: "Médéa",
    },
  },
  {
    id: 922,
    name: "Baata",
    wilaya_id: 26,
    zip_code: "26024",
    wilaya: {
      id: 26,
      name: "Médéa",
    },
  },
  {
    id: 923,
    name: "Boghar",
    wilaya_id: 26,
    zip_code: "26025",
    wilaya: {
      id: 26,
      name: "Médéa",
    },
  },
  {
    id: 924,
    name: "Sidi Naamane",
    wilaya_id: 26,
    zip_code: "26026",
    wilaya: {
      id: 26,
      name: "Médéa",
    },
  },
  {
    id: 925,
    name: "Ouled Bouachra",
    wilaya_id: 26,
    zip_code: "26027",
    wilaya: {
      id: 26,
      name: "Médéa",
    },
  },
  {
    id: 926,
    name: "Sidi Zahar",
    wilaya_id: 26,
    zip_code: "26028",
    wilaya: {
      id: 26,
      name: "Médéa",
    },
  },
  {
    id: 927,
    name: "Oued Harbil",
    wilaya_id: 26,
    zip_code: "26029",
    wilaya: {
      id: 26,
      name: "Médéa",
    },
  },
  {
    id: 928,
    name: "Benchicao",
    wilaya_id: 26,
    zip_code: "26030",
    wilaya: {
      id: 26,
      name: "Médéa",
    },
  },
  {
    id: 929,
    name: "Sidi Damed",
    wilaya_id: 26,
    zip_code: "26031",
    wilaya: {
      id: 26,
      name: "Médéa",
    },
  },
  {
    id: 930,
    name: "Aziz",
    wilaya_id: 26,
    zip_code: "26032",
    wilaya: {
      id: 26,
      name: "Médéa",
    },
  },
  {
    id: 931,
    name: "Souagui",
    wilaya_id: 26,
    zip_code: "26033",
    wilaya: {
      id: 26,
      name: "Médéa",
    },
  },
  {
    id: 932,
    name: "Zoubiria",
    wilaya_id: 26,
    zip_code: "26034",
    wilaya: {
      id: 26,
      name: "Médéa",
    },
  },
  {
    id: 933,
    name: "Ksar Boukhari",
    wilaya_id: 26,
    zip_code: "26035",
    wilaya: {
      id: 26,
      name: "Médéa",
    },
  },
  {
    id: 934,
    name: "El Azizia",
    wilaya_id: 26,
    zip_code: "26036",
    wilaya: {
      id: 26,
      name: "Médéa",
    },
  },
  {
    id: 935,
    name: "Djouab",
    wilaya_id: 26,
    zip_code: "26037",
    wilaya: {
      id: 26,
      name: "Médéa",
    },
  },
  {
    id: 936,
    name: "Chahbounia",
    wilaya_id: 26,
    zip_code: "26038",
    wilaya: {
      id: 26,
      name: "Médéa",
    },
  },
  {
    id: 937,
    name: "Tizi Mahdi",
    wilaya_id: 26,
    zip_code: "26039",
    wilaya: {
      id: 26,
      name: "Médéa",
    },
  },
  {
    id: 938,
    name: "Cheniguel",
    wilaya_id: 26,
    zip_code: "26040",
    wilaya: {
      id: 26,
      name: "Médéa",
    },
  },
  {
    id: 939,
    name: "Aïn Ouksir",
    wilaya_id: 26,
    zip_code: "26041",
    wilaya: {
      id: 26,
      name: "Médéa",
    },
  },
  {
    id: 940,
    name: "Oum El Djalil",
    wilaya_id: 26,
    zip_code: "26042",
    wilaya: {
      id: 26,
      name: "Médéa",
    },
  },
  {
    id: 941,
    name: "Ouamri",
    wilaya_id: 26,
    zip_code: "26043",
    wilaya: {
      id: 26,
      name: "Médéa",
    },
  },
  {
    id: 942,
    name: "Si Mahdjoub",
    wilaya_id: 26,
    zip_code: "26044",
    wilaya: {
      id: 26,
      name: "Médéa",
    },
  },
  {
    id: 943,
    name: "Tlatet Eddouar",
    wilaya_id: 26,
    zip_code: "26045",
    wilaya: {
      id: 26,
      name: "Médéa",
    },
  },
  {
    id: 944,
    name: "Beni Slimane",
    wilaya_id: 26,
    zip_code: "26046",
    wilaya: {
      id: 26,
      name: "Médéa",
    },
  },
  {
    id: 945,
    name: "Berrouaghia",
    wilaya_id: 26,
    zip_code: "26047",
    wilaya: {
      id: 26,
      name: "Médéa",
    },
  },
  {
    id: 946,
    name: "Seghouane",
    wilaya_id: 26,
    zip_code: "26048",
    wilaya: {
      id: 26,
      name: "Médéa",
    },
  },
  {
    id: 947,
    name: "Meftaha",
    wilaya_id: 26,
    zip_code: "26049",
    wilaya: {
      id: 26,
      name: "Médéa",
    },
  },
  {
    id: 948,
    name: "Mihoub",
    wilaya_id: 26,
    zip_code: "26050",
    wilaya: {
      id: 26,
      name: "Médéa",
    },
  },
  {
    id: 949,
    name: "Boughezoul",
    wilaya_id: 26,
    zip_code: "26051",
    wilaya: {
      id: 26,
      name: "Médéa",
    },
  },
  {
    id: 950,
    name: "Tablat",
    wilaya_id: 26,
    zip_code: "26052",
    wilaya: {
      id: 26,
      name: "Médéa",
    },
  },
  {
    id: 951,
    name: "Deux Bassins",
    wilaya_id: 26,
    zip_code: "26053",
    wilaya: {
      id: 26,
      name: "Médéa",
    },
  },
  {
    id: 952,
    name: "Draa Essamar",
    wilaya_id: 26,
    zip_code: "26054",
    wilaya: {
      id: 26,
      name: "Médéa",
    },
  },
  {
    id: 953,
    name: "Sidi Errabia",
    wilaya_id: 26,
    zip_code: "26055",
    wilaya: {
      id: 26,
      name: "Médéa",
    },
  },
  {
    id: 954,
    name: "Bir Ben Laabed",
    wilaya_id: 26,
    zip_code: "26056",
    wilaya: {
      id: 26,
      name: "Médéa",
    },
  },
  {
    id: 955,
    name: "El Ouinet",
    wilaya_id: 26,
    zip_code: "26057",
    wilaya: {
      id: 26,
      name: "Médéa",
    },
  },
  {
    id: 956,
    name: "Ouled Antar",
    wilaya_id: 26,
    zip_code: "26058",
    wilaya: {
      id: 26,
      name: "Médéa",
    },
  },
  {
    id: 957,
    name: "Bouaichoune",
    wilaya_id: 26,
    zip_code: "26059",
    wilaya: {
      id: 26,
      name: "Médéa",
    },
  },
  {
    id: 958,
    name: "Hannacha",
    wilaya_id: 26,
    zip_code: "26060",
    wilaya: {
      id: 26,
      name: "Médéa",
    },
  },
  {
    id: 959,
    name: "Sedraia",
    wilaya_id: 26,
    zip_code: "26061",
    wilaya: {
      id: 26,
      name: "Médéa",
    },
  },
  {
    id: 960,
    name: "Meghraoua",
    wilaya_id: 26,
    zip_code: "26062",
    wilaya: {
      id: 26,
      name: "Médéa",
    },
  },
  {
    id: 961,
    name: "Khams Djouamaa",
    wilaya_id: 26,
    zip_code: "26063",
    wilaya: {
      id: 26,
      name: "Médéa",
    },
  },
  {
    id: 962,
    name: "Saneg",
    wilaya_id: 26,
    zip_code: "26064",
    wilaya: {
      id: 26,
      name: "Médéa",
    },
  },
  {
    id: 963,
    name: "Mostaganem",
    wilaya_id: 27,
    zip_code: "27001",
    wilaya: {
      id: 27,
      name: "Mostaganem",
    },
  },
  {
    id: 964,
    name: "Sayada",
    wilaya_id: 27,
    zip_code: "27002",
    wilaya: {
      id: 27,
      name: "Mostaganem",
    },
  },
  {
    id: 965,
    name: "Fornaka",
    wilaya_id: 27,
    zip_code: "27003",
    wilaya: {
      id: 27,
      name: "Mostaganem",
    },
  },
  {
    id: 966,
    name: "Stidia",
    wilaya_id: 27,
    zip_code: "27004",
    wilaya: {
      id: 27,
      name: "Mostaganem",
    },
  },
  {
    id: 967,
    name: "Aïn Nouissy",
    wilaya_id: 27,
    zip_code: "27005",
    wilaya: {
      id: 27,
      name: "Mostaganem",
    },
  },
  {
    id: 968,
    name: "Hassi Mameche",
    wilaya_id: 27,
    zip_code: "27006",
    wilaya: {
      id: 27,
      name: "Mostaganem",
    },
  },
  {
    id: 969,
    name: "Aïn Tedles",
    wilaya_id: 27,
    zip_code: "27007",
    wilaya: {
      id: 27,
      name: "Mostaganem",
    },
  },
  {
    id: 970,
    name: "Sour",
    wilaya_id: 27,
    zip_code: "27008",
    wilaya: {
      id: 27,
      name: "Mostaganem",
    },
  },
  {
    id: 971,
    name: "Oued El Kheir",
    wilaya_id: 27,
    zip_code: "27009",
    wilaya: {
      id: 27,
      name: "Mostaganem",
    },
  },
  {
    id: 972,
    name: "Sidi Belattar",
    wilaya_id: 27,
    zip_code: "27010",
    wilaya: {
      id: 27,
      name: "Mostaganem",
    },
  },
  {
    id: 973,
    name: "Kheiredine",
    wilaya_id: 27,
    zip_code: "27011",
    wilaya: {
      id: 27,
      name: "Mostaganem",
    },
  },
  {
    id: 974,
    name: "Sidi Ali",
    wilaya_id: 27,
    zip_code: "27012",
    wilaya: {
      id: 27,
      name: "Mostaganem",
    },
  },
  {
    id: 975,
    name: "Abdelmalek Ramdane",
    wilaya_id: 27,
    zip_code: "27013",
    wilaya: {
      id: 27,
      name: "Mostaganem",
    },
  },
  {
    id: 976,
    name: "Hadjadj",
    wilaya_id: 27,
    zip_code: "27014",
    wilaya: {
      id: 27,
      name: "Mostaganem",
    },
  },
  {
    id: 977,
    name: "Nekmaria",
    wilaya_id: 27,
    zip_code: "27015",
    wilaya: {
      id: 27,
      name: "Mostaganem",
    },
  },
  {
    id: 978,
    name: "Sidi Lakhdar",
    wilaya_id: 27,
    zip_code: "27016",
    wilaya: {
      id: 27,
      name: "Mostaganem",
    },
  },
  {
    id: 979,
    name: "Achaacha",
    wilaya_id: 27,
    zip_code: "27017",
    wilaya: {
      id: 27,
      name: "Mostaganem",
    },
  },
  {
    id: 980,
    name: "Khadra",
    wilaya_id: 27,
    zip_code: "27018",
    wilaya: {
      id: 27,
      name: "Mostaganem",
    },
  },
  {
    id: 981,
    name: "Bouguirat",
    wilaya_id: 27,
    zip_code: "27019",
    wilaya: {
      id: 27,
      name: "Mostaganem",
    },
  },
  {
    id: 982,
    name: "Sirat",
    wilaya_id: 27,
    zip_code: "27020",
    wilaya: {
      id: 27,
      name: "Mostaganem",
    },
  },
  {
    id: 983,
    name: "Aïn Sidi Cherif",
    wilaya_id: 27,
    zip_code: "27021",
    wilaya: {
      id: 27,
      name: "Mostaganem",
    },
  },
  {
    id: 984,
    name: "Mesra",
    wilaya_id: 27,
    zip_code: "27022",
    wilaya: {
      id: 27,
      name: "Mostaganem",
    },
  },
  {
    id: 985,
    name: "Mansourah",
    wilaya_id: 27,
    zip_code: "27023",
    wilaya: {
      id: 27,
      name: "Mostaganem",
    },
  },
  {
    id: 986,
    name: "Souaflia",
    wilaya_id: 27,
    zip_code: "27024",
    wilaya: {
      id: 27,
      name: "Mostaganem",
    },
  },
  {
    id: 987,
    name: "Ouled Boughalem",
    wilaya_id: 27,
    zip_code: "27025",
    wilaya: {
      id: 27,
      name: "Mostaganem",
    },
  },
  {
    id: 988,
    name: "Ouled Maallah",
    wilaya_id: 27,
    zip_code: "27026",
    wilaya: {
      id: 27,
      name: "Mostaganem",
    },
  },
  {
    id: 989,
    name: "Mazagran",
    wilaya_id: 27,
    zip_code: "27027",
    wilaya: {
      id: 27,
      name: "Mostaganem",
    },
  },
  {
    id: 990,
    name: "Aïn Boudinar",
    wilaya_id: 27,
    zip_code: "27028",
    wilaya: {
      id: 27,
      name: "Mostaganem",
    },
  },
  {
    id: 991,
    name: "Tazgait",
    wilaya_id: 27,
    zip_code: "27029",
    wilaya: {
      id: 27,
      name: "Mostaganem",
    },
  },
  {
    id: 992,
    name: "Safsaf",
    wilaya_id: 27,
    zip_code: "27030",
    wilaya: {
      id: 27,
      name: "Mostaganem",
    },
  },
  {
    id: 993,
    name: "Blad Touahria",
    wilaya_id: 27,
    zip_code: "27031",
    wilaya: {
      id: 27,
      name: "Mostaganem",
    },
  },
  {
    id: 994,
    name: "El Hassaine",
    wilaya_id: 27,
    zip_code: "27032",
    wilaya: {
      id: 27,
      name: "Mostaganem",
    },
  },
  {
    id: 995,
    name: "M'Sila",
    wilaya_id: 28,
    zip_code: "28001",
    wilaya: {
      id: 28,
      name: "M'Sila",
    },
  },
  {
    id: 996,
    name: "Maadid",
    wilaya_id: 28,
    zip_code: "28002",
    wilaya: {
      id: 28,
      name: "M'Sila",
    },
  },
  {
    id: 997,
    name: "Hammam Dhalaa",
    wilaya_id: 28,
    zip_code: "28003",
    wilaya: {
      id: 28,
      name: "M'Sila",
    },
  },
  {
    id: 998,
    name: "Ouled Derradj",
    wilaya_id: 28,
    zip_code: "28004",
    wilaya: {
      id: 28,
      name: "M'Sila",
    },
  },
  {
    id: 999,
    name: "Tarmount",
    wilaya_id: 28,
    zip_code: "28005",
    wilaya: {
      id: 28,
      name: "M'Sila",
    },
  },
  {
    id: 1000,
    name: "M'Tarfa",
    wilaya_id: 28,
    zip_code: "28006",
    wilaya: {
      id: 28,
      name: "M'Sila",
    },
  },
  {
    id: 1001,
    name: "Khoubana",
    wilaya_id: 28,
    zip_code: "28007",
    wilaya: {
      id: 28,
      name: "M'Sila",
    },
  },
  {
    id: 1002,
    name: "M'Cif",
    wilaya_id: 28,
    zip_code: "28008",
    wilaya: {
      id: 28,
      name: "M'Sila",
    },
  },
  {
    id: 1003,
    name: "Chellal",
    wilaya_id: 28,
    zip_code: "28009",
    wilaya: {
      id: 28,
      name: "M'Sila",
    },
  },
  {
    id: 1004,
    name: "Ouled Madhi",
    wilaya_id: 28,
    zip_code: "28010",
    wilaya: {
      id: 28,
      name: "M'Sila",
    },
  },
  {
    id: 1005,
    name: "Magra",
    wilaya_id: 28,
    zip_code: "28011",
    wilaya: {
      id: 28,
      name: "M'Sila",
    },
  },
  {
    id: 1006,
    name: "Berhoum",
    wilaya_id: 28,
    zip_code: "28012",
    wilaya: {
      id: 28,
      name: "M'Sila",
    },
  },
  {
    id: 1007,
    name: "Aïn Khadra",
    wilaya_id: 28,
    zip_code: "28013",
    wilaya: {
      id: 28,
      name: "M'Sila",
    },
  },
  {
    id: 1008,
    name: "Ouled Addi Guebala",
    wilaya_id: 28,
    zip_code: "28014",
    wilaya: {
      id: 28,
      name: "M'Sila",
    },
  },
  {
    id: 1009,
    name: "Belaiba",
    wilaya_id: 28,
    zip_code: "28015",
    wilaya: {
      id: 28,
      name: "M'Sila",
    },
  },
  {
    id: 1010,
    name: "Sidi Aïssa",
    wilaya_id: 28,
    zip_code: "28016",
    wilaya: {
      id: 28,
      name: "M'Sila",
    },
  },
  {
    id: 1011,
    name: "Aïn El Hadjel",
    wilaya_id: 28,
    zip_code: "28017",
    wilaya: {
      id: 28,
      name: "M'Sila",
    },
  },
  {
    id: 1012,
    name: "Sidi Hadjeres",
    wilaya_id: 28,
    zip_code: "28018",
    wilaya: {
      id: 28,
      name: "M'Sila",
    },
  },
  {
    id: 1013,
    name: "Ouanougha",
    wilaya_id: 28,
    zip_code: "28019",
    wilaya: {
      id: 28,
      name: "M'Sila",
    },
  },
  {
    id: 1014,
    name: "Bou Saâda",
    wilaya_id: 28,
    zip_code: "28020",
    wilaya: {
      id: 28,
      name: "M'Sila",
    },
  },
  {
    id: 1015,
    name: "Ouled Sidi Brahim",
    wilaya_id: 28,
    zip_code: "28021",
    wilaya: {
      id: 28,
      name: "M'Sila",
    },
  },
  {
    id: 1016,
    name: "Sidi Ameur",
    wilaya_id: 28,
    zip_code: "28022",
    wilaya: {
      id: 28,
      name: "M'Sila",
    },
  },
  {
    id: 1017,
    name: "Tamsa",
    wilaya_id: 28,
    zip_code: "28023",
    wilaya: {
      id: 28,
      name: "M'Sila",
    },
  },
  {
    id: 1018,
    name: "Ben Srour",
    wilaya_id: 28,
    zip_code: "28024",
    wilaya: {
      id: 28,
      name: "M'Sila",
    },
  },
  {
    id: 1019,
    name: "Ouled Slimane",
    wilaya_id: 28,
    zip_code: "28025",
    wilaya: {
      id: 28,
      name: "M'Sila",
    },
  },
  {
    id: 1020,
    name: "El Houamed",
    wilaya_id: 28,
    zip_code: "28026",
    wilaya: {
      id: 28,
      name: "M'Sila",
    },
  },
  {
    id: 1021,
    name: "El Hamel",
    wilaya_id: 28,
    zip_code: "28027",
    wilaya: {
      id: 28,
      name: "M'Sila",
    },
  },
  {
    id: 1022,
    name: "Ouled Mansour",
    wilaya_id: 28,
    zip_code: "28028",
    wilaya: {
      id: 28,
      name: "M'Sila",
    },
  },
  {
    id: 1023,
    name: "Maarif",
    wilaya_id: 28,
    zip_code: "28029",
    wilaya: {
      id: 28,
      name: "M'Sila",
    },
  },
  {
    id: 1024,
    name: "Dehahna",
    wilaya_id: 28,
    zip_code: "28030",
    wilaya: {
      id: 28,
      name: "M'Sila",
    },
  },
  {
    id: 1025,
    name: "Bouti Sayah",
    wilaya_id: 28,
    zip_code: "28031",
    wilaya: {
      id: 28,
      name: "M'Sila",
    },
  },
  {
    id: 1026,
    name: "Khettouti Sed El Djir",
    wilaya_id: 28,
    zip_code: "28032",
    wilaya: {
      id: 28,
      name: "M'Sila",
    },
  },
  {
    id: 1027,
    name: "Zarzour",
    wilaya_id: 28,
    zip_code: "28033",
    wilaya: {
      id: 28,
      name: "M'Sila",
    },
  },
  {
    id: 1028,
    name: "Mohammed Boudiaf",
    wilaya_id: 28,
    zip_code: "28034",
    wilaya: {
      id: 28,
      name: "M'Sila",
    },
  },
  {
    id: 1029,
    name: "Benzouh",
    wilaya_id: 28,
    zip_code: "28035",
    wilaya: {
      id: 28,
      name: "M'Sila",
    },
  },
  {
    id: 1030,
    name: "Bir Foda",
    wilaya_id: 28,
    zip_code: "28036",
    wilaya: {
      id: 28,
      name: "M'Sila",
    },
  },
  {
    id: 1031,
    name: "Aïn Fares",
    wilaya_id: 28,
    zip_code: "28037",
    wilaya: {
      id: 28,
      name: "M'Sila",
    },
  },
  {
    id: 1032,
    name: "Sidi Mhamed",
    wilaya_id: 28,
    zip_code: "28038",
    wilaya: {
      id: 28,
      name: "M'Sila",
    },
  },
  {
    id: 1033,
    name: "Ouled Atia",
    wilaya_id: 28,
    zip_code: "28039",
    wilaya: {
      id: 28,
      name: "M'Sila",
    },
  },
  {
    id: 1034,
    name: "Souamaa",
    wilaya_id: 28,
    zip_code: "28040",
    wilaya: {
      id: 28,
      name: "M'Sila",
    },
  },
  {
    id: 1035,
    name: "Aïn El Melh",
    wilaya_id: 28,
    zip_code: "28041",
    wilaya: {
      id: 28,
      name: "M'Sila",
    },
  },
  {
    id: 1036,
    name: "Medjedel",
    wilaya_id: 28,
    zip_code: "28042",
    wilaya: {
      id: 28,
      name: "M'Sila",
    },
  },
  {
    id: 1037,
    name: "Slim",
    wilaya_id: 28,
    zip_code: "28043",
    wilaya: {
      id: 28,
      name: "M'Sila",
    },
  },
  {
    id: 1038,
    name: "Aïn Errich",
    wilaya_id: 28,
    zip_code: "28044",
    wilaya: {
      id: 28,
      name: "M'Sila",
    },
  },
  {
    id: 1039,
    name: "Beni Ilmane",
    wilaya_id: 28,
    zip_code: "28045",
    wilaya: {
      id: 28,
      name: "M'Sila",
    },
  },
  {
    id: 1040,
    name: "Oultem",
    wilaya_id: 28,
    zip_code: "28046",
    wilaya: {
      id: 28,
      name: "M'Sila",
    },
  },
  {
    id: 1041,
    name: "Djebel Messaad",
    wilaya_id: 28,
    zip_code: "28047",
    wilaya: {
      id: 28,
      name: "M'Sila",
    },
  },
  {
    id: 1042,
    name: "Mascara",
    wilaya_id: 29,
    zip_code: "29001",
    wilaya: {
      id: 29,
      name: "Mascara",
    },
  },
  {
    id: 1043,
    name: "Bou Hanifia",
    wilaya_id: 29,
    zip_code: "29002",
    wilaya: {
      id: 29,
      name: "Mascara",
    },
  },
  {
    id: 1044,
    name: "Tizi",
    wilaya_id: 29,
    zip_code: "29003",
    wilaya: {
      id: 29,
      name: "Mascara",
    },
  },
  {
    id: 1045,
    name: "Hacine",
    wilaya_id: 29,
    zip_code: "29004",
    wilaya: {
      id: 29,
      name: "Mascara",
    },
  },
  {
    id: 1046,
    name: "Maoussa",
    wilaya_id: 29,
    zip_code: "29005",
    wilaya: {
      id: 29,
      name: "Mascara",
    },
  },
  {
    id: 1047,
    name: "Tighennif",
    wilaya_id: 29,
    zip_code: "29006",
    wilaya: {
      id: 29,
      name: "Mascara",
    },
  },
  {
    id: 1048,
    name: "El Guettana",
    wilaya_id: 29,
    zip_code: "29007",
    wilaya: {
      id: 29,
      name: "Mascara",
    },
  },
  {
    id: 1049,
    name: "Sidi Kada",
    wilaya_id: 29,
    zip_code: "29008",
    wilaya: {
      id: 29,
      name: "Mascara",
    },
  },
  {
    id: 1050,
    name: "Zelmata",
    wilaya_id: 29,
    zip_code: "29009",
    wilaya: {
      id: 29,
      name: "Mascara",
    },
  },
  {
    id: 1051,
    name: "Oued El Abtal",
    wilaya_id: 29,
    zip_code: "29010",
    wilaya: {
      id: 29,
      name: "Mascara",
    },
  },
  {
    id: 1052,
    name: "Aïn Ferah",
    wilaya_id: 29,
    zip_code: "29011",
    wilaya: {
      id: 29,
      name: "Mascara",
    },
  },
  {
    id: 1053,
    name: "Ghriss",
    wilaya_id: 29,
    zip_code: "29012",
    wilaya: {
      id: 29,
      name: "Mascara",
    },
  },
  {
    id: 1054,
    name: "Froha",
    wilaya_id: 29,
    zip_code: "29013",
    wilaya: {
      id: 29,
      name: "Mascara",
    },
  },
  {
    id: 1055,
    name: "Matemore",
    wilaya_id: 29,
    zip_code: "29014",
    wilaya: {
      id: 29,
      name: "Mascara",
    },
  },
  {
    id: 1056,
    name: "Makdha",
    wilaya_id: 29,
    zip_code: "29015",
    wilaya: {
      id: 29,
      name: "Mascara",
    },
  },
  {
    id: 1057,
    name: "Sidi Boussaid",
    wilaya_id: 29,
    zip_code: "29016",
    wilaya: {
      id: 29,
      name: "Mascara",
    },
  },
  {
    id: 1058,
    name: "El Bordj",
    wilaya_id: 29,
    zip_code: "29017",
    wilaya: {
      id: 29,
      name: "Mascara",
    },
  },
  {
    id: 1059,
    name: "Aïn Fekan",
    wilaya_id: 29,
    zip_code: "29018",
    wilaya: {
      id: 29,
      name: "Mascara",
    },
  },
  {
    id: 1060,
    name: "Beniane",
    wilaya_id: 29,
    zip_code: "29019",
    wilaya: {
      id: 29,
      name: "Mascara",
    },
  },
  {
    id: 1061,
    name: "Khalouia",
    wilaya_id: 29,
    zip_code: "29020",
    wilaya: {
      id: 29,
      name: "Mascara",
    },
  },
  {
    id: 1062,
    name: "El Menaouer",
    wilaya_id: 29,
    zip_code: "29021",
    wilaya: {
      id: 29,
      name: "Mascara",
    },
  },
  {
    id: 1063,
    name: "Oued Taria",
    wilaya_id: 29,
    zip_code: "29022",
    wilaya: {
      id: 29,
      name: "Mascara",
    },
  },
  {
    id: 1064,
    name: "Aouf",
    wilaya_id: 29,
    zip_code: "29023",
    wilaya: {
      id: 29,
      name: "Mascara",
    },
  },
  {
    id: 1065,
    name: "Ain Fares",
    wilaya_id: 29,
    zip_code: "29024",
    wilaya: {
      id: 29,
      name: "Mascara",
    },
  },
  {
    id: 1066,
    name: "Aïn Fras",
    wilaya_id: 29,
    zip_code: "29025",
    wilaya: {
      id: 29,
      name: "Mascara",
    },
  },
  {
    id: 1067,
    name: "Sig",
    wilaya_id: 29,
    zip_code: "29026",
    wilaya: {
      id: 29,
      name: "Mascara",
    },
  },
  {
    id: 1068,
    name: "Oggaz",
    wilaya_id: 29,
    zip_code: "29027",
    wilaya: {
      id: 29,
      name: "Mascara",
    },
  },
  {
    id: 1069,
    name: "Alaïmia",
    wilaya_id: 29,
    zip_code: "29028",
    wilaya: {
      id: 29,
      name: "Mascara",
    },
  },
  {
    id: 1070,
    name: "El Gaada",
    wilaya_id: 29,
    zip_code: "29029",
    wilaya: {
      id: 29,
      name: "Mascara",
    },
  },
  {
    id: 1071,
    name: "Zahana",
    wilaya_id: 29,
    zip_code: "29030",
    wilaya: {
      id: 29,
      name: "Mascara",
    },
  },
  {
    id: 1072,
    name: "Mohammadia",
    wilaya_id: 29,
    zip_code: "29031",
    wilaya: {
      id: 29,
      name: "Mascara",
    },
  },
  {
    id: 1073,
    name: "Sidi Abdelmoumen",
    wilaya_id: 29,
    zip_code: "29032",
    wilaya: {
      id: 29,
      name: "Mascara",
    },
  },
  {
    id: 1074,
    name: "Ferraguig",
    wilaya_id: 29,
    zip_code: "29033",
    wilaya: {
      id: 29,
      name: "Mascara",
    },
  },
  {
    id: 1075,
    name: "El Ghomri",
    wilaya_id: 29,
    zip_code: "29034",
    wilaya: {
      id: 29,
      name: "Mascara",
    },
  },
  {
    id: 1076,
    name: "Sedjerara",
    wilaya_id: 29,
    zip_code: "29035",
    wilaya: {
      id: 29,
      name: "Mascara",
    },
  },
  {
    id: 1077,
    name: "Mocta Douz",
    wilaya_id: 29,
    zip_code: "29036",
    wilaya: {
      id: 29,
      name: "Mascara",
    },
  },
  {
    id: 1078,
    name: "Bou Henni",
    wilaya_id: 29,
    zip_code: "29037",
    wilaya: {
      id: 29,
      name: "Mascara",
    },
  },
  {
    id: 1079,
    name: "Hachem",
    wilaya_id: 29,
    zip_code: "29038",
    wilaya: {
      id: 29,
      name: "Mascara",
    },
  },
  {
    id: 1080,
    name: "Mamounia",
    wilaya_id: 29,
    zip_code: "29039",
    wilaya: {
      id: 29,
      name: "Mascara",
    },
  },
  {
    id: 1081,
    name: "El Keurt",
    wilaya_id: 29,
    zip_code: "29040",
    wilaya: {
      id: 29,
      name: "Mascara",
    },
  },
  {
    id: 1082,
    name: "Gharrous",
    wilaya_id: 29,
    zip_code: "29041",
    wilaya: {
      id: 29,
      name: "Mascara",
    },
  },
  {
    id: 1083,
    name: "Guerdjoum",
    wilaya_id: 29,
    zip_code: "29042",
    wilaya: {
      id: 29,
      name: "Mascara",
    },
  },
  {
    id: 1084,
    name: "Chorfa",
    wilaya_id: 29,
    zip_code: "29043",
    wilaya: {
      id: 29,
      name: "Mascara",
    },
  },
  {
    id: 1085,
    name: "Ras El Aïn Amirouche",
    wilaya_id: 29,
    zip_code: "29044",
    wilaya: {
      id: 29,
      name: "Mascara",
    },
  },
  {
    id: 1086,
    name: "Nesmoth",
    wilaya_id: 29,
    zip_code: "29045",
    wilaya: {
      id: 29,
      name: "Mascara",
    },
  },
  {
    id: 1087,
    name: "Sidi Abdeldjebar",
    wilaya_id: 29,
    zip_code: "29046",
    wilaya: {
      id: 29,
      name: "Mascara",
    },
  },
  {
    id: 1088,
    name: "Sehailia",
    wilaya_id: 29,
    zip_code: "29047",
    wilaya: {
      id: 29,
      name: "Mascara",
    },
  },
  {
    id: 1089,
    name: "Ouargla",
    wilaya_id: 30,
    zip_code: "30001",
    wilaya: {
      id: 30,
      name: "Ouargla",
    },
  },
  {
    id: 1090,
    name: "Ain Beida",
    wilaya_id: 30,
    zip_code: "30002",
    wilaya: {
      id: 30,
      name: "Ouargla",
    },
  },
  {
    id: 1091,
    name: "N'Goussa",
    wilaya_id: 30,
    zip_code: "30003",
    wilaya: {
      id: 30,
      name: "Ouargla",
    },
  },
  {
    id: 1092,
    name: "Hassi Messaoud",
    wilaya_id: 30,
    zip_code: "30004",
    wilaya: {
      id: 30,
      name: "Ouargla",
    },
  },
  {
    id: 1093,
    name: "Rouissat",
    wilaya_id: 30,
    zip_code: "30005",
    wilaya: {
      id: 30,
      name: "Ouargla",
    },
  },
  {
    id: 1094,
    name: "Blidet Amor",
    wilaya_id: 55,
    zip_code: "30006",
    wilaya: {
      id: 55,
      name: "Touggourt",
    },
  },
  {
    id: 1095,
    name: "Tebesbest",
    wilaya_id: 55,
    zip_code: "30007",
    wilaya: {
      id: 55,
      name: "Touggourt",
    },
  },
  {
    id: 1096,
    name: "Nezla",
    wilaya_id: 55,
    zip_code: "30008",
    wilaya: {
      id: 55,
      name: "Touggourt",
    },
  },
  {
    id: 1097,
    name: "Zaouia El Abidia",
    wilaya_id: 55,
    zip_code: "30009",
    wilaya: {
      id: 55,
      name: "Touggourt",
    },
  },
  {
    id: 1098,
    name: "Sidi Slimane",
    wilaya_id: 55,
    zip_code: "30010",
    wilaya: {
      id: 55,
      name: "Touggourt",
    },
  },
  {
    id: 1099,
    name: "Sidi Khouiled",
    wilaya_id: 30,
    zip_code: "30011",
    wilaya: {
      id: 30,
      name: "Ouargla",
    },
  },
  {
    id: 1100,
    name: "Hassi Ben Abdellah",
    wilaya_id: 30,
    zip_code: "30012",
    wilaya: {
      id: 30,
      name: "Ouargla",
    },
  },
  {
    id: 1101,
    name: "Touggourt",
    wilaya_id: 55,
    zip_code: "30013",
    wilaya: {
      id: 55,
      name: "Touggourt",
    },
  },
  {
    id: 1102,
    name: "El Hadjira",
    wilaya_id: 55,
    zip_code: "30014",
    wilaya: {
      id: 55,
      name: "Touggourt",
    },
  },
  {
    id: 1103,
    name: "Taibet",
    wilaya_id: 55,
    zip_code: "30015",
    wilaya: {
      id: 55,
      name: "Touggourt",
    },
  },
  {
    id: 1104,
    name: "Tamacine",
    wilaya_id: 55,
    zip_code: "30016",
    wilaya: {
      id: 55,
      name: "Touggourt",
    },
  },
  {
    id: 1105,
    name: "Benaceur",
    wilaya_id: 55,
    zip_code: "30017",
    wilaya: {
      id: 55,
      name: "Touggourt",
    },
  },
  {
    id: 1106,
    name: "Megarine",
    wilaya_id: 55,
    zip_code: "30018",
    wilaya: {
      id: 55,
      name: "Touggourt",
    },
  },
  {
    id: 1107,
    name: "M'Naguer",
    wilaya_id: 55,
    zip_code: "30019",
    wilaya: {
      id: 55,
      name: "Touggourt",
    },
  },
  {
    id: 1108,
    name: "El Allia",
    wilaya_id: 55,
    zip_code: "30020",
    wilaya: {
      id: 55,
      name: "Touggourt",
    },
  },
  {
    id: 1109,
    name: "El Borma",
    wilaya_id: 55,
    zip_code: "30021",
    wilaya: {
      id: 55,
      name: "Touggourt",
    },
  },
  {
    id: 1110,
    name: "Oran",
    wilaya_id: 31,
    zip_code: "31001",
    wilaya: {
      id: 31,
      name: "Oran",
    },
  },
  {
    id: 1111,
    name: "Gdyel",
    wilaya_id: 31,
    zip_code: "31002",
    wilaya: {
      id: 31,
      name: "Oran",
    },
  },
  {
    id: 1112,
    name: "Bir El Djir",
    wilaya_id: 31,
    zip_code: "31003",
    wilaya: {
      id: 31,
      name: "Oran",
    },
  },
  {
    id: 1113,
    name: "Hassi Bounif",
    wilaya_id: 31,
    zip_code: "31004",
    wilaya: {
      id: 31,
      name: "Oran",
    },
  },
  {
    id: 1114,
    name: "Es Senia",
    wilaya_id: 31,
    zip_code: "31005",
    wilaya: {
      id: 31,
      name: "Oran",
    },
  },
  {
    id: 1115,
    name: "Arzew",
    wilaya_id: 31,
    zip_code: "31006",
    wilaya: {
      id: 31,
      name: "Oran",
    },
  },
  {
    id: 1116,
    name: "Bethioua",
    wilaya_id: 31,
    zip_code: "31007",
    wilaya: {
      id: 31,
      name: "Oran",
    },
  },
  {
    id: 1117,
    name: "Marsat El Hadjadj",
    wilaya_id: 31,
    zip_code: "31008",
    wilaya: {
      id: 31,
      name: "Oran",
    },
  },
  {
    id: 1118,
    name: "Ain Turk",
    wilaya_id: 31,
    zip_code: "31009",
    wilaya: {
      id: 31,
      name: "Oran",
    },
  },
  {
    id: 1119,
    name: "El Ançor",
    wilaya_id: 31,
    zip_code: "31010",
    wilaya: {
      id: 31,
      name: "Oran",
    },
  },
  {
    id: 1120,
    name: "Oued Tlelat",
    wilaya_id: 31,
    zip_code: "31011",
    wilaya: {
      id: 31,
      name: "Oran",
    },
  },
  {
    id: 1121,
    name: "Tafraoui",
    wilaya_id: 31,
    zip_code: "31012",
    wilaya: {
      id: 31,
      name: "Oran",
    },
  },
  {
    id: 1122,
    name: "Sidi Chami",
    wilaya_id: 31,
    zip_code: "31013",
    wilaya: {
      id: 31,
      name: "Oran",
    },
  },
  {
    id: 1123,
    name: "Boufatis",
    wilaya_id: 31,
    zip_code: "31014",
    wilaya: {
      id: 31,
      name: "Oran",
    },
  },
  {
    id: 1124,
    name: "Mers El Kébir",
    wilaya_id: 31,
    zip_code: "31015",
    wilaya: {
      id: 31,
      name: "Oran",
    },
  },
  {
    id: 1125,
    name: "Bou Sfer",
    wilaya_id: 31,
    zip_code: "31016",
    wilaya: {
      id: 31,
      name: "Oran",
    },
  },
  {
    id: 1126,
    name: "El Kerma",
    wilaya_id: 31,
    zip_code: "31017",
    wilaya: {
      id: 31,
      name: "Oran",
    },
  },
  {
    id: 1127,
    name: "El Braya",
    wilaya_id: 31,
    zip_code: "31018",
    wilaya: {
      id: 31,
      name: "Oran",
    },
  },
  {
    id: 1128,
    name: "Hassi Ben Okba",
    wilaya_id: 31,
    zip_code: "31019",
    wilaya: {
      id: 31,
      name: "Oran",
    },
  },
  {
    id: 1129,
    name: "Ben Freha",
    wilaya_id: 31,
    zip_code: "31020",
    wilaya: {
      id: 31,
      name: "Oran",
    },
  },
  {
    id: 1130,
    name: "Hassi Mefsoukh",
    wilaya_id: 31,
    zip_code: "31021",
    wilaya: {
      id: 31,
      name: "Oran",
    },
  },
  {
    id: 1131,
    name: "Sidi Benyebka",
    wilaya_id: 31,
    zip_code: "31022",
    wilaya: {
      id: 31,
      name: "Oran",
    },
  },
  {
    id: 1132,
    name: "Misserghin",
    wilaya_id: 31,
    zip_code: "31023",
    wilaya: {
      id: 31,
      name: "Oran",
    },
  },
  {
    id: 1133,
    name: "Boutlelis",
    wilaya_id: 31,
    zip_code: "31024",
    wilaya: {
      id: 31,
      name: "Oran",
    },
  },
  {
    id: 1134,
    name: "Aïn El Kerma",
    wilaya_id: 31,
    zip_code: "31025",
    wilaya: {
      id: 31,
      name: "Oran",
    },
  },
  {
    id: 1135,
    name: "Aïn El Bia",
    wilaya_id: 31,
    zip_code: "31026",
    wilaya: {
      id: 31,
      name: "Oran",
    },
  },
  {
    id: 1136,
    name: "El Bayadh",
    wilaya_id: 32,
    zip_code: "32001",
    wilaya: {
      id: 32,
      name: "El Bayadh",
    },
  },
  {
    id: 1137,
    name: "Rogassa",
    wilaya_id: 32,
    zip_code: "32002",
    wilaya: {
      id: 32,
      name: "El Bayadh",
    },
  },
  {
    id: 1138,
    name: "Stitten",
    wilaya_id: 32,
    zip_code: "32003",
    wilaya: {
      id: 32,
      name: "El Bayadh",
    },
  },
  {
    id: 1139,
    name: "Brezina",
    wilaya_id: 32,
    zip_code: "32004",
    wilaya: {
      id: 32,
      name: "El Bayadh",
    },
  },
  {
    id: 1140,
    name: "Ghassoul",
    wilaya_id: 32,
    zip_code: "32005",
    wilaya: {
      id: 32,
      name: "El Bayadh",
    },
  },
  {
    id: 1141,
    name: "Boualem",
    wilaya_id: 32,
    zip_code: "32006",
    wilaya: {
      id: 32,
      name: "El Bayadh",
    },
  },
  {
    id: 1142,
    name: "El Abiodh Sidi Cheikh",
    wilaya_id: 32,
    zip_code: "32007",
    wilaya: {
      id: 32,
      name: "El Bayadh",
    },
  },
  {
    id: 1143,
    name: "Aïn El Orak",
    wilaya_id: 32,
    zip_code: "32008",
    wilaya: {
      id: 32,
      name: "El Bayadh",
    },
  },
  {
    id: 1144,
    name: "Arbaouat",
    wilaya_id: 32,
    zip_code: "32009",
    wilaya: {
      id: 32,
      name: "El Bayadh",
    },
  },
  {
    id: 1145,
    name: "Bougtoub",
    wilaya_id: 32,
    zip_code: "32010",
    wilaya: {
      id: 32,
      name: "El Bayadh",
    },
  },
  {
    id: 1146,
    name: "El Kheiter",
    wilaya_id: 32,
    zip_code: "32011",
    wilaya: {
      id: 32,
      name: "El Bayadh",
    },
  },
  {
    id: 1147,
    name: "Kef El Ahmar",
    wilaya_id: 32,
    zip_code: "32012",
    wilaya: {
      id: 32,
      name: "El Bayadh",
    },
  },
  {
    id: 1148,
    name: "Boussemghoun",
    wilaya_id: 32,
    zip_code: "32013",
    wilaya: {
      id: 32,
      name: "El Bayadh",
    },
  },
  {
    id: 1149,
    name: "Chellala",
    wilaya_id: 32,
    zip_code: "32014",
    wilaya: {
      id: 32,
      name: "El Bayadh",
    },
  },
  {
    id: 1150,
    name: "Kraakda",
    wilaya_id: 32,
    zip_code: "32015",
    wilaya: {
      id: 32,
      name: "El Bayadh",
    },
  },
  {
    id: 1151,
    name: "El Bnoud",
    wilaya_id: 32,
    zip_code: "32016",
    wilaya: {
      id: 32,
      name: "El Bayadh",
    },
  },
  {
    id: 1152,
    name: "Cheguig",
    wilaya_id: 32,
    zip_code: "32017",
    wilaya: {
      id: 32,
      name: "El Bayadh",
    },
  },
  {
    id: 1153,
    name: "Sidi Ameur",
    wilaya_id: 32,
    zip_code: "32018",
    wilaya: {
      id: 32,
      name: "El Bayadh",
    },
  },
  {
    id: 1154,
    name: "El Mehara",
    wilaya_id: 32,
    zip_code: "32019",
    wilaya: {
      id: 32,
      name: "El Bayadh",
    },
  },
  {
    id: 1155,
    name: "Tousmouline",
    wilaya_id: 32,
    zip_code: "32020",
    wilaya: {
      id: 32,
      name: "El Bayadh",
    },
  },
  {
    id: 1156,
    name: "Sidi Slimane",
    wilaya_id: 32,
    zip_code: "32021",
    wilaya: {
      id: 32,
      name: "El Bayadh",
    },
  },
  {
    id: 1157,
    name: "Sidi Tifour",
    wilaya_id: 32,
    zip_code: "32022",
    wilaya: {
      id: 32,
      name: "El Bayadh",
    },
  },
  {
    id: 1158,
    name: "Illizi",
    wilaya_id: 33,
    zip_code: "33001",
    wilaya: {
      id: 33,
      name: "Illizi",
    },
  },
  {
    id: 1159,
    name: "Djanet",
    wilaya_id: 56,
    zip_code: "33002",
    wilaya: {
      id: 56,
      name: "Djanet",
    },
  },
  {
    id: 1160,
    name: "Debdeb",
    wilaya_id: 33,
    zip_code: "33003",
    wilaya: {
      id: 33,
      name: "Illizi",
    },
  },
  {
    id: 1161,
    name: "Bordj Omar Driss",
    wilaya_id: 33,
    zip_code: "33004",
    wilaya: {
      id: 33,
      name: "Illizi",
    },
  },
  {
    id: 1162,
    name: "Bordj El Haouas",
    wilaya_id: 56,
    zip_code: "33005",
    wilaya: {
      id: 56,
      name: "Djanet",
    },
  },
  {
    id: 1163,
    name: "In Amenas",
    wilaya_id: 33,
    zip_code: "33006",
    wilaya: {
      id: 33,
      name: "Illizi",
    },
  },
  {
    id: 1164,
    name: "Bordj Bou Arreridj",
    wilaya_id: 34,
    zip_code: "34001",
    wilaya: {
      id: 34,
      name: "Bordj Bou Arreridj",
    },
  },
  {
    id: 1165,
    name: "Ras El Oued",
    wilaya_id: 34,
    zip_code: "34002",
    wilaya: {
      id: 34,
      name: "Bordj Bou Arreridj",
    },
  },
  {
    id: 1166,
    name: "Bordj Zemoura",
    wilaya_id: 34,
    zip_code: "34003",
    wilaya: {
      id: 34,
      name: "Bordj Bou Arreridj",
    },
  },
  {
    id: 1167,
    name: "Mansoura",
    wilaya_id: 34,
    zip_code: "34004",
    wilaya: {
      id: 34,
      name: "Bordj Bou Arreridj",
    },
  },
  {
    id: 1168,
    name: "El M'hir",
    wilaya_id: 34,
    zip_code: "34005",
    wilaya: {
      id: 34,
      name: "Bordj Bou Arreridj",
    },
  },
  {
    id: 1169,
    name: "Ben Daoud",
    wilaya_id: 34,
    zip_code: "34006",
    wilaya: {
      id: 34,
      name: "Bordj Bou Arreridj",
    },
  },
  {
    id: 1170,
    name: "El Achir",
    wilaya_id: 34,
    zip_code: "34007",
    wilaya: {
      id: 34,
      name: "Bordj Bou Arreridj",
    },
  },
  {
    id: 1171,
    name: "Aïn Taghrout",
    wilaya_id: 34,
    zip_code: "34008",
    wilaya: {
      id: 34,
      name: "Bordj Bou Arreridj",
    },
  },
  {
    id: 1172,
    name: "Bordj Ghédir",
    wilaya_id: 34,
    zip_code: "34009",
    wilaya: {
      id: 34,
      name: "Bordj Bou Arreridj",
    },
  },
  {
    id: 1173,
    name: "Sidi Embarek",
    wilaya_id: 34,
    zip_code: "34010",
    wilaya: {
      id: 34,
      name: "Bordj Bou Arreridj",
    },
  },
  {
    id: 1174,
    name: "El Hamadia",
    wilaya_id: 34,
    zip_code: "34011",
    wilaya: {
      id: 34,
      name: "Bordj Bou Arreridj",
    },
  },
  {
    id: 1175,
    name: "Belimour",
    wilaya_id: 34,
    zip_code: "34012",
    wilaya: {
      id: 34,
      name: "Bordj Bou Arreridj",
    },
  },
  {
    id: 1176,
    name: "Medjana",
    wilaya_id: 34,
    zip_code: "34013",
    wilaya: {
      id: 34,
      name: "Bordj Bou Arreridj",
    },
  },
  {
    id: 1177,
    name: "Teniet En Nasr",
    wilaya_id: 34,
    zip_code: "34014",
    wilaya: {
      id: 34,
      name: "Bordj Bou Arreridj",
    },
  },
  {
    id: 1178,
    name: "Djaafra",
    wilaya_id: 34,
    zip_code: "34015",
    wilaya: {
      id: 34,
      name: "Bordj Bou Arreridj",
    },
  },
  {
    id: 1179,
    name: "El Main",
    wilaya_id: 34,
    zip_code: "34016",
    wilaya: {
      id: 34,
      name: "Bordj Bou Arreridj",
    },
  },
  {
    id: 1180,
    name: "Ouled Brahem",
    wilaya_id: 34,
    zip_code: "34017",
    wilaya: {
      id: 34,
      name: "Bordj Bou Arreridj",
    },
  },
  {
    id: 1181,
    name: "Ouled Dahmane",
    wilaya_id: 34,
    zip_code: "34018",
    wilaya: {
      id: 34,
      name: "Bordj Bou Arreridj",
    },
  },
  {
    id: 1182,
    name: "Hasnaoua",
    wilaya_id: 34,
    zip_code: "34019",
    wilaya: {
      id: 34,
      name: "Bordj Bou Arreridj",
    },
  },
  {
    id: 1183,
    name: "Khelil",
    wilaya_id: 34,
    zip_code: "34020",
    wilaya: {
      id: 34,
      name: "Bordj Bou Arreridj",
    },
  },
  {
    id: 1184,
    name: "Taglait",
    wilaya_id: 34,
    zip_code: "34021",
    wilaya: {
      id: 34,
      name: "Bordj Bou Arreridj",
    },
  },
  {
    id: 1185,
    name: "Ksour",
    wilaya_id: 34,
    zip_code: "34022",
    wilaya: {
      id: 34,
      name: "Bordj Bou Arreridj",
    },
  },
  {
    id: 1186,
    name: "Ouled Sidi Brahim",
    wilaya_id: 34,
    zip_code: "34023",
    wilaya: {
      id: 34,
      name: "Bordj Bou Arreridj",
    },
  },
  {
    id: 1187,
    name: "Tefreg",
    wilaya_id: 34,
    zip_code: "34024",
    wilaya: {
      id: 34,
      name: "Bordj Bou Arreridj",
    },
  },
  {
    id: 1188,
    name: "Colla",
    wilaya_id: 34,
    zip_code: "34025",
    wilaya: {
      id: 34,
      name: "Bordj Bou Arreridj",
    },
  },
  {
    id: 1189,
    name: "Tixter",
    wilaya_id: 34,
    zip_code: "34026",
    wilaya: {
      id: 34,
      name: "Bordj Bou Arreridj",
    },
  },
  {
    id: 1190,
    name: "El Ach",
    wilaya_id: 34,
    zip_code: "34027",
    wilaya: {
      id: 34,
      name: "Bordj Bou Arreridj",
    },
  },
  {
    id: 1191,
    name: "El Anseur",
    wilaya_id: 34,
    zip_code: "34028",
    wilaya: {
      id: 34,
      name: "Bordj Bou Arreridj",
    },
  },
  {
    id: 1192,
    name: "Tassameurt",
    wilaya_id: 34,
    zip_code: "34029",
    wilaya: {
      id: 34,
      name: "Bordj Bou Arreridj",
    },
  },
  {
    id: 1193,
    name: "Aïn Tesra",
    wilaya_id: 34,
    zip_code: "34030",
    wilaya: {
      id: 34,
      name: "Bordj Bou Arreridj",
    },
  },
  {
    id: 1194,
    name: "Bir Kasdali",
    wilaya_id: 34,
    zip_code: "34031",
    wilaya: {
      id: 34,
      name: "Bordj Bou Arreridj",
    },
  },
  {
    id: 1195,
    name: "Ghilassa",
    wilaya_id: 34,
    zip_code: "34032",
    wilaya: {
      id: 34,
      name: "Bordj Bou Arreridj",
    },
  },
  {
    id: 1196,
    name: "Rabta",
    wilaya_id: 34,
    zip_code: "34033",
    wilaya: {
      id: 34,
      name: "Bordj Bou Arreridj",
    },
  },
  {
    id: 1197,
    name: "Haraza",
    wilaya_id: 34,
    zip_code: "34034",
    wilaya: {
      id: 34,
      name: "Bordj Bou Arreridj",
    },
  },
  {
    id: 1198,
    name: "Boumerdes",
    wilaya_id: 35,
    zip_code: "35001",
    wilaya: {
      id: 35,
      name: "Boumerdès",
    },
  },
  {
    id: 1199,
    name: "Boudouaou",
    wilaya_id: 35,
    zip_code: "35002",
    wilaya: {
      id: 35,
      name: "Boumerdès",
    },
  },
  {
    id: 1200,
    name: "Afir",
    wilaya_id: 35,
    zip_code: "35004",
    wilaya: {
      id: 35,
      name: "Boumerdès",
    },
  },
  {
    id: 1201,
    name: "Bordj Menaiel",
    wilaya_id: 35,
    zip_code: "35005",
    wilaya: {
      id: 35,
      name: "Boumerdès",
    },
  },
  {
    id: 1202,
    name: "Baghlia",
    wilaya_id: 35,
    zip_code: "35006",
    wilaya: {
      id: 35,
      name: "Boumerdès",
    },
  },
  {
    id: 1203,
    name: "Sidi Daoud",
    wilaya_id: 35,
    zip_code: "35007",
    wilaya: {
      id: 35,
      name: "Boumerdès",
    },
  },
  {
    id: 1204,
    name: "Naciria",
    wilaya_id: 35,
    zip_code: "35008",
    wilaya: {
      id: 35,
      name: "Boumerdès",
    },
  },
  {
    id: 1205,
    name: "Djinet",
    wilaya_id: 35,
    zip_code: "35009",
    wilaya: {
      id: 35,
      name: "Boumerdès",
    },
  },
  {
    id: 1206,
    name: "Issers",
    wilaya_id: 35,
    zip_code: "35010",
    wilaya: {
      id: 35,
      name: "Boumerdès",
    },
  },
  {
    id: 1207,
    name: "Zemmouri",
    wilaya_id: 35,
    zip_code: "35011",
    wilaya: {
      id: 35,
      name: "Boumerdès",
    },
  },
  {
    id: 1208,
    name: "Si Mustapha",
    wilaya_id: 35,
    zip_code: "35012",
    wilaya: {
      id: 35,
      name: "Boumerdès",
    },
  },
  {
    id: 1209,
    name: "Tidjelabine",
    wilaya_id: 35,
    zip_code: "35013",
    wilaya: {
      id: 35,
      name: "Boumerdès",
    },
  },
  {
    id: 1210,
    name: "Chabet El Ameur",
    wilaya_id: 35,
    zip_code: "35014",
    wilaya: {
      id: 35,
      name: "Boumerdès",
    },
  },
  {
    id: 1211,
    name: "Thenia",
    wilaya_id: 35,
    zip_code: "35015",
    wilaya: {
      id: 35,
      name: "Boumerdès",
    },
  },
  {
    id: 1212,
    name: "Timezrit",
    wilaya_id: 35,
    zip_code: "35018",
    wilaya: {
      id: 35,
      name: "Boumerdès",
    },
  },
  {
    id: 1213,
    name: "Corso",
    wilaya_id: 35,
    zip_code: "35019",
    wilaya: {
      id: 35,
      name: "Boumerdès",
    },
  },
  {
    id: 1214,
    name: "Ouled Moussa",
    wilaya_id: 35,
    zip_code: "35020",
    wilaya: {
      id: 35,
      name: "Boumerdès",
    },
  },
  {
    id: 1215,
    name: "Leghata",
    wilaya_id: 35,
    zip_code: "35021",
    wilaya: {
      id: 35,
      name: "Boumerdès",
    },
  },
  {
    id: 1216,
    name: "Bouzegza Keddara",
    wilaya_id: 35,
    zip_code: "35022",
    wilaya: {
      id: 35,
      name: "Boumerdès",
    },
  },
  {
    id: 1217,
    name: "Taourga",
    wilaya_id: 35,
    zip_code: "35025",
    wilaya: {
      id: 35,
      name: "Boumerdès",
    },
  },
  {
    id: 1218,
    name: "Ouled Aissa",
    wilaya_id: 35,
    zip_code: "35026",
    wilaya: {
      id: 35,
      name: "Boumerdès",
    },
  },
  {
    id: 1219,
    name: "Ben Choud",
    wilaya_id: 35,
    zip_code: "35027",
    wilaya: {
      id: 35,
      name: "Boumerdès",
    },
  },
  {
    id: 1220,
    name: "Dellys",
    wilaya_id: 35,
    zip_code: "35028",
    wilaya: {
      id: 35,
      name: "Boumerdès",
    },
  },
  {
    id: 1221,
    name: "Ammal",
    wilaya_id: 35,
    zip_code: "35029",
    wilaya: {
      id: 35,
      name: "Boumerdès",
    },
  },
  {
    id: 1222,
    name: "Beni Amrane",
    wilaya_id: 35,
    zip_code: "35030",
    wilaya: {
      id: 35,
      name: "Boumerdès",
    },
  },
  {
    id: 1223,
    name: "Souk El Had",
    wilaya_id: 35,
    zip_code: "35031",
    wilaya: {
      id: 35,
      name: "Boumerdès",
    },
  },
  {
    id: 1224,
    name: "Boudouaou El Bahri",
    wilaya_id: 35,
    zip_code: "35032",
    wilaya: {
      id: 35,
      name: "Boumerdès",
    },
  },
  {
    id: 1225,
    name: "Ouled Hedadj",
    wilaya_id: 35,
    zip_code: "35033",
    wilaya: {
      id: 35,
      name: "Boumerdès",
    },
  },
  {
    id: 1226,
    name: "Larbatache",
    wilaya_id: 35,
    zip_code: "35035",
    wilaya: {
      id: 35,
      name: "Boumerdès",
    },
  },
  {
    id: 1227,
    name: "Hammedi",
    wilaya_id: 35,
    zip_code: "35036",
    wilaya: {
      id: 35,
      name: "Boumerdès",
    },
  },
  {
    id: 1228,
    name: "Khemis El Khechna",
    wilaya_id: 35,
    zip_code: "35037",
    wilaya: {
      id: 35,
      name: "Boumerdès",
    },
  },
  {
    id: 1229,
    name: "El Kharrouba",
    wilaya_id: 35,
    zip_code: "35038",
    wilaya: {
      id: 35,
      name: "Boumerdès",
    },
  },
  {
    id: 1230,
    name: "El Tarf",
    wilaya_id: 36,
    zip_code: "36001",
    wilaya: {
      id: 36,
      name: "El Tarf",
    },
  },
  {
    id: 1231,
    name: "Bouhadjar",
    wilaya_id: 36,
    zip_code: "36002",
    wilaya: {
      id: 36,
      name: "El Tarf",
    },
  },
  {
    id: 1232,
    name: "Ben Mehidi",
    wilaya_id: 36,
    zip_code: "36003",
    wilaya: {
      id: 36,
      name: "El Tarf",
    },
  },
  {
    id: 1233,
    name: "Bougous",
    wilaya_id: 36,
    zip_code: "36004",
    wilaya: {
      id: 36,
      name: "El Tarf",
    },
  },
  {
    id: 1234,
    name: "El Kala",
    wilaya_id: 36,
    zip_code: "36005",
    wilaya: {
      id: 36,
      name: "El Tarf",
    },
  },
  {
    id: 1235,
    name: "Aïn El Assel",
    wilaya_id: 36,
    zip_code: "36006",
    wilaya: {
      id: 36,
      name: "El Tarf",
    },
  },
  {
    id: 1236,
    name: "El Aioun",
    wilaya_id: 36,
    zip_code: "36007",
    wilaya: {
      id: 36,
      name: "El Tarf",
    },
  },
  {
    id: 1237,
    name: "Bouteldja",
    wilaya_id: 36,
    zip_code: "36008",
    wilaya: {
      id: 36,
      name: "El Tarf",
    },
  },
  {
    id: 1238,
    name: "Souarekh",
    wilaya_id: 36,
    zip_code: "36009",
    wilaya: {
      id: 36,
      name: "El Tarf",
    },
  },
  {
    id: 1239,
    name: "Berrihane",
    wilaya_id: 36,
    zip_code: "36010",
    wilaya: {
      id: 36,
      name: "El Tarf",
    },
  },
  {
    id: 1240,
    name: "Lac Des Oiseaux",
    wilaya_id: 36,
    zip_code: "36011",
    wilaya: {
      id: 36,
      name: "El Tarf",
    },
  },
  {
    id: 1241,
    name: "Chefia",
    wilaya_id: 36,
    zip_code: "36012",
    wilaya: {
      id: 36,
      name: "El Tarf",
    },
  },
  {
    id: 1242,
    name: "Dréan",
    wilaya_id: 36,
    zip_code: "36013",
    wilaya: {
      id: 36,
      name: "El Tarf",
    },
  },
  {
    id: 1243,
    name: "Chihani",
    wilaya_id: 36,
    zip_code: "36014",
    wilaya: {
      id: 36,
      name: "El Tarf",
    },
  },
  {
    id: 1244,
    name: "Chebaita Mokhtar",
    wilaya_id: 36,
    zip_code: "36015",
    wilaya: {
      id: 36,
      name: "El Tarf",
    },
  },
  {
    id: 1245,
    name: "Besbes",
    wilaya_id: 36,
    zip_code: "36016",
    wilaya: {
      id: 36,
      name: "El Tarf",
    },
  },
  {
    id: 1246,
    name: "Asfour",
    wilaya_id: 36,
    zip_code: "36017",
    wilaya: {
      id: 36,
      name: "El Tarf",
    },
  },
  {
    id: 1247,
    name: "Echatt",
    wilaya_id: 36,
    zip_code: "36018",
    wilaya: {
      id: 36,
      name: "El Tarf",
    },
  },
  {
    id: 1248,
    name: "Zerizer",
    wilaya_id: 36,
    zip_code: "36019",
    wilaya: {
      id: 36,
      name: "El Tarf",
    },
  },
  {
    id: 1249,
    name: "Zitouna",
    wilaya_id: 36,
    zip_code: "36020",
    wilaya: {
      id: 36,
      name: "El Tarf",
    },
  },
  {
    id: 1250,
    name: "Ain Kerma",
    wilaya_id: 36,
    zip_code: "36021",
    wilaya: {
      id: 36,
      name: "El Tarf",
    },
  },
  {
    id: 1251,
    name: "Oued Zitoun",
    wilaya_id: 36,
    zip_code: "36022",
    wilaya: {
      id: 36,
      name: "El Tarf",
    },
  },
  {
    id: 1252,
    name: "Hammam Beni Salah",
    wilaya_id: 36,
    zip_code: "36023",
    wilaya: {
      id: 36,
      name: "El Tarf",
    },
  },
  {
    id: 1253,
    name: "Raml Souk",
    wilaya_id: 36,
    zip_code: "36024",
    wilaya: {
      id: 36,
      name: "El Tarf",
    },
  },
  {
    id: 1254,
    name: "Tindouf",
    wilaya_id: 37,
    zip_code: "37001",
    wilaya: {
      id: 37,
      name: "Tindouf",
    },
  },
  {
    id: 1255,
    name: "Oum El Assel",
    wilaya_id: 37,
    zip_code: "37002",
    wilaya: {
      id: 37,
      name: "Tindouf",
    },
  },
  {
    id: 1256,
    name: "Tissemsilt",
    wilaya_id: 38,
    zip_code: "38001",
    wilaya: {
      id: 38,
      name: "Tissemsilt",
    },
  },
  {
    id: 1257,
    name: "Bordj Bou Naama",
    wilaya_id: 38,
    zip_code: "38002",
    wilaya: {
      id: 38,
      name: "Tissemsilt",
    },
  },
  {
    id: 1258,
    name: "Theniet El Had",
    wilaya_id: 38,
    zip_code: "38003",
    wilaya: {
      id: 38,
      name: "Tissemsilt",
    },
  },
  {
    id: 1259,
    name: "Lazharia",
    wilaya_id: 38,
    zip_code: "38004",
    wilaya: {
      id: 38,
      name: "Tissemsilt",
    },
  },
  {
    id: 1260,
    name: "Beni Chaib",
    wilaya_id: 38,
    zip_code: "38005",
    wilaya: {
      id: 38,
      name: "Tissemsilt",
    },
  },
  {
    id: 1261,
    name: "Lardjem",
    wilaya_id: 38,
    zip_code: "38006",
    wilaya: {
      id: 38,
      name: "Tissemsilt",
    },
  },
  {
    id: 1262,
    name: "Melaab",
    wilaya_id: 38,
    zip_code: "38007",
    wilaya: {
      id: 38,
      name: "Tissemsilt",
    },
  },
  {
    id: 1263,
    name: "Sidi Lantri",
    wilaya_id: 38,
    zip_code: "38008",
    wilaya: {
      id: 38,
      name: "Tissemsilt",
    },
  },
  {
    id: 1264,
    name: "Bordj El Emir Abdelkader",
    wilaya_id: 38,
    zip_code: "38009",
    wilaya: {
      id: 38,
      name: "Tissemsilt",
    },
  },
  {
    id: 1265,
    name: "Layoune",
    wilaya_id: 38,
    zip_code: "38010",
    wilaya: {
      id: 38,
      name: "Tissemsilt",
    },
  },
  {
    id: 1266,
    name: "Khemisti",
    wilaya_id: 38,
    zip_code: "38011",
    wilaya: {
      id: 38,
      name: "Tissemsilt",
    },
  },
  {
    id: 1267,
    name: "Ouled Bessem",
    wilaya_id: 38,
    zip_code: "38012",
    wilaya: {
      id: 38,
      name: "Tissemsilt",
    },
  },
  {
    id: 1268,
    name: "Ammari",
    wilaya_id: 38,
    zip_code: "38013",
    wilaya: {
      id: 38,
      name: "Tissemsilt",
    },
  },
  {
    id: 1269,
    name: "Youssoufia",
    wilaya_id: 38,
    zip_code: "38014",
    wilaya: {
      id: 38,
      name: "Tissemsilt",
    },
  },
  {
    id: 1270,
    name: "Sidi Boutouchent",
    wilaya_id: 38,
    zip_code: "38015",
    wilaya: {
      id: 38,
      name: "Tissemsilt",
    },
  },
  {
    id: 1271,
    name: "Larbaa",
    wilaya_id: 38,
    zip_code: "38016",
    wilaya: {
      id: 38,
      name: "Tissemsilt",
    },
  },
  {
    id: 1272,
    name: "Maacem",
    wilaya_id: 38,
    zip_code: "38017",
    wilaya: {
      id: 38,
      name: "Tissemsilt",
    },
  },
  {
    id: 1273,
    name: "Sidi Abed",
    wilaya_id: 38,
    zip_code: "38018",
    wilaya: {
      id: 38,
      name: "Tissemsilt",
    },
  },
  {
    id: 1274,
    name: "Tamalaht",
    wilaya_id: 38,
    zip_code: "38019",
    wilaya: {
      id: 38,
      name: "Tissemsilt",
    },
  },
  {
    id: 1275,
    name: "Sidi Slimane",
    wilaya_id: 38,
    zip_code: "38020",
    wilaya: {
      id: 38,
      name: "Tissemsilt",
    },
  },
  {
    id: 1276,
    name: "Boucaid",
    wilaya_id: 38,
    zip_code: "38021",
    wilaya: {
      id: 38,
      name: "Tissemsilt",
    },
  },
  {
    id: 1277,
    name: "Beni Lahcene",
    wilaya_id: 38,
    zip_code: "38022",
    wilaya: {
      id: 38,
      name: "Tissemsilt",
    },
  },
  {
    id: 1278,
    name: "El Oued",
    wilaya_id: 39,
    zip_code: "39001",
    wilaya: {
      id: 39,
      name: "El Oued",
    },
  },
  {
    id: 1279,
    name: "Robbah",
    wilaya_id: 39,
    zip_code: "39002",
    wilaya: {
      id: 39,
      name: "El Oued",
    },
  },
  {
    id: 1280,
    name: "Oued El Alenda",
    wilaya_id: 39,
    zip_code: "39003",
    wilaya: {
      id: 39,
      name: "El Oued",
    },
  },
  {
    id: 1281,
    name: "Bayadha",
    wilaya_id: 39,
    zip_code: "39004",
    wilaya: {
      id: 39,
      name: "El Oued",
    },
  },
  {
    id: 1282,
    name: "Nakhla",
    wilaya_id: 39,
    zip_code: "39005",
    wilaya: {
      id: 39,
      name: "El Oued",
    },
  },
  {
    id: 1283,
    name: "Guemar",
    wilaya_id: 39,
    zip_code: "39006",
    wilaya: {
      id: 39,
      name: "El Oued",
    },
  },
  {
    id: 1284,
    name: "Kouinine",
    wilaya_id: 39,
    zip_code: "39007",
    wilaya: {
      id: 39,
      name: "El Oued",
    },
  },
  {
    id: 1285,
    name: "Reguiba",
    wilaya_id: 39,
    zip_code: "39008",
    wilaya: {
      id: 39,
      name: "El Oued",
    },
  },
  {
    id: 1286,
    name: "Hamraia",
    wilaya_id: 39,
    zip_code: "39009",
    wilaya: {
      id: 39,
      name: "El Oued",
    },
  },
  {
    id: 1287,
    name: "Taghzout",
    wilaya_id: 39,
    zip_code: "39010",
    wilaya: {
      id: 39,
      name: "El Oued",
    },
  },
  {
    id: 1288,
    name: "Debila",
    wilaya_id: 39,
    zip_code: "39011",
    wilaya: {
      id: 39,
      name: "El Oued",
    },
  },
  {
    id: 1289,
    name: "Hassani Abdelkrim",
    wilaya_id: 39,
    zip_code: "39012",
    wilaya: {
      id: 39,
      name: "El Oued",
    },
  },
  {
    id: 1290,
    name: "Hassi Khalifa",
    wilaya_id: 39,
    zip_code: "39013",
    wilaya: {
      id: 39,
      name: "El Oued",
    },
  },
  {
    id: 1291,
    name: "Taleb Larbi",
    wilaya_id: 39,
    zip_code: "39014",
    wilaya: {
      id: 39,
      name: "El Oued",
    },
  },
  {
    id: 1292,
    name: "Douar El Ma",
    wilaya_id: 39,
    zip_code: "39015",
    wilaya: {
      id: 39,
      name: "El Oued",
    },
  },
  {
    id: 1293,
    name: "Sidi Aoun",
    wilaya_id: 39,
    zip_code: "39016",
    wilaya: {
      id: 39,
      name: "El Oued",
    },
  },
  {
    id: 1294,
    name: "Trifaoui",
    wilaya_id: 39,
    zip_code: "39017",
    wilaya: {
      id: 39,
      name: "El Oued",
    },
  },
  {
    id: 1295,
    name: "Magrane",
    wilaya_id: 39,
    zip_code: "39018",
    wilaya: {
      id: 39,
      name: "El Oued",
    },
  },
  {
    id: 1296,
    name: "Beni Guecha",
    wilaya_id: 39,
    zip_code: "39019",
    wilaya: {
      id: 39,
      name: "El Oued",
    },
  },
  {
    id: 1297,
    name: "Ourmas",
    wilaya_id: 39,
    zip_code: "39020",
    wilaya: {
      id: 39,
      name: "El Oued",
    },
  },
  {
    id: 1298,
    name: "Still",
    wilaya_id: 57,
    zip_code: "39021",
    wilaya: {
      id: 57,
      name: "El M'Ghair",
    },
  },
  {
    id: 1299,
    name: "M'Rara",
    wilaya_id: 57,
    zip_code: "39022",
    wilaya: {
      id: 57,
      name: "El M'Ghair",
    },
  },
  {
    id: 1300,
    name: "Sidi Khellil",
    wilaya_id: 57,
    zip_code: "39023",
    wilaya: {
      id: 57,
      name: "El M'Ghair",
    },
  },
  {
    id: 1301,
    name: "Tendla",
    wilaya_id: 57,
    zip_code: "39024",
    wilaya: {
      id: 57,
      name: "El M'Ghair",
    },
  },
  {
    id: 1302,
    name: "El Ogla",
    wilaya_id: 39,
    zip_code: "39025",
    wilaya: {
      id: 39,
      name: "El Oued",
    },
  },
  {
    id: 1303,
    name: "Mih Ouansa",
    wilaya_id: 39,
    zip_code: "39026",
    wilaya: {
      id: 39,
      name: "El Oued",
    },
  },
  {
    id: 1304,
    name: "El M'Ghair",
    wilaya_id: 57,
    zip_code: "39027",
    wilaya: {
      id: 57,
      name: "El M'Ghair",
    },
  },
  {
    id: 1305,
    name: "Djamaa",
    wilaya_id: 57,
    zip_code: "39028",
    wilaya: {
      id: 57,
      name: "El M'Ghair",
    },
  },
  {
    id: 1306,
    name: "Oum Touyour",
    wilaya_id: 57,
    zip_code: "39029",
    wilaya: {
      id: 57,
      name: "El M'Ghair",
    },
  },
  {
    id: 1307,
    name: "Sidi Amrane",
    wilaya_id: 57,
    zip_code: "39030",
    wilaya: {
      id: 57,
      name: "El M'Ghair",
    },
  },
  {
    id: 1308,
    name: "Khenchela",
    wilaya_id: 40,
    zip_code: "40001",
    wilaya: {
      id: 40,
      name: "Khenchela",
    },
  },
  {
    id: 1309,
    name: "M'Toussa",
    wilaya_id: 40,
    zip_code: "40002",
    wilaya: {
      id: 40,
      name: "Khenchela",
    },
  },
  {
    id: 1310,
    name: "Kais",
    wilaya_id: 40,
    zip_code: "40003",
    wilaya: {
      id: 40,
      name: "Khenchela",
    },
  },
  {
    id: 1311,
    name: "Baghai",
    wilaya_id: 40,
    zip_code: "40004",
    wilaya: {
      id: 40,
      name: "Khenchela",
    },
  },
  {
    id: 1312,
    name: "El Hamma",
    wilaya_id: 40,
    zip_code: "40005",
    wilaya: {
      id: 40,
      name: "Khenchela",
    },
  },
  {
    id: 1313,
    name: "Aïn Touila",
    wilaya_id: 40,
    zip_code: "40006",
    wilaya: {
      id: 40,
      name: "Khenchela",
    },
  },
  {
    id: 1314,
    name: "Taouzient",
    wilaya_id: 40,
    zip_code: "40007",
    wilaya: {
      id: 40,
      name: "Khenchela",
    },
  },
  {
    id: 1315,
    name: "Bouhmama",
    wilaya_id: 40,
    zip_code: "40008",
    wilaya: {
      id: 40,
      name: "Khenchela",
    },
  },
  {
    id: 1316,
    name: "El Oueldja",
    wilaya_id: 40,
    zip_code: "40009",
    wilaya: {
      id: 40,
      name: "Khenchela",
    },
  },
  {
    id: 1317,
    name: "Remila",
    wilaya_id: 40,
    zip_code: "40010",
    wilaya: {
      id: 40,
      name: "Khenchela",
    },
  },
  {
    id: 1318,
    name: "Chelia",
    wilaya_id: 40,
    zip_code: "40011",
    wilaya: {
      id: 40,
      name: "Khenchela",
    },
  },
  {
    id: 1319,
    name: "Djellal",
    wilaya_id: 40,
    zip_code: "40012",
    wilaya: {
      id: 40,
      name: "Khenchela",
    },
  },
  {
    id: 1320,
    name: "Babar",
    wilaya_id: 40,
    zip_code: "40013",
    wilaya: {
      id: 40,
      name: "Khenchela",
    },
  },
  {
    id: 1321,
    name: "Tamza",
    wilaya_id: 40,
    zip_code: "40014",
    wilaya: {
      id: 40,
      name: "Khenchela",
    },
  },
  {
    id: 1322,
    name: "Ensigha",
    wilaya_id: 40,
    zip_code: "40015",
    wilaya: {
      id: 40,
      name: "Khenchela",
    },
  },
  {
    id: 1323,
    name: "Ouled Rechache",
    wilaya_id: 40,
    zip_code: "40016",
    wilaya: {
      id: 40,
      name: "Khenchela",
    },
  },
  {
    id: 1324,
    name: "El Mahmal",
    wilaya_id: 40,
    zip_code: "40017",
    wilaya: {
      id: 40,
      name: "Khenchela",
    },
  },
  {
    id: 1325,
    name: "M'Sara",
    wilaya_id: 40,
    zip_code: "40018",
    wilaya: {
      id: 40,
      name: "Khenchela",
    },
  },
  {
    id: 1326,
    name: "Yabous",
    wilaya_id: 40,
    zip_code: "40019",
    wilaya: {
      id: 40,
      name: "Khenchela",
    },
  },
  {
    id: 1327,
    name: "Khirane",
    wilaya_id: 40,
    zip_code: "40020",
    wilaya: {
      id: 40,
      name: "Khenchela",
    },
  },
  {
    id: 1328,
    name: "Chechar",
    wilaya_id: 40,
    zip_code: "40021",
    wilaya: {
      id: 40,
      name: "Khenchela",
    },
  },
  {
    id: 1329,
    name: "Souk Ahras",
    wilaya_id: 41,
    zip_code: "41001",
    wilaya: {
      id: 41,
      name: "Souk Ahras",
    },
  },
  {
    id: 1330,
    name: "Sedrata",
    wilaya_id: 41,
    zip_code: "41002",
    wilaya: {
      id: 41,
      name: "Souk Ahras",
    },
  },
  {
    id: 1331,
    name: "Heddada",
    wilaya_id: 41,
    zip_code: "41003",
    wilaya: {
      id: 41,
      name: "Souk Ahras",
    },
  },
  {
    id: 1332,
    name: "Mechroha",
    wilaya_id: 41,
    zip_code: "41004",
    wilaya: {
      id: 41,
      name: "Souk Ahras",
    },
  },
  {
    id: 1333,
    name: "Ouled Driss",
    wilaya_id: 41,
    zip_code: "41005",
    wilaya: {
      id: 41,
      name: "Souk Ahras",
    },
  },
  {
    id: 1334,
    name: "Tiffech",
    wilaya_id: 41,
    zip_code: "41006",
    wilaya: {
      id: 41,
      name: "Souk Ahras",
    },
  },
  {
    id: 1335,
    name: "Zaarouria",
    wilaya_id: 41,
    zip_code: "41007",
    wilaya: {
      id: 41,
      name: "Souk Ahras",
    },
  },
  {
    id: 1336,
    name: "Taoura",
    wilaya_id: 41,
    zip_code: "41008",
    wilaya: {
      id: 41,
      name: "Souk Ahras",
    },
  },
  {
    id: 1337,
    name: "Drea",
    wilaya_id: 41,
    zip_code: "41009",
    wilaya: {
      id: 41,
      name: "Souk Ahras",
    },
  },
  {
    id: 1338,
    name: "Hanancha",
    wilaya_id: 41,
    zip_code: "41010",
    wilaya: {
      id: 41,
      name: "Souk Ahras",
    },
  },
  {
    id: 1339,
    name: "Khedara",
    wilaya_id: 41,
    zip_code: "41011",
    wilaya: {
      id: 41,
      name: "Souk Ahras",
    },
  },
  {
    id: 1340,
    name: "Merahna",
    wilaya_id: 41,
    zip_code: "41012",
    wilaya: {
      id: 41,
      name: "Souk Ahras",
    },
  },
  {
    id: 1341,
    name: "Ouled Moumene",
    wilaya_id: 41,
    zip_code: "41013",
    wilaya: {
      id: 41,
      name: "Souk Ahras",
    },
  },
  {
    id: 1342,
    name: "Bir Bou Haouch",
    wilaya_id: 41,
    zip_code: "41014",
    wilaya: {
      id: 41,
      name: "Souk Ahras",
    },
  },
  {
    id: 1343,
    name: "M'daourouch",
    wilaya_id: 41,
    zip_code: "41015",
    wilaya: {
      id: 41,
      name: "Souk Ahras",
    },
  },
  {
    id: 1344,
    name: "Oum El Adhaim",
    wilaya_id: 41,
    zip_code: "41016",
    wilaya: {
      id: 41,
      name: "Souk Ahras",
    },
  },
  {
    id: 1345,
    name: "Aïn Zana",
    wilaya_id: 41,
    zip_code: "41017",
    wilaya: {
      id: 41,
      name: "Souk Ahras",
    },
  },
  {
    id: 1346,
    name: "Ain Soltane",
    wilaya_id: 41,
    zip_code: "41018",
    wilaya: {
      id: 41,
      name: "Souk Ahras",
    },
  },
  {
    id: 1347,
    name: "Ouillen",
    wilaya_id: 41,
    zip_code: "41019",
    wilaya: {
      id: 41,
      name: "Souk Ahras",
    },
  },
  {
    id: 1348,
    name: "Sidi Fredj",
    wilaya_id: 41,
    zip_code: "41020",
    wilaya: {
      id: 41,
      name: "Souk Ahras",
    },
  },
  {
    id: 1349,
    name: "Safel El Ouiden",
    wilaya_id: 41,
    zip_code: "41021",
    wilaya: {
      id: 41,
      name: "Souk Ahras",
    },
  },
  {
    id: 1350,
    name: "Ragouba",
    wilaya_id: 41,
    zip_code: "41022",
    wilaya: {
      id: 41,
      name: "Souk Ahras",
    },
  },
  {
    id: 1351,
    name: "Khemissa",
    wilaya_id: 41,
    zip_code: "41023",
    wilaya: {
      id: 41,
      name: "Souk Ahras",
    },
  },
  {
    id: 1352,
    name: "Oued Keberit",
    wilaya_id: 41,
    zip_code: "41024",
    wilaya: {
      id: 41,
      name: "Souk Ahras",
    },
  },
  {
    id: 1353,
    name: "Terraguelt",
    wilaya_id: 41,
    zip_code: "41025",
    wilaya: {
      id: 41,
      name: "Souk Ahras",
    },
  },
  {
    id: 1354,
    name: "Zouabi",
    wilaya_id: 41,
    zip_code: "41026",
    wilaya: {
      id: 41,
      name: "Souk Ahras",
    },
  },
  {
    id: 1355,
    name: "Tipaza",
    wilaya_id: 42,
    zip_code: "42001",
    wilaya: {
      id: 42,
      name: "Tipaza",
    },
  },
  {
    id: 1356,
    name: "Menaceur",
    wilaya_id: 42,
    zip_code: "42002",
    wilaya: {
      id: 42,
      name: "Tipaza",
    },
  },
  {
    id: 1357,
    name: "Larhat",
    wilaya_id: 42,
    zip_code: "42003",
    wilaya: {
      id: 42,
      name: "Tipaza",
    },
  },
  {
    id: 1358,
    name: "Douaouda",
    wilaya_id: 42,
    zip_code: "42004",
    wilaya: {
      id: 42,
      name: "Tipaza",
    },
  },
  {
    id: 1359,
    name: "Bourkika",
    wilaya_id: 42,
    zip_code: "42005",
    wilaya: {
      id: 42,
      name: "Tipaza",
    },
  },
  {
    id: 1360,
    name: "Khemisti",
    wilaya_id: 42,
    zip_code: "42006",
    wilaya: {
      id: 42,
      name: "Tipaza",
    },
  },
  {
    id: 1361,
    name: "Aghbal",
    wilaya_id: 42,
    zip_code: "42010",
    wilaya: {
      id: 42,
      name: "Tipaza",
    },
  },
  {
    id: 1362,
    name: "Hadjout",
    wilaya_id: 42,
    zip_code: "42012",
    wilaya: {
      id: 42,
      name: "Tipaza",
    },
  },
  {
    id: 1363,
    name: "Sidi Amar",
    wilaya_id: 42,
    zip_code: "42013",
    wilaya: {
      id: 42,
      name: "Tipaza",
    },
  },
  {
    id: 1364,
    name: "Gouraya",
    wilaya_id: 42,
    zip_code: "42014",
    wilaya: {
      id: 42,
      name: "Tipaza",
    },
  },
  {
    id: 1365,
    name: "Nador",
    wilaya_id: 42,
    zip_code: "42015",
    wilaya: {
      id: 42,
      name: "Tipaza",
    },
  },
  {
    id: 1366,
    name: "Chaiba",
    wilaya_id: 42,
    zip_code: "42016",
    wilaya: {
      id: 42,
      name: "Tipaza",
    },
  },
  {
    id: 1367,
    name: "Aïn Tagourait",
    wilaya_id: 42,
    zip_code: "42017",
    wilaya: {
      id: 42,
      name: "Tipaza",
    },
  },
  {
    id: 1368,
    name: "Cherchell",
    wilaya_id: 42,
    zip_code: "42022",
    wilaya: {
      id: 42,
      name: "Tipaza",
    },
  },
  {
    id: 1369,
    name: "Damous",
    wilaya_id: 42,
    zip_code: "42023",
    wilaya: {
      id: 42,
      name: "Tipaza",
    },
  },
  {
    id: 1370,
    name: "Messelmoun",
    wilaya_id: 42,
    zip_code: "42024",
    wilaya: {
      id: 42,
      name: "Tipaza",
    },
  },
  {
    id: 1371,
    name: "Fouka",
    wilaya_id: 42,
    zip_code: "42025",
    wilaya: {
      id: 42,
      name: "Tipaza",
    },
  },
  {
    id: 1372,
    name: "Bou Ismaïl",
    wilaya_id: 42,
    zip_code: "42026",
    wilaya: {
      id: 42,
      name: "Tipaza",
    },
  },
  {
    id: 1373,
    name: "Ahmar El Aïn",
    wilaya_id: 42,
    zip_code: "42027",
    wilaya: {
      id: 42,
      name: "Tipaza",
    },
  },
  {
    id: 1374,
    name: "Bouharoun",
    wilaya_id: 42,
    zip_code: "42030",
    wilaya: {
      id: 42,
      name: "Tipaza",
    },
  },
  {
    id: 1375,
    name: "Sidi Ghiles",
    wilaya_id: 42,
    zip_code: "42032",
    wilaya: {
      id: 42,
      name: "Tipaza",
    },
  },
  {
    id: 1376,
    name: "Merad",
    wilaya_id: 42,
    zip_code: "42033",
    wilaya: {
      id: 42,
      name: "Tipaza",
    },
  },
  {
    id: 1377,
    name: "Sidi Rached",
    wilaya_id: 42,
    zip_code: "42034",
    wilaya: {
      id: 42,
      name: "Tipaza",
    },
  },
  {
    id: 1378,
    name: "Koléa",
    wilaya_id: 42,
    zip_code: "42035",
    wilaya: {
      id: 42,
      name: "Tipaza",
    },
  },
  {
    id: 1379,
    name: "Attatba",
    wilaya_id: 42,
    zip_code: "42036",
    wilaya: {
      id: 42,
      name: "Tipaza",
    },
  },
  {
    id: 1380,
    name: "Sidi Semiane",
    wilaya_id: 42,
    zip_code: "42040",
    wilaya: {
      id: 42,
      name: "Tipaza",
    },
  },
  {
    id: 1381,
    name: "Beni Milleuk",
    wilaya_id: 42,
    zip_code: "42041",
    wilaya: {
      id: 42,
      name: "Tipaza",
    },
  },
  {
    id: 1382,
    name: "Hadjeret Ennous",
    wilaya_id: 42,
    zip_code: "42042",
    wilaya: {
      id: 42,
      name: "Tipaza",
    },
  },
  {
    id: 1383,
    name: "Mila",
    wilaya_id: 43,
    zip_code: "43001",
    wilaya: {
      id: 43,
      name: "Mila",
    },
  },
  {
    id: 1384,
    name: "Ferdjioua",
    wilaya_id: 43,
    zip_code: "43002",
    wilaya: {
      id: 43,
      name: "Mila",
    },
  },
  {
    id: 1385,
    name: "Chelghoum Laid",
    wilaya_id: 43,
    zip_code: "43003",
    wilaya: {
      id: 43,
      name: "Mila",
    },
  },
  {
    id: 1386,
    name: "Oued Athmania",
    wilaya_id: 43,
    zip_code: "43004",
    wilaya: {
      id: 43,
      name: "Mila",
    },
  },
  {
    id: 1387,
    name: "Aïn Mellouk",
    wilaya_id: 43,
    zip_code: "43005",
    wilaya: {
      id: 43,
      name: "Mila",
    },
  },
  {
    id: 1388,
    name: "Teleghma",
    wilaya_id: 43,
    zip_code: "43006",
    wilaya: {
      id: 43,
      name: "Mila",
    },
  },
  {
    id: 1389,
    name: "Oued Seguen",
    wilaya_id: 43,
    zip_code: "43007",
    wilaya: {
      id: 43,
      name: "Mila",
    },
  },
  {
    id: 1390,
    name: "Tadjenanet",
    wilaya_id: 43,
    zip_code: "43008",
    wilaya: {
      id: 43,
      name: "Mila",
    },
  },
  {
    id: 1391,
    name: "Benyahia Abderrahmane",
    wilaya_id: 43,
    zip_code: "43009",
    wilaya: {
      id: 43,
      name: "Mila",
    },
  },
  {
    id: 1392,
    name: "Oued Endja",
    wilaya_id: 43,
    zip_code: "43010",
    wilaya: {
      id: 43,
      name: "Mila",
    },
  },
  {
    id: 1393,
    name: "Ahmed Rachedi",
    wilaya_id: 43,
    zip_code: "43011",
    wilaya: {
      id: 43,
      name: "Mila",
    },
  },
  {
    id: 1394,
    name: "Ouled Khalouf",
    wilaya_id: 43,
    zip_code: "43012",
    wilaya: {
      id: 43,
      name: "Mila",
    },
  },
  {
    id: 1395,
    name: "Tiberguent",
    wilaya_id: 43,
    zip_code: "43013",
    wilaya: {
      id: 43,
      name: "Mila",
    },
  },
  {
    id: 1396,
    name: "Bouhatem",
    wilaya_id: 43,
    zip_code: "43014",
    wilaya: {
      id: 43,
      name: "Mila",
    },
  },
  {
    id: 1397,
    name: "Rouached",
    wilaya_id: 43,
    zip_code: "43015",
    wilaya: {
      id: 43,
      name: "Mila",
    },
  },
  {
    id: 1398,
    name: "Tessala Lemtaï",
    wilaya_id: 43,
    zip_code: "43016",
    wilaya: {
      id: 43,
      name: "Mila",
    },
  },
  {
    id: 1399,
    name: "Grarem Gouga",
    wilaya_id: 43,
    zip_code: "43017",
    wilaya: {
      id: 43,
      name: "Mila",
    },
  },
  {
    id: 1400,
    name: "Sidi Merouane",
    wilaya_id: 43,
    zip_code: "43018",
    wilaya: {
      id: 43,
      name: "Mila",
    },
  },
  {
    id: 1401,
    name: "Tassadane Haddada",
    wilaya_id: 43,
    zip_code: "43019",
    wilaya: {
      id: 43,
      name: "Mila",
    },
  },
  {
    id: 1402,
    name: "Derradji Bousselah",
    wilaya_id: 43,
    zip_code: "43020",
    wilaya: {
      id: 43,
      name: "Mila",
    },
  },
  {
    id: 1403,
    name: "Minar Zarza",
    wilaya_id: 43,
    zip_code: "43021",
    wilaya: {
      id: 43,
      name: "Mila",
    },
  },
  {
    id: 1404,
    name: "Amira Arrès",
    wilaya_id: 43,
    zip_code: "43022",
    wilaya: {
      id: 43,
      name: "Mila",
    },
  },
  {
    id: 1405,
    name: "Terrai Bainen",
    wilaya_id: 43,
    zip_code: "43023",
    wilaya: {
      id: 43,
      name: "Mila",
    },
  },
  {
    id: 1406,
    name: "Hamala",
    wilaya_id: 43,
    zip_code: "43024",
    wilaya: {
      id: 43,
      name: "Mila",
    },
  },
  {
    id: 1407,
    name: "Aïn Tine",
    wilaya_id: 43,
    zip_code: "43025",
    wilaya: {
      id: 43,
      name: "Mila",
    },
  },
  {
    id: 1408,
    name: "El Mechira",
    wilaya_id: 43,
    zip_code: "43026",
    wilaya: {
      id: 43,
      name: "Mila",
    },
  },
  {
    id: 1409,
    name: "Sidi Khelifa",
    wilaya_id: 43,
    zip_code: "43027",
    wilaya: {
      id: 43,
      name: "Mila",
    },
  },
  {
    id: 1410,
    name: "Zeghaia",
    wilaya_id: 43,
    zip_code: "43028",
    wilaya: {
      id: 43,
      name: "Mila",
    },
  },
  {
    id: 1411,
    name: "Elayadi Barbes",
    wilaya_id: 43,
    zip_code: "43029",
    wilaya: {
      id: 43,
      name: "Mila",
    },
  },
  {
    id: 1412,
    name: "Aïn Beida Harriche",
    wilaya_id: 43,
    zip_code: "43030",
    wilaya: {
      id: 43,
      name: "Mila",
    },
  },
  {
    id: 1413,
    name: "Yahia Beni Guecha",
    wilaya_id: 43,
    zip_code: "43031",
    wilaya: {
      id: 43,
      name: "Mila",
    },
  },
  {
    id: 1414,
    name: "Chigara",
    wilaya_id: 43,
    zip_code: "43032",
    wilaya: {
      id: 43,
      name: "Mila",
    },
  },
  {
    id: 1415,
    name: "Aïn Defla",
    wilaya_id: 44,
    zip_code: "44001",
    wilaya: {
      id: 44,
      name: "Aïn Defla",
    },
  },
  {
    id: 1416,
    name: "Miliana",
    wilaya_id: 44,
    zip_code: "44002",
    wilaya: {
      id: 44,
      name: "Aïn Defla",
    },
  },
  {
    id: 1417,
    name: "Boumedfaa",
    wilaya_id: 44,
    zip_code: "44003",
    wilaya: {
      id: 44,
      name: "Aïn Defla",
    },
  },
  {
    id: 1418,
    name: "Khemis Miliana",
    wilaya_id: 44,
    zip_code: "44004",
    wilaya: {
      id: 44,
      name: "Aïn Defla",
    },
  },
  {
    id: 1419,
    name: "Hammam Righa",
    wilaya_id: 44,
    zip_code: "44005",
    wilaya: {
      id: 44,
      name: "Aïn Defla",
    },
  },
  {
    id: 1420,
    name: "Arib",
    wilaya_id: 44,
    zip_code: "44006",
    wilaya: {
      id: 44,
      name: "Aïn Defla",
    },
  },
  {
    id: 1421,
    name: "Djelida",
    wilaya_id: 44,
    zip_code: "44007",
    wilaya: {
      id: 44,
      name: "Aïn Defla",
    },
  },
  {
    id: 1422,
    name: "El Amra",
    wilaya_id: 44,
    zip_code: "44008",
    wilaya: {
      id: 44,
      name: "Aïn Defla",
    },
  },
  {
    id: 1423,
    name: "Bourached",
    wilaya_id: 44,
    zip_code: "44009",
    wilaya: {
      id: 44,
      name: "Aïn Defla",
    },
  },
  {
    id: 1424,
    name: "El Attaf",
    wilaya_id: 44,
    zip_code: "44010",
    wilaya: {
      id: 44,
      name: "Aïn Defla",
    },
  },
  {
    id: 1425,
    name: "El Abadia",
    wilaya_id: 44,
    zip_code: "44011",
    wilaya: {
      id: 44,
      name: "Aïn Defla",
    },
  },
  {
    id: 1426,
    name: "Djendel",
    wilaya_id: 44,
    zip_code: "44012",
    wilaya: {
      id: 44,
      name: "Aïn Defla",
    },
  },
  {
    id: 1427,
    name: "Oued Chorfa",
    wilaya_id: 44,
    zip_code: "44013",
    wilaya: {
      id: 44,
      name: "Aïn Defla",
    },
  },
  {
    id: 1428,
    name: "Aïn Lechiekh",
    wilaya_id: 44,
    zip_code: "44014",
    wilaya: {
      id: 44,
      name: "Aïn Defla",
    },
  },
  {
    id: 1429,
    name: "Oued Djemaa",
    wilaya_id: 44,
    zip_code: "44015",
    wilaya: {
      id: 44,
      name: "Aïn Defla",
    },
  },
  {
    id: 1430,
    name: "Rouina",
    wilaya_id: 44,
    zip_code: "44016",
    wilaya: {
      id: 44,
      name: "Aïn Defla",
    },
  },
  {
    id: 1431,
    name: "Zeddine",
    wilaya_id: 44,
    zip_code: "44017",
    wilaya: {
      id: 44,
      name: "Aïn Defla",
    },
  },
  {
    id: 1432,
    name: "El Hassania",
    wilaya_id: 44,
    zip_code: "44018",
    wilaya: {
      id: 44,
      name: "Aïn Defla",
    },
  },
  {
    id: 1433,
    name: "Bir Ould Khelifa",
    wilaya_id: 44,
    zip_code: "44019",
    wilaya: {
      id: 44,
      name: "Aïn Defla",
    },
  },
  {
    id: 1434,
    name: "Ain Soltane",
    wilaya_id: 44,
    zip_code: "44020",
    wilaya: {
      id: 44,
      name: "Aïn Defla",
    },
  },
  {
    id: 1435,
    name: "Tarik Ibn Ziad",
    wilaya_id: 44,
    zip_code: "44021",
    wilaya: {
      id: 44,
      name: "Aïn Defla",
    },
  },
  {
    id: 1436,
    name: "Bordj Emir Khaled",
    wilaya_id: 44,
    zip_code: "44022",
    wilaya: {
      id: 44,
      name: "Aïn Defla",
    },
  },
  {
    id: 1437,
    name: "Aïn Torki",
    wilaya_id: 44,
    zip_code: "44023",
    wilaya: {
      id: 44,
      name: "Aïn Defla",
    },
  },
  {
    id: 1438,
    name: "Sidi Lakhdar",
    wilaya_id: 44,
    zip_code: "44024",
    wilaya: {
      id: 44,
      name: "Aïn Defla",
    },
  },
  {
    id: 1439,
    name: "Ben Allal",
    wilaya_id: 44,
    zip_code: "44025",
    wilaya: {
      id: 44,
      name: "Aïn Defla",
    },
  },
  {
    id: 1440,
    name: "Ain Benian",
    wilaya_id: 44,
    zip_code: "44026",
    wilaya: {
      id: 44,
      name: "Aïn Defla",
    },
  },
  {
    id: 1441,
    name: "Hoceinia",
    wilaya_id: 44,
    zip_code: "44027",
    wilaya: {
      id: 44,
      name: "Aïn Defla",
    },
  },
  {
    id: 1442,
    name: "Bathia",
    wilaya_id: 44,
    zip_code: "44028",
    wilaya: {
      id: 44,
      name: "Aïn Defla",
    },
  },
  {
    id: 1443,
    name: "Djemaa Ouled Cheikh",
    wilaya_id: 44,
    zip_code: "44029",
    wilaya: {
      id: 44,
      name: "Aïn Defla",
    },
  },
  {
    id: 1444,
    name: "Mekhatria",
    wilaya_id: 44,
    zip_code: "44030",
    wilaya: {
      id: 44,
      name: "Aïn Defla",
    },
  },
  {
    id: 1445,
    name: "Birbouche",
    wilaya_id: 44,
    zip_code: "44031",
    wilaya: {
      id: 44,
      name: "Aïn Defla",
    },
  },
  {
    id: 1446,
    name: "Tacheta Zougagha",
    wilaya_id: 44,
    zip_code: "44032",
    wilaya: {
      id: 44,
      name: "Aïn Defla",
    },
  },
  {
    id: 1447,
    name: "Aïn Bouyahia",
    wilaya_id: 44,
    zip_code: "44033",
    wilaya: {
      id: 44,
      name: "Aïn Defla",
    },
  },
  {
    id: 1448,
    name: "El Maine",
    wilaya_id: 44,
    zip_code: "44034",
    wilaya: {
      id: 44,
      name: "Aïn Defla",
    },
  },
  {
    id: 1449,
    name: "Tiberkanine",
    wilaya_id: 44,
    zip_code: "44035",
    wilaya: {
      id: 44,
      name: "Aïn Defla",
    },
  },
  {
    id: 1450,
    name: "Belaas",
    wilaya_id: 44,
    zip_code: "44036",
    wilaya: {
      id: 44,
      name: "Aïn Defla",
    },
  },
  {
    id: 1451,
    name: "Naâma",
    wilaya_id: 45,
    zip_code: "45001",
    wilaya: {
      id: 45,
      name: "Naâma",
    },
  },
  {
    id: 1452,
    name: "Mecheria",
    wilaya_id: 45,
    zip_code: "45002",
    wilaya: {
      id: 45,
      name: "Naâma",
    },
  },
  {
    id: 1453,
    name: "Aïn Sefra",
    wilaya_id: 45,
    zip_code: "45003",
    wilaya: {
      id: 45,
      name: "Naâma",
    },
  },
  {
    id: 1454,
    name: "Tiout",
    wilaya_id: 45,
    zip_code: "45004",
    wilaya: {
      id: 45,
      name: "Naâma",
    },
  },
  {
    id: 1455,
    name: "Sfissifa",
    wilaya_id: 45,
    zip_code: "45005",
    wilaya: {
      id: 45,
      name: "Naâma",
    },
  },
  {
    id: 1456,
    name: "Moghrar",
    wilaya_id: 45,
    zip_code: "45006",
    wilaya: {
      id: 45,
      name: "Naâma",
    },
  },
  {
    id: 1457,
    name: "Assela",
    wilaya_id: 45,
    zip_code: "45007",
    wilaya: {
      id: 45,
      name: "Naâma",
    },
  },
  {
    id: 1458,
    name: "Djeniene Bourezg",
    wilaya_id: 45,
    zip_code: "45008",
    wilaya: {
      id: 45,
      name: "Naâma",
    },
  },
  {
    id: 1459,
    name: "Aïn Ben Khelil",
    wilaya_id: 45,
    zip_code: "45009",
    wilaya: {
      id: 45,
      name: "Naâma",
    },
  },
  {
    id: 1460,
    name: "Makman Ben Amer",
    wilaya_id: 45,
    zip_code: "45010",
    wilaya: {
      id: 45,
      name: "Naâma",
    },
  },
  {
    id: 1461,
    name: "Kasdir",
    wilaya_id: 45,
    zip_code: "45011",
    wilaya: {
      id: 45,
      name: "Naâma",
    },
  },
  {
    id: 1462,
    name: "El Biod",
    wilaya_id: 45,
    zip_code: "45012",
    wilaya: {
      id: 45,
      name: "Naâma",
    },
  },
  {
    id: 1463,
    name: "Aïn Témouchent",
    wilaya_id: 46,
    zip_code: "46001",
    wilaya: {
      id: 46,
      name: "Aïn Témouchent",
    },
  },
  {
    id: 1464,
    name: "Chaabat El Leham",
    wilaya_id: 46,
    zip_code: "46002",
    wilaya: {
      id: 46,
      name: "Aïn Témouchent",
    },
  },
  {
    id: 1465,
    name: "Aïn Kihal",
    wilaya_id: 46,
    zip_code: "46003",
    wilaya: {
      id: 46,
      name: "Aïn Témouchent",
    },
  },
  {
    id: 1466,
    name: "Hammam Bouhadjar",
    wilaya_id: 46,
    zip_code: "46004",
    wilaya: {
      id: 46,
      name: "Aïn Témouchent",
    },
  },
  {
    id: 1467,
    name: "Bouzedjar",
    wilaya_id: 46,
    zip_code: "46005",
    wilaya: {
      id: 46,
      name: "Aïn Témouchent",
    },
  },
  {
    id: 1468,
    name: "Oued Berkeche",
    wilaya_id: 46,
    zip_code: "46006",
    wilaya: {
      id: 46,
      name: "Aïn Témouchent",
    },
  },
  {
    id: 1469,
    name: "Aghlal",
    wilaya_id: 46,
    zip_code: "46007",
    wilaya: {
      id: 46,
      name: "Aïn Témouchent",
    },
  },
  {
    id: 1470,
    name: "Terga",
    wilaya_id: 46,
    zip_code: "46008",
    wilaya: {
      id: 46,
      name: "Aïn Témouchent",
    },
  },
  {
    id: 1471,
    name: "Aïn El Arbaa",
    wilaya_id: 46,
    zip_code: "46009",
    wilaya: {
      id: 46,
      name: "Aïn Témouchent",
    },
  },
  {
    id: 1472,
    name: "Tamzoura",
    wilaya_id: 46,
    zip_code: "46010",
    wilaya: {
      id: 46,
      name: "Aïn Témouchent",
    },
  },
  {
    id: 1473,
    name: "Chentouf",
    wilaya_id: 46,
    zip_code: "46011",
    wilaya: {
      id: 46,
      name: "Aïn Témouchent",
    },
  },
  {
    id: 1474,
    name: "Sidi Ben Adda",
    wilaya_id: 46,
    zip_code: "46012",
    wilaya: {
      id: 46,
      name: "Aïn Témouchent",
    },
  },
  {
    id: 1475,
    name: "Aoubellil",
    wilaya_id: 46,
    zip_code: "46013",
    wilaya: {
      id: 46,
      name: "Aïn Témouchent",
    },
  },
  {
    id: 1476,
    name: "El Malah",
    wilaya_id: 46,
    zip_code: "46014",
    wilaya: {
      id: 46,
      name: "Aïn Témouchent",
    },
  },
  {
    id: 1477,
    name: "Sidi Boumedienne",
    wilaya_id: 46,
    zip_code: "46015",
    wilaya: {
      id: 46,
      name: "Aïn Témouchent",
    },
  },
  {
    id: 1478,
    name: "Oued Sabah",
    wilaya_id: 46,
    zip_code: "46016",
    wilaya: {
      id: 46,
      name: "Aïn Témouchent",
    },
  },
  {
    id: 1479,
    name: "Ouled Boudjemaa",
    wilaya_id: 46,
    zip_code: "46017",
    wilaya: {
      id: 46,
      name: "Aïn Témouchent",
    },
  },
  {
    id: 1480,
    name: "Aïn Tolba",
    wilaya_id: 46,
    zip_code: "46018",
    wilaya: {
      id: 46,
      name: "Aïn Témouchent",
    },
  },
  {
    id: 1481,
    name: "El Amria",
    wilaya_id: 46,
    zip_code: "46019",
    wilaya: {
      id: 46,
      name: "Aïn Témouchent",
    },
  },
  {
    id: 1482,
    name: "Hassi El Ghella",
    wilaya_id: 46,
    zip_code: "46020",
    wilaya: {
      id: 46,
      name: "Aïn Témouchent",
    },
  },
  {
    id: 1483,
    name: "Hassasna",
    wilaya_id: 46,
    zip_code: "46021",
    wilaya: {
      id: 46,
      name: "Aïn Témouchent",
    },
  },
  {
    id: 1484,
    name: "Ouled Kihal",
    wilaya_id: 46,
    zip_code: "46022",
    wilaya: {
      id: 46,
      name: "Aïn Témouchent",
    },
  },
  {
    id: 1485,
    name: "Beni Saf",
    wilaya_id: 46,
    zip_code: "46023",
    wilaya: {
      id: 46,
      name: "Aïn Témouchent",
    },
  },
  {
    id: 1486,
    name: "Sidi Safi",
    wilaya_id: 46,
    zip_code: "46024",
    wilaya: {
      id: 46,
      name: "Aïn Témouchent",
    },
  },
  {
    id: 1487,
    name: "Oulhaça El Gheraba",
    wilaya_id: 46,
    zip_code: "46025",
    wilaya: {
      id: 46,
      name: "Aïn Témouchent",
    },
  },
  {
    id: 1488,
    name: "Sidi Ouriache",
    wilaya_id: 46,
    zip_code: "46026",
    wilaya: {
      id: 46,
      name: "Aïn Témouchent",
    },
  },
  {
    id: 1489,
    name: "El Emir Abdelkader",
    wilaya_id: 46,
    zip_code: "46027",
    wilaya: {
      id: 46,
      name: "Aïn Témouchent",
    },
  },
  {
    id: 1490,
    name: "El Messaid",
    wilaya_id: 46,
    zip_code: "46028",
    wilaya: {
      id: 46,
      name: "Aïn Témouchent",
    },
  },
  {
    id: 1491,
    name: "Ghardaïa",
    wilaya_id: 47,
    zip_code: "47001",
    wilaya: {
      id: 47,
      name: "Ghardaïa",
    },
  },
  {
    id: 1492,
    name: "El Menia",
    wilaya_id: 58,
    zip_code: "47002",
    wilaya: {
      id: 58,
      name: "El Menia",
    },
  },
  {
    id: 1493,
    name: "Dhayet Bendhahoua",
    wilaya_id: 47,
    zip_code: "47003",
    wilaya: {
      id: 47,
      name: "Ghardaïa",
    },
  },
  {
    id: 1494,
    name: "Berriane",
    wilaya_id: 47,
    zip_code: "47004",
    wilaya: {
      id: 47,
      name: "Ghardaïa",
    },
  },
  {
    id: 1495,
    name: "Metlili",
    wilaya_id: 47,
    zip_code: "47005",
    wilaya: {
      id: 47,
      name: "Ghardaïa",
    },
  },
  {
    id: 1496,
    name: "El Guerrara",
    wilaya_id: 47,
    zip_code: "47006",
    wilaya: {
      id: 47,
      name: "Ghardaïa",
    },
  },
  {
    id: 1497,
    name: "El Atteuf",
    wilaya_id: 47,
    zip_code: "47007",
    wilaya: {
      id: 47,
      name: "Ghardaïa",
    },
  },
  {
    id: 1498,
    name: "Zelfana",
    wilaya_id: 47,
    zip_code: "47008",
    wilaya: {
      id: 47,
      name: "Ghardaïa",
    },
  },
  {
    id: 1499,
    name: "Sebseb",
    wilaya_id: 47,
    zip_code: "47009",
    wilaya: {
      id: 47,
      name: "Ghardaïa",
    },
  },
  {
    id: 1500,
    name: "Bounoura",
    wilaya_id: 47,
    zip_code: "47010",
    wilaya: {
      id: 47,
      name: "Ghardaïa",
    },
  },
  {
    id: 1501,
    name: "Hassi Fehal",
    wilaya_id: 58,
    zip_code: "47011",
    wilaya: {
      id: 58,
      name: "El Menia",
    },
  },
  {
    id: 1502,
    name: "Hassi Gara",
    wilaya_id: 58,
    zip_code: "47012",
    wilaya: {
      id: 58,
      name: "El Menia",
    },
  },
  {
    id: 1503,
    name: "Mansoura",
    wilaya_id: 47,
    zip_code: "47013",
    wilaya: {
      id: 47,
      name: "Ghardaïa",
    },
  },
  {
    id: 1504,
    name: "Relizane",
    wilaya_id: 48,
    zip_code: "48001",
    wilaya: {
      id: 48,
      name: "Relizane",
    },
  },
  {
    id: 1505,
    name: "Oued Rhiou",
    wilaya_id: 48,
    zip_code: "48002",
    wilaya: {
      id: 48,
      name: "Relizane",
    },
  },
  {
    id: 1506,
    name: "Belassel Bouzegza",
    wilaya_id: 48,
    zip_code: "48003",
    wilaya: {
      id: 48,
      name: "Relizane",
    },
  },
  {
    id: 1507,
    name: "Sidi Saada",
    wilaya_id: 48,
    zip_code: "48004",
    wilaya: {
      id: 48,
      name: "Relizane",
    },
  },
  {
    id: 1508,
    name: "Ouled Aiche",
    wilaya_id: 48,
    zip_code: "48005",
    wilaya: {
      id: 48,
      name: "Relizane",
    },
  },
  {
    id: 1509,
    name: "Sidi Lazreg",
    wilaya_id: 48,
    zip_code: "48006",
    wilaya: {
      id: 48,
      name: "Relizane",
    },
  },
  {
    id: 1510,
    name: "El Hamadna",
    wilaya_id: 48,
    zip_code: "48007",
    wilaya: {
      id: 48,
      name: "Relizane",
    },
  },
  {
    id: 1511,
    name: "Sidi M'Hamed Ben Ali",
    wilaya_id: 48,
    zip_code: "48008",
    wilaya: {
      id: 48,
      name: "Relizane",
    },
  },
  {
    id: 1512,
    name: "Mediouna",
    wilaya_id: 48,
    zip_code: "48009",
    wilaya: {
      id: 48,
      name: "Relizane",
    },
  },
  {
    id: 1513,
    name: "Sidi Khettab",
    wilaya_id: 48,
    zip_code: "48010",
    wilaya: {
      id: 48,
      name: "Relizane",
    },
  },
  {
    id: 1514,
    name: "Ammi Moussa",
    wilaya_id: 48,
    zip_code: "48011",
    wilaya: {
      id: 48,
      name: "Relizane",
    },
  },
  {
    id: 1515,
    name: "Zemmora",
    wilaya_id: 48,
    zip_code: "48012",
    wilaya: {
      id: 48,
      name: "Relizane",
    },
  },
  {
    id: 1516,
    name: "Beni Dergoun",
    wilaya_id: 48,
    zip_code: "48013",
    wilaya: {
      id: 48,
      name: "Relizane",
    },
  },
  {
    id: 1517,
    name: "Djidioua",
    wilaya_id: 48,
    zip_code: "48014",
    wilaya: {
      id: 48,
      name: "Relizane",
    },
  },
  {
    id: 1518,
    name: "El Guettar",
    wilaya_id: 48,
    zip_code: "48015",
    wilaya: {
      id: 48,
      name: "Relizane",
    },
  },
  {
    id: 1519,
    name: "Hamri",
    wilaya_id: 48,
    zip_code: "48016",
    wilaya: {
      id: 48,
      name: "Relizane",
    },
  },
  {
    id: 1520,
    name: "El Matmar",
    wilaya_id: 48,
    zip_code: "48017",
    wilaya: {
      id: 48,
      name: "Relizane",
    },
  },
  {
    id: 1521,
    name: "Sidi M'Hamed Benaouda",
    wilaya_id: 48,
    zip_code: "48018",
    wilaya: {
      id: 48,
      name: "Relizane",
    },
  },
  {
    id: 1522,
    name: "Aïn Tarek",
    wilaya_id: 48,
    zip_code: "48019",
    wilaya: {
      id: 48,
      name: "Relizane",
    },
  },
  {
    id: 1523,
    name: "Oued Essalem",
    wilaya_id: 48,
    zip_code: "48020",
    wilaya: {
      id: 48,
      name: "Relizane",
    },
  },
  {
    id: 1524,
    name: "Ouarizane",
    wilaya_id: 48,
    zip_code: "48021",
    wilaya: {
      id: 48,
      name: "Relizane",
    },
  },
  {
    id: 1525,
    name: "Mazouna",
    wilaya_id: 48,
    zip_code: "48022",
    wilaya: {
      id: 48,
      name: "Relizane",
    },
  },
  {
    id: 1526,
    name: "Kalaa",
    wilaya_id: 48,
    zip_code: "48023",
    wilaya: {
      id: 48,
      name: "Relizane",
    },
  },
  {
    id: 1527,
    name: "Aïn Rahma",
    wilaya_id: 48,
    zip_code: "48024",
    wilaya: {
      id: 48,
      name: "Relizane",
    },
  },
  {
    id: 1528,
    name: "Yellel",
    wilaya_id: 48,
    zip_code: "48025",
    wilaya: {
      id: 48,
      name: "Relizane",
    },
  },
  {
    id: 1529,
    name: "Oued El Djemaa",
    wilaya_id: 48,
    zip_code: "48026",
    wilaya: {
      id: 48,
      name: "Relizane",
    },
  },
  {
    id: 1530,
    name: "Ramka",
    wilaya_id: 48,
    zip_code: "48027",
    wilaya: {
      id: 48,
      name: "Relizane",
    },
  },
  {
    id: 1531,
    name: "Mendes",
    wilaya_id: 48,
    zip_code: "48028",
    wilaya: {
      id: 48,
      name: "Relizane",
    },
  },
  {
    id: 1532,
    name: "Lahlef",
    wilaya_id: 48,
    zip_code: "48029",
    wilaya: {
      id: 48,
      name: "Relizane",
    },
  },
  {
    id: 1533,
    name: "Beni Zentis",
    wilaya_id: 48,
    zip_code: "48030",
    wilaya: {
      id: 48,
      name: "Relizane",
    },
  },
  {
    id: 1534,
    name: "Souk El Had",
    wilaya_id: 48,
    zip_code: "48031",
    wilaya: {
      id: 48,
      name: "Relizane",
    },
  },
  {
    id: 1535,
    name: "Dar Ben Abdellah",
    wilaya_id: 48,
    zip_code: "48032",
    wilaya: {
      id: 48,
      name: "Relizane",
    },
  },
  {
    id: 1536,
    name: "El Hassi",
    wilaya_id: 48,
    zip_code: "48033",
    wilaya: {
      id: 48,
      name: "Relizane",
    },
  },
  {
    id: 1537,
    name: "Had Echkalla",
    wilaya_id: 48,
    zip_code: "48034",
    wilaya: {
      id: 48,
      name: "Relizane",
    },
  },
  {
    id: 1538,
    name: "Bendaoud",
    wilaya_id: 48,
    zip_code: "48035",
    wilaya: {
      id: 48,
      name: "Relizane",
    },
  },
  {
    id: 1539,
    name: "El Ouldja",
    wilaya_id: 48,
    zip_code: "48036",
    wilaya: {
      id: 48,
      name: "Relizane",
    },
  },
  {
    id: 1540,
    name: "Merdja Sidi Abed",
    wilaya_id: 48,
    zip_code: "48037",
    wilaya: {
      id: 48,
      name: "Relizane",
    },
  },
  {
    id: 1541,
    name: "Ouled Sidi Mihoub",
    wilaya_id: 48,
    zip_code: "48038",
    wilaya: {
      id: 48,
      name: "Relizane",
    },
  },
];
